import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAlignLeft,
  faAlignJustify,
  faUser,
  faTh,
  faPlus,
  faGrinAlt,
  faSignOutAlt,
  faCloudDownloadAlt,
  faFile,
  faDatabase,
  faCog,
  faUserEdit,
  faMinus,
  faQuestion,
  faStar,
  faHeadset,
  faChevronLeft,
  faChevronRight,
  faKey,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/js/dist/collapse";
import _, { stubTrue } from "lodash";
import DashBoardV1 from "./../User/Dashboard/dashboardV1.1";
import { Switch, Route, Redirect } from "react-router-dom";
import { REPORTS_ENABLED } from "../PlantAssistant/features";
import CocoLogo from "../PlantAssistant/CocoLogo";
import LeafNetLogo from "../theme/LeafNetLogo";
import UiModeSwitch from "../theme/UiModeSwitch";
import { MachineStateChart, hasRelayConfigured } from "./../utill/machineStateChart";
import axios from "../httpServices/httpService";
import api from "../config.json";
import auth from "../httpServices/authService";
import ChangePassword from "./ChangePasswordForm";
import RouteErrorBoundary from "./RouteErrorBoundary";
import { generateExcelFile, generateExcelTextFile } from "../utill/download";
import masterCache from "../utill/masterDataCache";
import swal from "sweetalert";
import { alertReasonEndsRunningJob, notifyJobResults, notifyMultipleJobResults } from "../utill/endJobAlert";
import Loading from "../utill/LoadingComponent";
import ToolCodeMaster from "../User/Setting/ToolCode/ToolCodeMaster";
import ToolCodeMasterTable from "../User/Setting/ToolCode/ToolCodeMasterTable";
import ActivityDashboard from "../User/Dashboard/activityDashboard";
import DetailedProduction1 from "../Reporting/DetailedProduction1";
import { ToastContainer, toast } from "react-toastify";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import { Switch as Swtch } from "antd";
import { Modal, Button, ThemeProvider } from "react-bootstrap";
import MultiSelect from "../Common/multiselect";
import dateTime from "../utill/dateTime.js";
import validation from "../utill/validation";
import joi from "joi";
import http from "../httpServices/httpService";
import moment from "moment";
import { InputNumber, Space, Tabs } from "antd";
import DowntimeEntryInterval from "./LiveCounDownComponent.jsx";
import jwtDecode from "jwt-decode";
import { Row, Col, Typography, Select } from 'antd';
import DashBoardDowntimeAndIncident from "../User/Dashboard/DashBoardDownTimeAndIncident";
import DashBoardCustom from "../User/Dashboard/DashBoardCustom";
import ShiftTypeTabs from "../User/Setting/ShiftSetting/ShiftTypeTabs.jsx";
import { visibleShiftTypes } from "../User/Setting/ShiftSetting/shiftTypes";
const HistoryMachineState = React.lazy(() => import("./../Reporting/HistoryMachineState"));
const UserGroup = React.lazy(() => import("../User/Setting/UserGroup/UserGroup"));
const UserGroupTable = React.lazy(() => import("../User/Setting/UserGroup/UserGroupTable"));
const EquipmentGroupTable = React.lazy(() => import("../User/Setting/EquipmentGroup/EquipmentGroupTable"));
const EquipmentGroup = React.lazy(() => import("../User/Setting/EquipmentGroup/EquipmentGroup"));
const EquipmentTypeTable = React.lazy(() => import("../User/Setting/EquipmentType/EquipmentTypeTable"));
const EquipmentType = React.lazy(() => import("../User/Setting/EquipmentType/EquipmentType"));
const EquipmentLocationTable = React.lazy(() => import("../User/Setting/EquipmentLocation/EquipmentLocationTable"));
const EquipmentLocation = React.lazy(() => import("../User/Setting/EquipmentLocation/EquipmentLocation"));
const EquipmentModelTable = React.lazy(() => import("../User/Setting/EquipmentModel/EquipmentModelTable"));
const EquipmentModel = React.lazy(() => import("../User/Setting/EquipmentModel/EquipmentModel"));
const Equipment = React.lazy(() => import("../User/Setting/Equipment/Equipment"));
const EquipmentTable = React.lazy(() => import("../User/Setting/Equipment/EquipmentTable"));
const DowntimeSummary = React.lazy(() => import("../Reporting/DowntimeSummary"));
const ConsumablesGroup = React.lazy(() => import("../User/Setting/ConsumablesGroup/ConsumablesGroup"));
const ConsumablesGroupTable = React.lazy(() => import("../User/Setting/ConsumablesGroup/ConsumablesTable"));
const ConsumablesMaster = React.lazy(() => import("../User/Setting/ConsumablesMaster/ConsumablesMaster"));
const ConsumablesMasterTable = React.lazy(() => import("../User/Setting/ConsumablesMaster/ConsumablesMasterTable"));
const OperatorMaster = React.lazy(() => import("../User/Setting/OperatorMaster/OperatorMaster"));
const OperatorMasterTable = React.lazy(() => import("../User/Setting/OperatorMaster/OperatorMasterTable"));
const DownTimeReasonGroup = React.lazy(() => import("../User/Setting/DownTimeGroup/DownTimeReasonGroup"));
const DownTimeReasonGroupTable = React.lazy(() => import("../User/Setting/DownTimeGroup/DownTimeReasonGroupTable"));
const DownTime = React.lazy(() => import("../User/Setting/DownTimeMaster/DownTime"));
const DownTimeTable = React.lazy(() => import("../User/Setting/DownTimeMaster/DownTimeTable"));
const UserRights = React.lazy(() => import("../User/Setting/UserRights/UserRight"));
const UserRightTable = React.lazy(() => import("../User/Setting/UserRights/UserRightTable"));
const QualityReasonGroup = React.lazy(() => import("../User/Setting/QualityReasonGroup/QualityReasonGroup"));
const QualityReasonGroupTable = React.lazy(() => import("../User/Setting/QualityReasonGroup/QualityReasonGroupTable"));
const QualityReasonTable = React.lazy(() => import("../User/Setting/QualityReasonMaster/QualityReasonTable"));
const QualityReason = React.lazy(() => import("../User/Setting/QualityReasonMaster/QualityReason"));
const ToolMaster = React.lazy(() => import("../User/Setting/ToolMaster/ToolMaster"));
const ToolMasterTable = React.lazy(() => import("../User/Setting/ToolMaster/ToolMasterTable"));
const RawMaterialMaster = React.lazy(() => import("../User/Setting/RawMaterialMaster/RawMaterialMaster"));
const RawMaterialMasterTable = React.lazy(() => import("../User/Setting/RawMaterialMaster/RawMaterialMasterTable"));
const ComponentTable = React.lazy(() => import("../User/Setting/ComponentMaster/ComponentTable"));
const EmployeeReport = React.lazy(() => import("../Reporting/Premier/EmployeeReport.jsx"));
const ShiftSetting = React.lazy(() => import("../User/Setting/ShiftSetting/ShiftSetting"));
const ShiftSettingTable = React.lazy(() => import("../User/Setting/ShiftSetting/ShiftSettingTable"));
const Downtime = React.lazy(() => import("../User/DataEntry/DownTime/Downtime"));
const DowntimeView = React.lazy(() => import("../User/DataEntry/DownTime/DowntimeView"));
const ERP = React.lazy(() => import("../User/DataEntry/ERP/ERP.jsx"));
const ErpLogs = React.lazy(() => import("../Reporting/ErpLogs/ErpLogs.jsx"));
const ComponentDataEntry = React.lazy(() => import("../User/DataEntry/Component/component"));
const ComponentView = React.lazy(() => import("../User/DataEntry/Component/componentView"));
const QualityView = React.lazy(() => import("../User/DataEntry/Quality/QualityView"));
const Quality = React.lazy(() => import("../User/DataEntry/Quality/Quality"));
const Consumable = React.lazy(() => import("../User/DataEntry/Consumables/Consumable"));
const ConsumableView = React.lazy(() => import("../User/DataEntry/Consumables/ConsumableView"));
const DashBoard = React.lazy(() => import("../User/Dashboard/dashboard"));
const ProductionReport = React.lazy(() => import("./../Reporting/ProductionReport"));
const ProductionSummaryReport = React.lazy(() => import("../Reporting/ProductionSummaryReport.jsx"));
const Machine_OEE = React.lazy(() => import("../Reporting/Machine_OEE"));
const JobRunReport = React.lazy(() => import("../Reporting/JobRunReport"));
const Availability = React.lazy(() => import("../Reporting/Availability"));
const JobPerformance = React.lazy(() => import("./../Reporting/JobPerformanceReport"));
const DowntimeMachineTrend = React.lazy(() => import("./../Reporting/DowntimeMachineTrend"));
const OperatorPerformance = React.lazy(() => import("../Reporting/OperatorPerformance"));
const OperatorPerfDetailed = React.lazy(() => import("../Reporting/OperatorPerfDetailed"));
const DowntimeAnalysisCumulative = React.lazy(() => import("../Reporting/DowntimeAnalysisCumulative"));
const DowntimeAnalysisMachine = React.lazy(() => import("../Reporting/DowntimeAnalysisMachine"));
const QualityReport = React.lazy(() => import("../Reporting/QualityReport"));
const ComponentTest = React.lazy(() => import("./../User/Setting/ComponentMaster/ComponentTest"));
const User = React.lazy(() => import("./../User/Setting/User/User"));
const UserTable = React.lazy(() => import("./../User/Setting/User/UserTable"));
const OperationMaster = React.lazy(() => import("./../User/Setting/Operation/OperationMaster"));
const OperationTable = React.lazy(() => import("./../User/Setting/Operation/OperationTable"));
const FirstPartReport = React.lazy(() => import("./../Reporting/FirstPartReport"));
const Performance_Overview = React.lazy(() => import("./../Reporting/Performance_Overview"));
const PerformanceDetailed = React.lazy(() => import("./../Reporting/Performance_Detailed"));
const MachineActvity = React.lazy(() => import("../Reporting/MachineActivity"));
const Job_Operator_Performance = React.lazy(() => import("./../Reporting/Job_Operator_Performance"));
const AvailabilityTrend = React.lazy(() => import("./../Reporting/AvailabilityTrend"));
const JobOEE = React.lazy(() => import("./../Reporting/JobOee"));
const DowntimePareto = React.lazy(() => import("./../Reporting/DowntimePareto"));
const QualityPareto = React.lazy(() => import("./../Reporting/QualityPareto"));
const BatchReport = React.lazy(() => import("./../Reporting/BatchReport"));
const OCXView = React.lazy(() => import("./../User/Dashboard/OCXView"));
const MachineStateEventLog = React.lazy(() => import("./../Reporting/MachineStateEventLog"));
const ProcessParameter = React.lazy(() => import("./../Reporting/ProcessParameter"));
const DiscardedBreakdownReport = React.lazy(() => import("./../Reporting/DiscardedBreakdownReport"));
const CustomerMaster = React.lazy(() => import("./../User/Setting/CustomerMaster/customer"));
const CustomerTable = React.lazy(() => import("./../User/Setting/CustomerMaster/customerTable"));
const AndonDashboard = React.lazy(() => import("./../User/Dashboard/andonDashboard"));
const AvailabilityReportHourly = React.lazy(() => import("../Reporting/AvailabilityHourly"));
const NotificationClickDowntimeView = React.lazy(() => import("../User/DataEntry/DownTime/NotificationClickDowntimeView"));
const CycleRunAndRuntime = React.lazy(() => import("../Reporting/CycleRunAndRuntime"));
const DetailedProduction = React.lazy(() => import("../Reporting/DetailedProduction"));
const BenchMarkTable = React.lazy(() => import("../Reporting/BenchMarkTable"));
const ToolRun = React.lazy(() => import("../Reporting/ToolRun"));
const HourlyActivityDashboard = React.lazy(() => import("../User/Dashboard/hourlyActivityDashboard"));
const ReportSetting = React.lazy(() => import("../User/Setting/Report/ReportSetting"));
const CycleDuration = React.lazy(() => import("../Reporting/CycleDuration"));
const JobEntryTabular = React.lazy(() => import("../User/DataEntry/Component/JobEntryTabular"));
// import { Modal, Button } from 'react-bootstrap';
const RejectionStatge = React.lazy(() => import("../User/Setting/RejectionStage/RejectionStage"));
const RejectionStageTable = React.lazy(() => import("../User/Setting/RejectionStage/RejectionStageTable"));
const PartsPerCycleReason = React.lazy(() => import("../User/Setting/PartsPerCycleReason/PartsPerCycleReason"));
const PartsPerCycleReasonTable = React.lazy(() => import("../User/Setting/PartsPerCycleReason/PartsPerCycleReasonTable"));
const DowntimeDetailedAnalysis = React.lazy(() => import("../Reporting/DownTimeDetailedAnalysis"));
const QualityAnalysis = React.lazy(() => import("../Reporting/QualityAnalysis"));
const QualityRejectionStageReport = React.lazy(() => import("../Reporting/QualityRejectionStageReport"));
const UtilizationReport = React.lazy(() => import("../Reporting/UtilizationReport"));
const Dailyproductionreport = React.lazy(() => import("../Reporting/DailyProductionReport"));
const TalbrosProductionReport = React.lazy(() => import("../Reporting/Talbrosproductionreport"));
const EquipmentWiseProductionData = React.lazy(() => import("../Reporting/EquipmentWiseProductionData"));
const McWiseData = React.lazy(() => import("../Reporting/McWiseData"));
const TalbrosProductionSummary = React.lazy(() => import("../Reporting/TalbrosproductionSummary"));
const CustomForm1 = React.lazy(() => import("../User/DataEntry/Custom/CustomForm1"));
const CustomEquipmentGroup = React.lazy(() => import("../User/Setting/customEquipmentGroup/customEquipmentGroup"));
const CustomEquipmentGroupTable = React.lazy(() => import("../User/Setting/customEquipmentGroup/customEquipmentTable.jsx"));
const LiveDashBoards = React.lazy(() => import("../Reporting/LiveDashBoards"));
const SummaryReportWithoutWeighted = React.lazy(() => import("../Reporting/SummarReportWithoutweighted.jsx"));
const ProductionSummary = React.lazy(() => import("../Reporting/ProductionSummary"));
const AvilabilitySummary1 = React.lazy(() => import("../Reporting/AvailabilitySummary1"));
const QualitySummary1 = React.lazy(() => import("../Reporting/QualitySummary1"));
const HistogramReport = React.lazy(() => import("../Reporting/HistogramReport"));
const ComponentSummaryReport = React.lazy(() => import("../Reporting/Componentummary"));
const LiveDashBoards2 = React.lazy(() => import("../Reporting/LiveDashBoards2"));
const IncidentsReport1 = React.lazy(() => import("../Reporting/IncidentsReport1"));
const ProductionReportHourly = React.lazy(() => import("../Reporting/ProductionReportHourly"));
const AewProductionReport = React.lazy(() => import("../Reporting/Aew_Protech/ProductionReport.jsx"));
const FourMReport = React.lazy(() => import("../Reporting/FourMReport.jsx"));

const ProductionReportHourly2 = React.lazy(() => import("../Reporting/ProductionReportHourly2"));
const DetailedProduction2 = React.lazy(() => import("../Reporting/DetailedProduction2"));
const EquipmentHourlyRate = React.lazy(() => import("../User/Setting/EquipmentHourlyRate/EquipmentHourlyRate"));
const EquipmentHourlyRateTable = React.lazy(() => import("../User/Setting/EquipmentHourlyRate/EquipmentHourlyRateTbale"));
const CavityLossReasonReport = React.lazy(() => import("../Reporting/CavityLossReasons"));
const DailyProductionSummary = React.lazy(() => import("../Reporting/DailyProductionSummary"));
const FAQPage = React.lazy(() => import("./FAQPage"));

const DaySummaryOneReport = React.lazy(() => import("../Reporting/DaySummaryOneReport"));

const AvailabilityRejectionOEEReport = React.lazy(() => import("../Reporting/AvailabilityRejectionOeeReport"));
const OverallMachineOEE = React.lazy(() => import("../talbros_report/OverallMachineOEE"));
const OverallMonthOEE = React.lazy(() => import("../talbros_report/OverallMonthOEE"));
const ProductionReportHourly3 = React.lazy(() => import("../Reporting/ProductionReportHourly3"));
const ToolProductionReport = React.lazy(() => import("../Reporting/ToolProductionReport"));
const CycleRunReportDynamic = React.lazy(() => import("../Reporting/CycleRunReportDynamic"));
const JobCycleTime_DowntimeChart = React.lazy(() => import("../Reporting/Job_Cycletime&DowntimeChartReport"));
const PressWellReport = React.lazy(() => import("../Reporting/PressWellReport"));
const HourlyCountdashBoard = React.lazy(() => import("../User/Dashboard/HourlyCountDashboard"));
const VG_PresShopReport = React.lazy(() => import("../Reporting/VG_PressShopReport"));
const EquipmentGroupHourlyCount = React.lazy(() => import("../User/Dashboard/EquipmentGroupHourlyCount"));
const OperatorPerformanceBoard = React.lazy(() => import("../User/Dashboard/OperatorPerfBoard"));
const PressShopMonitoring = React.lazy(() => import("../User/Dashboard/PressShopMonioring.jsx"));
const DayWiseOEEReport = React.lazy(() => import("../Reporting/DayWiseOEEReport.jsx"));
const DayWiseQualityReport = React.lazy(() => import("../Reporting/DayWiseQualityReportReasoneWise.jsx"));
const LiveOperatorWiseProduction = React.lazy(() => import("../Reporting/LiveOperatorWiseProduction.jsx"));
const OperatorPerformanceBoardHistory = React.lazy(() => import("../Reporting/OperatorPerformanceBoard"));
const ToolxMachine = React.lazy(() => import("../User/Setting/ToolxMachine/ToolxMachine.jsx"));
const ComponentWise = React.lazy(() => import("../Reporting/Report-viskashForging/ComponentWise.jsx"));
const CycleTimeReport = React.lazy(() => import("../Reporting/Report-viskashForging/CycleTimeReport.jsx"));
const ComponentWise1 = React.lazy(() => import("../Reporting/Report-viskashForging/ComponentWise1.jsx"));
const Machine_Wise_OEE = React.lazy(() => import("../Reporting/Report-viskashForging/Machine_Wise_OEE.jsx"));
const MachineGroupMatrix = React.lazy(() => import("../User/Setting/MachineGroupMatrix/ToolxMachine/MachineGroupMatrix.jsx"));
const TargetMultiplier = React.lazy(() => import("../User/Setting/TargetMultiplier/TargetMultiplier.jsx"));
const RelayTemplateModule = React.lazy(() => import("../User/Setting/RelayTemplate/RelayTemplateModule"));
const ProcessParameterConfigModule = React.lazy(() => import("../User/Setting/ProcessParameterConfig/ProcessParameterConfigModule"));
const ConditionMasterModule = React.lazy(() => import("../User/Setting/ConditionMaster/ConditionMasterModule"));
const ToolChangeLog = React.lazy(() => import("../Reporting/ToolChangeLog.jsx"));
const ShiftSettingMaster = React.lazy(() => import("../User/Setting/ShiftSetting/ShiftSettingMaster.jsx"));
const ShiftManagement = React.lazy(() => import("../User/Setting/ShiftSetting/ShiftManagement.jsx"));
const ProductionReport_JRG = React.lazy(() => import("../Reporting/JRG_Automotive/ProductionReport_JRG.jsx"));
const JRG_PlantUtilizationReport = React.lazy(() => import("../Reporting/JRG_Automotive/JrgUtilizationReport.jsx"));
const PlantUtilizationReport = React.lazy(() => import("../Reporting/plantUtilizationReport.jsx"));
const EmployeeDataEntry = React.lazy(() => import("../User/DataEntry/Employee/Employee"));
const ProjectPlanning = React.lazy(() => import("../User/DataEntry/ProjectPlanning/ProjectPlanning"));
const ProjectPlanningView = React.lazy(() => import("../User/DataEntry/ProjectPlanning/ProjectPlanningView"));
const ProjectDataEntry = React.lazy(() => import("../User/DataEntry/Project/ProjectDataEntry"));
const ProjectDataEntryView = React.lazy(() => import("../User/DataEntry/Project/ProjectDataEntryView"));
const ProjectDetails = React.lazy(() => import("../Reporting/ProjectDetails"));
const ProjectBudgetVsPlan = React.lazy(() => import("../Reporting/ProjectBudgetVsPlan.jsx"));
const ProjectOverview = React.lazy(() => import("../Reporting/ProjectOverview.jsx"));
const MTTR_MTBF = React.lazy(() => import("../Reporting/MTTR_MTBF.js"));
const ActionTakenMaster = React.lazy(() => import("../User/Setting/DownTimeMaster/ActionTaken.jsx"));
const QualityRejectionReport = React.lazy(() => import("../Reporting/ParamJoyotiManesar/QualityRejectionReport.jsx"));
const OperatorEfficiencyReport = React.lazy(() => import("../Reporting/ParamJoyotiManesar/OperatorRejectionReport.jsx"));
const PremierOperatorEfficiencyReport = React.lazy(() => import("../Reporting/Premier/OperatorEfficiencyReport.jsx"));
const QualityReport_JRG = React.lazy(() => import("../Reporting/JRG_Automotive/QualityReport_JRG.jsx"));
const WastageReport = React.lazy(() => import("../Reporting/420namkeen/WastageReport.jsx"));
const UserRightsManager = React.lazy(() => import("../User/Setting/UserRightSManager/UserRightsManager.jsx"));
const PlanVsActual = React.lazy(() => import("../User/Dashboard/PlanVsActual.jsx"));
const PlantPlanVsActual = React.lazy(() => import("../User/Dashboard/PlantPlanVsActual.jsx"));
const PlanVsActualReport = React.lazy(() => import("../Reporting/PlanVsActual.jsx"));
const PlantPlanVsActualReport = React.lazy(() => import("../Reporting/PlantPlanVsActual.jsx"));
const BenchMarkHistory = React.lazy(() => import("../Reporting/BenchMarkHistoryReport.jsx"));
const Cost_To_Poor_Quality = React.lazy(() => import("../Reporting/Cost_To_Poor_Quality.jsx"));
const Component_Machine_Matrix = React.lazy(() => import("../User/Setting/Component_Machine_matrix/Component_X_Machie.jsx"));
const ProductionReport420 = React.lazy(() => import("../Reporting/420namkeen/Productionreport.jsx"));
const CompanySetting = React.lazy(() => import("../User/Setting/Companysettings/CompanySetting.jsx"));
const EquipmentWiseProductionData1 = React.lazy(() => import("../Reporting/EquipmentWiseProductiondata2.jsx"));
const EmployeeRole = React.lazy(() => import("../User/Setting/EmployeeMaster/EmployeeRole.jsx"));
const EmployeeMaster = React.lazy(() => import("../User/Setting/EmployeeMaster/EmployeeMaster.jsx"));
const CostingReport = React.lazy(() => import("../Reporting/CostingReport.jsx"));
const PerformanceLossReport = React.lazy(() => import("../Reporting/PerformanceLossReport.jsx"));
const MaterialConsumptionReport = React.lazy(() => import("../Reporting/MaterialConsumption.jsx"));
const MaterialRequirementReport = React.lazy(() => import("../Reporting/MaterialRequirement.jsx"));
const DashboardNagata = React.lazy(() => import("../Reporting/Nagata/NagataDashboard.jsx"));
const DashboardNagataConcept2 = React.lazy(() => import("../Reporting/Nagata/NagataConcept2.jsx"));
const Dashboard2 = React.lazy(() => import("../Reporting/Dashboard2.jsx"));
const EnergyConsumption = React.lazy(() => import("../Reporting/EnergyConsumptionReport.jsx"));
const CustomerSchedule = React.lazy(() => import("../User/Setting/CustomerScheduleMaster/CustomerSchedule.jsx"));
const CustomerPlanDashboard = React.lazy(() => import("../User/Dashboard/CustomerPlanDashboard.jsx"));
const CustomerScheduleHistoryReport = React.lazy(() => import("../Reporting/CustomerScheduleHistoryReport.jsx"));
const LossReport = React.lazy(() => import("../Reporting/LossReport.jsx"));
const CustomHourlyReport = React.lazy(() => import("../Reporting/CustomHourlyReport.jsx"));
const HPRReport = React.lazy(() => import("../Reporting/HPRReport.jsx"));
const Premier_Machine_OEE = React.lazy(() => import("../Reporting/Premier/Premier_OEE_Report.jsx"));
const ToolChangeReport = React.lazy(() => import("../Reporting/GRG_Automotive/ToolChangeReport.jsx"));
const NagataMISReport = React.lazy(() => import("../Reporting/Nagata/NagataMISReport.jsx"));
const NagataPressMISReport = React.lazy(() => import("../Reporting/Nagata/NagataPressMISReport.jsx"));
const MisReport = React.lazy(() => import("../Reporting/MisReport.jsx"));
const DashBoardDowntimeAndIncident2 = React.lazy(() => import("../User/Dashboard/DashboardDowntimeicident2"));
const CarouselComponent = React.lazy(() => import("../User/Dashboard/CrouselToggle"));
const WeldingFixtureDashbaord = React.lazy(() => import("../User/Dashboard/WeldingFixtureDashboard"));
const VG_Dashboard = React.lazy(() => import("../User/Dashboard/VGDashboard"));
const AVGSpmDashboard = React.lazy(() => import("../User/Dashboard/SPM_DashboardData"));
const DailySPMReport = React.lazy(() => import("../Reporting/DailySpmReport"));
const PlantTrendsDashboard = React.lazy(() => import("../Dashboards/PlantTrendsDashboard.jsx"));
const PlantLiveStatus = React.lazy(() => import("../Dashboards/PlantLiveStatus/PlantLiveStatus.jsx"));
const EquipmentGroupLive = React.lazy(() => import("../Dashboards/EquipmentGroupLive/EquipmentGroupLive.jsx"));
const LossAnalytics = React.lazy(() => import("../Dashboards/LossAnalytics/LossAnalytics.jsx"));
const ProcessParameterDashboard = React.lazy(() => import("../Dashboards/ProcessParameterDashboard/ProcessParameterDashboard.jsx"));
const AnalyticsSuite = React.lazy(() => import("../Analytics/AnalyticsSuite.jsx"));
const DashboardCarousel = React.lazy(() => import("../Dashboards/DashboardCarousel.jsx"));
const CustomShiftWiseProduction = React.lazy(() => import("../Reporting/VeeGee/CustomShiftWiseProduction.jsx"));
const GroupDashBoardCustom = React.lazy(() => import("../User/Dashboard/GroupDashboardCustom.jsx"));
const ProductionLossReport = React.lazy(() => import("../Reporting/ProductionLossReport.jsx"));
const SupportPage = React.lazy(() => import("../User/Support/SupportPage.jsx"));
const PlantAssistantWidget = React.lazy(() => import("../PlantAssistant/PlantAssistantWidget.jsx"));
const PlantAssistantPage = React.lazy(() => import("../PlantAssistant/PlantAssistantPage.jsx"));
const LeafnetReportsPage = React.lazy(() => import("../PlantAssistant/reports/ReportsPage.jsx"));
const { Option } = Select;
const { Text } = Typography;
const { TabPane } = Tabs;

// Each dashboard route gets its OWN localStorage key so the Equipment Group
// filter is independent per dashboard (not shared between dashboards).
const LIVE_REPORT_ROUTES = [
  "/setting/shiftManagement",
  "/",
  "/dashboard/livePerformace",
  "/dashboard/operator_per_board",
  "/dashboard/EquipmentGroupHourlyCount",
  "/dashboard/HourlyCountdashBoard",
  "/dashboard/cxoview",
  "/dashboard/cardview",
  "/dashboard/andon",
  "/dashboard/activity",
  "/dashboard/plant_plan_vs_actual",
  "/dashboard/plan_vs_actual",
  "/dashboard2",
  "/dashboard/customer_plan_dashboard",
  "/dashboard/toggle_custom",
  "/dashboard/vg_dashboard",
  "/dashboard/dashBoard_dt_&_incident",
  "/dashboard/customs",
  "/dashboard/AVGSpmDashboard",
  "/dashboard/welding_fixture_hourly",
  "/dashboard/plant-trends",
  "/dashboard/groups",
  "/dashboard/nagata/concept2",
];

const DASHBOARD_EQUIP_GROUP_KEYS = {
  "/dashboard/customs": "equipGroupFilter_customs",
  "/dashboard/dashBoard_dt_&_incident": "equipGroupFilter_dtIncident",
  "/dashboard/toggle_custom": "equipGroupFilter_toggleCustom",
  "/dashboard/vg_dashboard": "equipGroupFilter_vgDashboard",
};

const readDashboardEquipGroups = (path = window.location.pathname) => {
  try {
    const key = DASHBOARD_EQUIP_GROUP_KEYS[path];
    if (!key) return [];
    const raw = localStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

// Aggregated / By Equipment Type view of the upper dashboard cards. Only the routes
// below render DashBoardCustom, which is the one dashboard that offers it. The choice
// is stored per dashboard, reusing that dashboard's Equipment Group key as the suffix
// so the two filters stay paired.
const UPPER_VIEW_MODE_KEY_PREFIX = "dashboardUpperViewMode_";
const UPPER_VIEW_AGGREGATED = "aggregated";
const UPPER_VIEW_BY_TYPE = "byType";
const UPPER_VIEW_MODE_ROUTES = ["/dashboard/customs", "/dashboard/toggle_custom"];

const upperViewModeKey = (path = window.location.pathname) => {
  const groupKey = DASHBOARD_EQUIP_GROUP_KEYS[path];
  if (!groupKey || UPPER_VIEW_MODE_ROUTES.indexOf(path) === -1) return null;
  return UPPER_VIEW_MODE_KEY_PREFIX + groupKey;
};

const readDashboardUpperViewMode = (path = window.location.pathname) => {
  try {
    const key = upperViewModeKey(path);
    if (!key) return UPPER_VIEW_AGGREGATED;
    return localStorage.getItem(key) === UPPER_VIEW_BY_TYPE
      ? UPPER_VIEW_BY_TYPE
      : UPPER_VIEW_AGGREGATED;
  } catch (e) {
    return UPPER_VIEW_AGGREGATED;
  }
};

class NavBarUser extends Component {
  state = {
    JobData: null,
    userRights: null,
    // Pending flag for the "Default Landing Page" (LiveReportRights[].IsDefault)
    // redirect, resolved once the user rights arrive.
    // It is only armed when the app is *opened* on "/" (login, reload, fresh tab).
    // NavBarUser stays mounted for the whole session, so this never re-arms on
    // in-app navigation - which matters because the Machine State Dashboard is
    // itself the "/" route and would otherwise bounce back to the default.
    defaultDashboardPending: window.location.pathname === "/",
    navSelected: "",
    Plant: localStorage.getItem('plant') || (jwtDecode(auth.getJwt()) && jwtDecode(auth.getJwt()).Plants && jwtDecode(auth.getJwt()).Plants[0].company),

    fromDateLimit: null,
    toggle: isMobile ? false : true,
    userGroupList: [{ userGroup: "UG1", userGroup: "UG2" }],
    equipmentGroupList: [],
    equipmentTypeList: [],
    equipmentList: [],
    consumableGroupList: [],
    consumableMasterList: [],
    operatorMasterList: [],
    downTimeReasonGroupList: [],
    downTimeReasonList: [],
    userRightsList: [],
    userList: [],
    qualityReasonGroupList: [],
    qualityReasonList: [],
    toolMasterList: [],
    rawMaterialList: [],
    componentList: [],
    shiftSettingList: [],
    operationList: [],
    reports: [],
    reportMasterData: [],
    reportSearchQuery: "",
    reportSearchResults: [],
    reportSearchFocused: false,
    imgUrl: "",
    navSelected: "",
    userData: "",
    actionStatus: "",
    chnagePasswordModelState: false,
    chnagePasswordUserData: null,
    equipGroups: [],
    //data
    showModal: false,
    open: false,
    userData: {},
    userGroupData: {},
    consumableGroupData: {},
    consumableMasterData: {},
    equipmentGroupData: {},
    equipmentTypeData: {},
    equipmentData: {},
    operatorMasterData: {},
    downTimeReasonGroupData: {},
    downTimeReasonData: {},
    qualityReasonGroupData: {},
    rejectionStage: {},
    partsPerCycleReason: {},
    qualityReasonData: {},
    toolMasterData: {},
    rawMaterialData: {},
    componentData: {},
    shiftSettingData: {},
    userRightsData: {},
    customerData: {},
    dataEntryComponentData: {},
    dataEntryOperatorData: {},
    dataEntryConsumableData: {},
    operationMasterData: {},
    querySuccess: false,
    job_view_enable: { JobView: false },
    equipList: [],
    macGroups: ["All"],
    filterObj: { FilterBy: "All", SortBy: "Ascending", JobView: false },
    sortObj: { SortBy: "Name" },
    filterBy: { All: true },
    cardDashboardState: false,
    macStateDashboardState: false,
    andonDashboardState: false,
    activityDashboardState: false,
    version: "",
    downtimeReasonList: [],
    componentList: [],
    andonDashboardData: [],
    windowWidth: window.innerWidth,
    andOnData: [],
    equipGroups: [],
    andOnDasboardObj: {
      Equipment: true,
      ConnStatus: true,
      DeviceConfig: true,
      Component: true,
      CustomerName: true,
      PartsProduced: true,
      TargetParts: true,
      TotalTime: true,
      RunTime: true,
      BalanceParts: true,
      OperatorName: true,
      Operation: false,
      Tool: false,
      TotalCycles: false,
      Shift: false,
      Availability: false,
      State: true,
      Performance: false,
      QualityFactor: false,
      OEE: false,
      ComponentAlias: false,
      TotalDownTime: false,
      JobAverageSPM: false,
      JobAverageCycleTime: false,
      ShiftAverageSPM: false,
      ShiftAverageCycleTime: false,
      TargetCycleTime: false,
      TargetSPM: false,
      ActualSPM: false,
      BatchNumber: false,
      PlannedQuantity: false,
      CumulativeProduction: false,
      OverallOEE: false,
      CumulativeDataFrom: false,
      monthlyTarget: false,
      monthlyProduction: false,
      monthlyOEE: false,
      // IdealShiftProduction:false,
      IdealRealTimeProduction: false,
      NextLoading: false,
      PlannedBatchQty: false
    },
    toolList: [],
    reportGroupClick: "",
    company: {},
    qualityReasonList: [],
    modalSettingState: false,
    autoScrolOpPerfModal: false,
    autoScrolOpPerfObj: { AutoScroll: false },
    autoScrollObj: { AutoScroll: false },

    entryType: { Single: true, Multiple: false },
    machineStates: [],
    radioStateSingle: "Running",
    reasonGroupList: [],
    modelState: false,
    EnableDataEntry: false,
    reportGroupClick: "",
    company: {},
    qualityReasonList: [],
    customDashboardData: { CurrentDate: new Date() },
    selectdeReason: { InitiateBreakdown: true },
    states: [],
    reload: false,
    countdownInterval: null,
    updateEvent: [0, 0, 0, 0, 0, 0],
    updateEventMultiple: [],
    inputData: {},
    selectedReason: {},
    equipFilter: false,
    CycleRun: 0,
    Split: [],
    noOfReasons: 2,
    selectedEquipment: {},
    Entrytype: "Normal",
    SelectedReason: {},
    reasonSplitGroupList: [],
    favouriteReport: [],
    SplitError: false,
    IsTranferTypeModal: false,
    transferTypeTools: [],
    breakdownTypes: [],
    selectedBreakdownType: "",
    actionTakenSplitList: [],
    CompanyGroup: [],
    HideDownTimeGroup: false,
    reasonList: [],
    actionTakenList: [],
    PartialDowntime: { From: '', Till: '' },
    runningTab: "home",
    breakdownData: null,
    // Equipment Group filter for the active dashboard (multi-select).
    // Each dashboard route uses its own localStorage key (see
    // DASHBOARD_EQUIP_GROUP_KEYS); this holds the selection for whichever
    // dashboard route is currently active. Sent to the dashboard APIs as an
    // array of EquipmentGroup name strings.
    dashboardEquipmentGroups: readDashboardEquipGroups(),
    dashboardEquipGroupDropdownOpen: false,
    // Aggregated / By Equipment Type view for the active dashboard's upper cards.
    dashboardUpperViewMode: readDashboardUpperViewMode(),

  };

  intervalReloadId = null;


  handleStorageEvent = (event) => {
    if (event.key === 'reloadAllTabsTrigger' && event.newValue === 'reload') {
      window.location.reload();
    }
  };

  triggerReloadAllTabs = () => {
    localStorage.setItem('reloadAllTabsTrigger', 'reload');
    localStorage.removeItem('reloadAllTabsTrigger'); // cleanup
    window.location.reload(); // reload current tab too (optional)
  };
  handleOnChangeAutoScroll = (e) => {
    const obj = { ...this.state.autoScrollObj };
    if (e.currentTarget.name == "AutoScroll") {
      obj[e.currentTarget.name] = e.currentTarget.checked;
    } else {
      obj[e.currentTarget.name] = e.currentTarget.value;
    }
    this.setState({ autoScrollObj: obj });
  };

  handleOnChangeAutoScrollOpPerfBoard = (e) => {
    const obj = { ...this.state.autoScrolOpPerfObj };
    if (e.currentTarget.name == "AutoScroll") {
      obj[e.currentTarget.name] = e.currentTarget.checked;
    } else {
      obj[e.currentTarget.name] = e.currentTarget.value;
    }
    this.setState({ autoScrolOpPerfObj: obj });
  };

  GetBreakdownTypes = async (company) => {
    axios.get(api.dataEntryUrl + 'serviceRequestType')
      .then((result) => {
        result.data = result.data.filter(x => x.ForWorkflow == "Breakdown");
        result.data.push({ RequestType: "Others", _id: "Others" });
        this.setState({ breakdownTypes: result.data })
      })
      .catch((err) => {
        toast.success(`${err}`, {
          position: 'bottom-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            background: 'red', // Set your desired background color
            color: 'white',     // Set your desired text color
          },
        });
      })

  }

  handleAutoScrollSetting = () => {
    return (
      <Modal
        size="md"
        show={this.state.modalSettingState}
        onHide={() => this.setState({ modalSettingState: false })}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 17 }}>
            Auto Scroll Setting
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-sm-2">Enable</div>
            <div className="col-sm-2">
              <input
                type="radio"
                checked={
                  this.state.autoScrollObj.AutoScroll == true ? true : false
                }
                name="AutoScroll"
                onChange={(e) =>
                  this.handleOnChangeAutoScroll({
                    currentTarget: { name: "AutoScroll", checked: true },
                  })
                }
                placeholder=""
              />
            </div>
            <div className="col-sm-2">Disable</div>
            <div className="col-sm-2">
              <input
                type="radio"
                name="AutoScroll"
                checked={
                  this.state.autoScrollObj.AutoScroll == false ? true : false
                }
                onChange={(e) =>
                  this.handleOnChangeAutoScroll({
                    currentTarget: { name: "AutoScroll", checked: false },
                  })
                }
                placeholder=""
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-sm-6">Number Of Machine Screen</div>
            <div className="col-sm-6">
              <input
                type="text"
                value={this.state.autoScrollObj.NumberOfMachine}
                name="NumberOfMachine"
                onChange={this.handleOnChangeAutoScroll}
                className="form-control form-control-sm"
                placeholder="Enter..."
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">Display For (Sec)</div>
            <div className="col-sm-6">
              <input
                type="text"
                name="DisplayFor"
                value={this.state.autoScrollObj.DisplayFor}
                onChange={this.handleOnChangeAutoScroll}
                className="form-control form-control-sm"
                placeholder="Enter..."
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              if (this.state.macStateDashboardState) {
                localStorage.setItem(
                  "mac_state",
                  JSON.stringify(this.state.autoScrollObj)
                );
              }
              if (this.state.andonDashboardState) {
                localStorage.setItem(
                  "andon_state",
                  JSON.stringify(this.state.autoScrollObj)
                );
              }
              if (this.state.cardDashboardState) {
                localStorage.setItem(
                  "card_state",
                  JSON.stringify(this.state.autoScrollObj)
                );
              }
              this.setState({ modalSettingState: false });
            }}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  handleAutoScrollSettingForOpPerfBoard = () => {
    return (
      <Modal
        size="md"
        show={this.state.autoScrolOpPerfModal}
        onHide={() => this.setState({ autoScrolOpPerfModal: false })}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 17 }}>
            Auto Scroll Setting
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-sm-2">Enable</div>
            <div className="col-sm-2">
              <input
                type="radio"
                checked={
                  this.state.autoScrolOpPerfObj.AutoScroll == true
                    ? true
                    : false
                }
                name="AutoScroll"
                onChange={(e) =>
                  this.handleOnChangeAutoScrollOpPerfBoard({
                    currentTarget: { name: "AutoScroll", checked: true },
                  })
                }
                placeholder=""
              />
            </div>
            <div className="col-sm-2">Disable</div>
            <div className="col-sm-2">
              <input
                type="radio"
                name="AutoScroll"
                checked={
                  this.state.autoScrolOpPerfObj.AutoScroll == false
                    ? true
                    : false
                }
                onChange={(e) =>
                  this.handleOnChangeAutoScrollOpPerfBoard({
                    currentTarget: { name: "AutoScroll", checked: false },
                  })
                }
                placeholder=""
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-sm-6">Number Of Row</div>
            <div className="col-sm-6">
              <input
                type="text"
                value={this.state.autoScrolOpPerfObj.NumberOfMachine}
                name="NumberOfMachine"
                onChange={this.handleOnChangeAutoScrollOpPerfBoard}
                className="form-control form-control-sm"
                placeholder="Enter..."
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">Display For (Sec)</div>
            <div className="col-sm-6">
              <input
                type="text"
                name="DisplayFor"
                value={this.state.autoScrolOpPerfObj.DisplayFor}
                onChange={this.handleOnChangeAutoScrollOpPerfBoard}
                className="form-control form-control-sm"
                placeholder="Enter..."
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              localStorage.setItem(
                "op_per_board_state",
                JSON.stringify(this.state.autoScrolOpPerfObj)
              );
              this.setState({ autoScrolOpPerfModal: false });
            }}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  IsReloadVersionCheck = () => {
    axios
      .get(api.dataEntryUrl + "BackendVersion")
      .then((res) => {
        if (!res.data) return;

        // Set the backend version in state (avoids a separate API call)
        if (res.data.Version) {
          this.setState({ version: res.data.Version });
        }

        const newVersion = res.data.ui_version;
        const storedVersion = localStorage.getItem("lastUiVersion");

        // First time (no stored version) → just set it
        if (!storedVersion) {
          localStorage.setItem("lastUiVersion", newVersion);
          return;
        }

        // If version changed → reload once and update stored version
        if (newVersion !== storedVersion) {
          localStorage.setItem("lastUiVersion", newVersion);
          window.location.reload(true); // hard reload
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowWidth);
    window.removeEventListener('storage', this.handleStorageEvent);
    clearInterval(this.intervalReloadId); // Cleanup interval
  }
  onRunningTabChange = (tab) => {
    this.setState({ runningTab: tab });
  }

  updateWindowWidth = () => {
    this.setState({ windowWidth: window.innerWidth });
  };
  async componentDidMount() {
    window.addEventListener("resize", this.updateWindowWidth);
    window.addEventListener('storage', this.handleStorageEvent);

    // this.intervalReloadId = setInterval(this.IsReloadVersionCheck, 120000); // Call API every 120 sec

    // NOTE: this used to removeItem() the seven master-data keys (equipment,
    // equipmentgroup, downtimereason, qualityreason, operator, tool, component)
    // right here, and then read them straight back via storeDataInLocalStorage()
    // a few lines below. The cache could never survive a reload, so every F5
    // paid for all seven round trips in series.
    //
    // Freshness is now handled by src/utill/masterDataCache.js: entries expire on
    // a TTL, and a stale entry is served immediately while it refreshes in the
    // background. Re-login, company switch and UIVersion bumps still invalidate,
    // both through the stamp check and through the explicit clearAllMasterData()
    // call on the token-change path below.
    const macStateFilterObj = localStorage.getItem("macStateDashboardFilter");
    if (macStateFilterObj) {
      this.setState({ filterObj: JSON.parse(macStateFilterObj) });
    } else {
      this.setState({
        filterObj: { FilterBy: "All", SortBy: "Ascending", JobView: false },
      });
    }

    let andOnState = JSON.parse(localStorage.getItem("andon_state"));
    if (andOnState && andOnState.AutoScroll) {
      this.setState({ autoScrollObj: andOnState });
    }
    let filterObj = JSON.parse(localStorage.getItem("activityFilter"));
    let data = localStorage.getItem("andon");
    let url = localStorage.getItem("url");
    if (url) {
      this.props.history.push(url);
    }
    if (data) {
      // Merge saved config over the defaults so newly added fields
      // (e.g. TargetCycleTime, TargetSPM) still appear in the selector.
      this.setState({ andOnDasboardObj: { ...this.state.andOnDasboardObj, ...JSON.parse(data) } });
    }
    if (filterObj) {
      this.setState({ sortObj: filterObj });
    } else {
      this.setState({ sortObj: { SortBy: "Name" } });
    }

    const user = auth.getCurrentUser();
    if (user) {
      this.setState({ querySuccess: true });

      // Rights, report master and company details don't depend on the master
      // lists, so they are started first and left to resolve on their own.
      // Rights matters most: it gates setDefaultStateForDashboard, which decides
      // what "/" lands on, and it used to sit behind two master-list round trips.
      axios
        .put(api.dataEntryUrl + "userrights", { email: user._id })
        .then((result) => {
          // // consol(result.data)
          if (result.data) {
            let arr = [];
            let favouriteReport = [];
            result.data.ReportRights.forEach((one) => {
              if (one.enable) {
                // let DisplayName=one.data
                // let RouteName=one.data;
                // let obj={}
                //  RouteName=RouteName.split(/\W+/).join('')
                //  obj.DisplayName=DisplayName;
                //  obj.RouteName=RouteName.toLowerCase();
                if (one?.isFavourite && one?.isFavourite) {
                  favouriteReport.push(one);
                }
                arr.push(one);
              }
            });

            arr = this.getReport(arr);
            this.setState({
              userRights: result.data,
              reports: arr,
              favouriteReport,
              querySuccess: false,
            });
            this.setDefaultStateForDashboard(result.data);
          } else {
            this.setState({ querySuccess: false });
            // No rights returned: resolve the default-landing decision anyway so
            // "/" renders instead of waiting forever.
            this.setDefaultStateForDashboard();
          }
        })
        .catch((err) => {
          this.setState({ querySuccess: false });
          this.setDefaultStateForDashboard();
          toast.success(`${err}`, {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              background: "red", // Set your desired background color
              color: "white", // Set your desired text color
            },
          });
        });

      axios.get(api.dataEntryUrl + "reportmaster").then((res) => {
        if (res.data) {
          this.setState({ reportMasterData: res.data });
        }
      }).catch((err) => { console.error("Failed to load reportmaster:", err); });

      function objectIdToDate(objectId) {
        // First 8 characters of ObjectId are the timestamp (in hex)
        const hexTimestamp = objectId.toString().substring(0, 8);
        const timestamp = parseInt(hexTimestamp, 16); // Convert hex to seconds
        return new Date(timestamp * 1000); // Convert to milliseconds and return Date object
      }

      axios
        .get(api.dataEntryUrl + "company/" + auth.getCurrentUser().company)
        .then((result) => {
          let companycreationdate = result.data.createdAt ? result.data.createdAt.split("T")[0] : objectIdToDate(result?.data?._id); //yyyy-MM-dd format date
          const currentdate = new Date().toJSON().slice(0, 10);
          const currentDate = new Date();
          const oneYearAgoDate = new Date(currentDate);
          oneYearAgoDate.setFullYear(currentDate.getFullYear() - 1);
          // Format the date to "YYYY-MM-DD"
          const formattedOneYearAgo = oneYearAgoDate.toISOString().split("T")[0];
          // consol(companycreationdate, formattedOneYearAgo,"current date is grater")
          if (companycreationdate > formattedOneYearAgo) {
            this.setState({ fromDateLimit: companycreationdate });
          } else {
            this.setState({ fromDateLimit: formattedOneYearAgo });
            this.setState({ querySuccess: false });
          }
          if (result.data && result.data.allowDowntimeGroupSelection == false) {
            this.setState({ HideDownTimeGroup: true });
          } else {
            this.setState({ HideDownTimeGroup: false });
          }
          if (result.data) {
            this.GetBreakdownTypes(result.data)
            this.setState({ company: result.data, querySuccess: false });
          } else {
            this.setState({ querySuccess: false });
          }
        })
        .catch((err) => {
          this.setState({ querySuccess: false });
          toast.success(`${err}`, {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              background: "red", // Set your desired background color
              color: "white", // Set your desired text color
            },
          });
        });

      //////////////////// the master lists are cached in localStorage so the reports can read them without re-calling these APIs
      // All six lists plus actionTaken go out together. Each one used to be
      // awaited in turn, which made the wait the sum of seven round trips rather
      // than the slowest one.
      //
      // settle() rather than a bare Promise.all, so one failing list can't reject
      // the batch. That matters beyond this block: the actionTaken call was
      // previously unguarded, and any rejection skipped the remainder of
      // componentDidMount - including the route flags and the
      // loadDashboardEquipSelection() call at the end of this method.
      const masterKeys = this.masterDataKeys;
      const results = await Promise.all(
        masterKeys
          .map((key) =>
            masterCache.settle(
              this.storeDataInLocalStorage(key, (fresh) =>
                this.applyMasterData(key, fresh)
              )
            )
          )
          .concat([
            masterCache.settle(axios.get(api.dataEntryUrl + "actionTaken")),
          ])
      );

      const patch = { querySuccess: false };

      masterKeys.forEach((key, index) => {
        const outcome = results[index];
        if (!outcome.ok) return;
        Object.assign(patch, this.buildMasterDataPatch(key, outcome.value) || {});
      });

      const actionTaken = results[masterKeys.length];
      if (actionTaken.ok && actionTaken.value) {
        Object.assign(
          patch,
          this.buildMasterDataPatch("actionTaken", actionTaken.value.data) || {}
        );
      }

      // A single update for the whole batch, instead of the ten separate setState
      // calls this block used to make.
      this.setState(patch);
    }

    if (window.location.pathname == "/") {
      this.setState({
        cardDashboardState: false,
        macStateDashboardState: true,
        andonDashboardState: false,
        navSelected: window.location.pathname,
      });
    } else if (window.location.pathname == "/dashboard/cardview") {
      this.setState({
        activityDashboardState: false,
        macStateDashboardState: false,
        cardDashboardState: true,
        andonDashboardState: false,
        navSelected: window.location.pathname,
      });
    } else if (window.location.pathname == "/dashboard/andon") {
      this.setState({
        activityDashboardState: false,
        macStateDashboardState: false,
        cardDashboardState: false,
        andonDashboardState: true,
        navSelected: window.location.pathname,
      });
    } else if (window.location.pathname == "/dashboard/activity") {
      this.setState({
        activityDashboardState: true,
        macStateDashboardState: false,
        cardDashboardState: false,
        andonDashboardState: false,
        navSelected: window.location.pathname,
      });
    } else {
      this.setState({
        navSelected: window.location.pathname,
        cardDashboardState: false,
        macStateDashboardState: false,
        andonDashboardState: false,
        activityDashboardState: false,
      });
    }
    this.loadDashboardEquipSelection();
  }

  componentDidUpdate(prevProps) {
    // Update dashboard state flags when the route changes
    const prevPath = prevProps.location ? prevProps.location.pathname : "";
    const currentPath = this.props.location ? this.props.location.pathname : window.location.pathname;

    if (prevPath !== currentPath) {
      if (currentPath === "/") {
        this.setState({
          cardDashboardState: false,
          macStateDashboardState: true,
          andonDashboardState: false,
          activityDashboardState: false,
          navSelected: currentPath,
        });
      } else if (currentPath === "/dashboard/cardview") {
        this.setState({
          activityDashboardState: false,
          macStateDashboardState: false,
          cardDashboardState: true,
          andonDashboardState: false,
          navSelected: currentPath,
        });
      } else if (currentPath === "/dashboard/andon") {
        this.setState({
          activityDashboardState: false,
          macStateDashboardState: false,
          cardDashboardState: false,
          andonDashboardState: true,
          navSelected: currentPath,
        });
      } else if (currentPath === "/dashboard/activity") {
        this.setState({
          activityDashboardState: true,
          macStateDashboardState: false,
          cardDashboardState: false,
          andonDashboardState: false,
          navSelected: currentPath,
        });
      } else {
        this.setState({
          navSelected: currentPath,
          cardDashboardState: false,
          macStateDashboardState: false,
          andonDashboardState: false,
          activityDashboardState: false,
        });
      }
      this.loadDashboardEquipSelection(currentPath);
    }
  }

  setNavSelectedState = (navigation) => {
    this.setState({
      navSelected: navigation,
    });
  };
  handleInnerTimeChange = (field, value) => {
    // ─── Persist if valid ───────────────────────────────────────────────
    this.setState((prev) => ({
      PartialDowntime: {
        ...prev.PartialDowntime,
        [field]: value,       // sets either From or Till
      },
    }));

  };

  checkReasonIsOpenBreakdown = (reason) => {
    if (this.state.reasonList.find(x => x.Reason == reason)) {
      return this.state.reasonList.find(x => x.Reason == reason).IsOpenBreakdown
    } else {
      return false;
    }
  }

  // A downtime reason can be configured in the Downtime Reason master to always end the job
  // running on the machine. When it is, the End Current Job tick is forced on and locked so
  // the operator can see what will happen but cannot opt out. The server enforces the same
  // rule from the master regardless of what this screen sends.
  checkReasonAutoEndsJob = (reason) => {
    const found = this.state.reasonList.find(x => x.Reason == reason);
    if (found) return found.AutoEndCurrentJob || false;
    if (this.state.selectedReason && this.state.selectedReason.Reason == reason) {
      return this.state.selectedReason.AutoEndCurrentJob || false;
    }
    return false;
  }

  /**
   * Single place that renders the "End Current Job" tick in this file.
   * alwaysShow is for the sites that were never rights gated, so introducing this helper
   * does not hide the tick from anyone who can see it today.
   */
  renderEndCurrentJobTick = ({
    reason,
    checked,
    onChange,
    disabled = false,
    wrapperClassName = "form-group text-center ",
    labelClassName = "form-check-label small mr-4 ",
    alwaysShow = false,
  }) => {
    const forced = this.checkReasonAutoEndsJob(reason);
    // This component gates the tick with its own handleUserRightsToVisibleOrNot method,
    // so use that rather than a prop, to match the existing call sites exactly.
    const hasRights = this.handleUserRightsToVisibleOrNot("DynamicDataRights", "JobSelection", "update");
    if (!forced && !hasRights && !alwaysShow) return null;

    return (
      <div className={wrapperClassName}>
        <label className={labelClassName} htmlFor="flexCheckChecked">
          End Current Job
        </label>
        <input
          className="form-check-input"
          type="checkbox"
          checked={forced ? true : !!checked}
          disabled={forced || disabled}
          onChange={onChange}
          name="EndCurrentJob"
        />
        {forced && (
          <div className="small text-muted mt-1">
            This reason always ends the running job on this machine, at the downtime start time.
          </div>
        )}
      </div>
    );
  }

  // Company settings can hide the Breakdown Type/Description inputs; the remarks are then used as the description.
  isBreakdownTypeEditingHidden = (reason) => {
    const found = this.state.reasonList.find(x => x.Reason == reason);
    if (!found) return false;
    if (found.IsOpenBreakdown) return !!this.state.company?.disableToolBreakdownTypeEditing;
    if (found.isAssetBreakdownEnabled) return !!this.state.company?.disableBreakdownTypeEditing;
    return false;
  }

  getBreakdownFieldsForPayload = (reason, source = {}, remarks) => {
    if (this.isBreakdownTypeEditingHidden(reason)) {
      return { BreakdownType: "", BreakdownDesc: remarks || "" };
    }
    return { BreakdownType: source.BreakdownType, BreakdownDesc: source.BreakdownDesc };
  }

  checkJobExistsForDowntime = (equipmentName, downtimeFrom, downtimeTill) => {
    try {
      // Use the existing getJobForThisDown method which already works
      const job = this.getJobForThisDown(downtimeFrom, downtimeTill, equipmentName, [...this.state.states]);
      return !!job;
    } catch (error) {
      console.error('Error checking job existence:', error);
      return false;
    }
  }

  getFilteredReasonList = () => {
    // Show all reasons including Open Breakdown - selection is blocked in handleOnChangeReason with proper alert
    return this.state.reasonList;
  }

  UpdatePartialDown = async (updateEvent) => {
    const {
      PartialDowntime,
      updateEquipEvent,
      selectedReason,
      transferTypeTools,
      states,
    } = this.state;

    const matchedState = states.find((s) => s.Equipment === updateEvent[0]);

    if (!matchedState) {
      console.warn("No matching equipment found");
      return;
    }

    const filterMac = matchedState.ListOfEvents.filter(
      (one) =>
        new Date(one.From).getTime() === new Date(updateEvent[4]).getTime() &&
        new Date(one.Till).getTime() === new Date(updateEvent[5]).getTime()
    );

    if (!filterMac.length) {
      console.warn("No matching event found");
      return;
    }

    if (!this.state.selectedReason.ReasonGroup || this.state.selectedReason.ReasonGroup === "") {
      swal("Please select Downtime Group.", { icon: "warning", dangerMode: true });
      return;
    }
    if (!this.state.selectedReason.Reason || this.state.selectedReason.Reason === "" || this.state.selectedReason.Reason === "Running") {
      swal("Please select Downtime Reason.", { icon: "warning", dangerMode: true });
      return;
    }

    // Check if this is an Open Breakdown reason and validate job existence
    if (this.checkReasonIsOpenBreakdown(this.state.selectedReason.Reason)) {
      const hasJob = this.checkJobExistsForDowntime(updateEvent[0], updateEvent[4], updateEvent[5]);

      if (!hasJob) {
        swal({
          title: "Job Required",
          text: "You need to create a job first to enter the Open breakdown reason to open a ticket in TMS",
          icon: "warning",
          button: "OK"
        });
        return;
      }
    }

    // ↓ inside UpdatePartialDown
    const mergeDateAndTime = (dateSrc /* full date */, timeStr /* "HH:mm" */) => {
      // Guard clauses
      if (!dateSrc || !timeStr) return null;

      const datePart = new Date(dateSrc);
      const [hh, mm] = timeStr.split(":").map(Number);

      if (isNaN(datePart) || Number.isNaN(hh) || Number.isNaN(mm)) return null;

      // Copy H & M, keep seconds/millis at 0
      datePart.setHours(hh, mm, 0, 0);

      return datePart.toISOString();        // or datePart for a Date object
    };


    const mergedFrom = mergeDateAndTime(updateEvent[4], PartialDowntime.From);  // "08:53"
    const mergedTill = mergeDateAndTime(updateEvent[5], PartialDowntime.Till);  // "09:16"

    if (!mergedFrom || !mergedTill) {
      swal("Invalid From or Till datetime values.", { icon: "error" });
      return;
    }
    const selectedEquipment = this.state.equipList.find((equip) => equip.EquipmentID === updateEvent[0]);

    const start = new Date(mergedFrom);
    const end = new Date(mergedTill);

    // NaN guard
    if (isNaN(start) || isNaN(end)) {
      swal("Invalid date supplied:", mergedFrom.toString(), mergedTill.toString(), { icon: "error" });
      return false;
    }

    const diffSeconds = (end - start) / 1000; // ms → s
    const isValid = diffSeconds >= selectedEquipment.DownTimeThresold;

    if (!isValid) {
      return swal(
        "Invalid Downtime Duration",
        `The downtime duration must be at least ${selectedEquipment.DownTimeThresold} seconds as per equipment threshold.`,
        "warning"
      );
    }

    let fromTime = new Date(mergedFrom);
    fromTime.setMilliseconds(fromTime.getMilliseconds() + 1)
    if (this.RangeValidator(updateEvent[4], updateEvent[5], new Date(fromTime), mergedTill)) {
      let initiateBreakdown = _.cloneDeep(this.state.selectedReason).InitiateBreakdown;
      if (this.checkReasonIsOpenBreakdown(this.state.selectedReason.Reason) && initiateBreakdown) {
        if (!this.isBreakdownTypeEditingHidden(this.state.selectedReason.Reason)) {
          if (!this.state.selectedReason.BreakdownType) {
            swal("Please select Breakdown Type when initiating breakdown.", { dangerMode: true })
            this.setState({ querySuccess: false })
            return
          }
          if (this.state.selectedReason.BreakdownType == "Others") {
            swal("Please enter breakdown type for initiating breakdown in TMS.", { dangerMode: true })
            this.setState({ querySuccess: false })
            return
          }
          if (!this.state.selectedReason.BreakdownDesc) {
            this.setState({ querySuccess: false })
            swal("Please enter breakdown description to initiate breakdown in TMS.", { dangerMode: true })
            return
          }
        }
      } else {
        initiateBreakdown = false;
      }
      // Step 3: Construct payload
      const payload = {
        old: {
          Shift: filterMac[0].Shift,
          Equipment: updateEvent[0],
          State: updateEvent[1],
          From: updateEvent[4],
          Till: updateEvent[5],
        },
        new: [
          {
            Shift: filterMac[0].Shift,
            Equipment: updateEvent[0],
            Remarks: this.state.selectedReason.Remarks,
            Reason: this.state.selectedReason.Reason,
            IsTransferTool: !!transferTypeTools.length,
            actionTaken: this.state.selectedReason.actionTaken,
            EndCurrentJob: this.state.selectedReason.EndCurrentJob,
            ...this.getBreakdownFieldsForPayload(this.state.selectedReason.Reason, this.state.selectedReason, this.state.selectedReason.Remarks),
            InitiateBreakdown: initiateBreakdown,
            ReasonGroup: this.state.selectedReason.ReasonGroup,
            From: fromTime,
            Till: mergedTill,
          },
        ],
      };

      this.setState({ querySuccess: true });
      try {
        const res = await axios.patch(api.dataEntryUrl + 'split-running-state', payload);
        if (notifyJobResults(res.data?.jobResult)) this.handleClickOK(this.state.inputData);
        if (res.data) {
          this.handelupdate(true, [
            {
              Shift: filterMac[0].Shift,
              Equipment: updateEvent[0],
              Remarks: selectedReason.Remarks,
              Reason: selectedReason.Reason,
              IsTransferTool: !!transferTypeTools.length,
              actionTaken: this.state.selectedReason.actionTaken,
              EndCurrentJob: this.state.selectedReason.EndCurrentJob,
              ReasonGroup: selectedReason.ReasonGroup,
              From: mergedFrom,
              Till: mergedTill,
            },
          ]);
          this.handleClose();
        }
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          swal(err.response.data.message, { icon: "error", dangerMode: true });
        } else {
          swal("An error occurred while updating partial downtime.", { icon: "error", dangerMode: true });
        }
      } finally {
        this.setState({ querySuccess: false });
      }

    } else {
      return swal(`The entered Time should lie between the current From : ${moment(updateEvent[4]).format('DD-MM-YYYY HH:mm a')} - Till : ${moment(updateEvent[5]).format('DD-MM-YYYY HH:mm a')}  `)
    }

  };


  GetCompanyDetail = () => {
    function objectIdToDate(objectId) {
      // First 8 characters of ObjectId are the timestamp (in hex)
      const hexTimestamp = objectId.toString().substring(0, 8);
      const timestamp = parseInt(hexTimestamp, 16); // Convert hex to seconds
      return new Date(timestamp * 1000); // Convert to milliseconds and return Date object
    }

    axios
      .get(api.dataEntryUrl + "company/" + auth.getCurrentUser().company)
      .then((result) => {
        let companycreationdate = result.data.createdAt ? result.data.createdAt.split("T")[0] : objectIdToDate(result?.data?._id); //yyyy-MM-dd format date
        const currentdate = new Date().toJSON().slice(0, 10);
        const currentDate = new Date();
        const oneYearAgoDate = new Date(currentDate);
        oneYearAgoDate.setFullYear(currentDate.getFullYear() - 1);
        // Format the date to "YYYY-MM-DD"
        const formattedOneYearAgo = oneYearAgoDate.toISOString().split("T")[0];
        // consol(companycreationdate, formattedOneYearAgo,"current date is grater")
        if (companycreationdate > formattedOneYearAgo) {
          this.setState({ fromDateLimit: companycreationdate });
        } else {
          this.setState({ fromDateLimit: formattedOneYearAgo });
          this.setState({ querySuccess: false });
        }
        if (result.data && result.data.allowDowntimeGroupSelection == false) {
          this.setState({ HideDownTimeGroup: true });
        } else {
          this.setState({ HideDownTimeGroup: false });
        }
        if (result.data) {
          this.GetBreakdownTypes(result.data)
          this.setState({ company: result.data, querySuccess: false });
        } else {
          this.setState({ querySuccess: false });
        }
      })
      .catch((err) => {
        this.setState({ querySuccess: false });
        toast.success(`${err}`, {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            background: "red", // Set your desired background color
            color: "white", // Set your desired text color
          },
        });
      });
  }

  RangeValidator = (outerFrom, outerTill, innerFrom, innerTill) => {
    /* ---------- parse outer bounds ---------- */
    const oFrom = moment(outerFrom); // lenient; you already have valid Dates
    const oTill = moment(outerTill);

    /* ---------- helper to parse inner endpoints ---------- */
    const parseInner = (val, refDate) => {
      // 1) Try "HH:mm" (24 h) strict
      let m = moment(val, "HH:mm", true);
      if (m.isValid()) {
        // attach outer date
        return m.set({
          year: refDate.year(),
          month: refDate.month(),
          date: refDate.date(),
        });
      }
      // 2) Fallback: any full date‑time Moment can parse
      m = moment(val);
      return m;
    };

    const iFrom = parseInner(innerFrom, oFrom);
    const iTill = parseInner(innerTill, oFrom);

    let msg = "";

    /* ---------- format guard ---------- */
    if (![oFrom, oTill, iFrom, iTill].every(m => m.isValid())) {
      msg =
        "Times must be HH:mm (e.g. 08:23) or full ISO/‘YYYY‑MM‑DD hh:mm AM/PM’ date‑times.";
    }
    /* ---------- logical checks ---------- */
    else if (iFrom.isAfter(iTill)) {
      msg = "From must be earlier than Till.";
    } else if (iFrom.isBefore(oFrom)) {
      msg = "From cannot be earlier than the outer From.";
    } else if (iFrom.isAfter(oTill)) {
      msg = "From cannot be later than the outer Till.";
    } else if (iTill.isAfter(oTill)) {
      msg = "Till cannot be later than the outer Till.";
    } else if (iTill.isBefore(oFrom)) {
      msg = "Till cannot be earlier than the outer From.";
    }

    if (msg) {
      swal(msg, { icon: "warning", dangerMode: true });
      return false; // rejected
    }
    return true;    // accepted
  };
  // Live report RouteName values are stored both with and without a leading slash,
  // and can be missing on older rights documents.
  getNormalizedRoute = (routeName) => {
    if (typeof routeName !== "string" || routeName.trim() === "") return "";
    const route = routeName.trim();
    return route.startsWith("/") ? route : "/" + route;
  };

  // Applies the user's default landing page once per app load, and only when the
  // app was opened on "/". This is the ONLY place that redirects to the default
  // dashboard: doing it from the "/" route render instead would trap the user,
  // because the Machine State Dashboard lives on "/" and would bounce back to the
  // default on every click.
  setDefaultStateForDashboard = (rights = { LiveReportRights: [] }) => {
    if (!this.state.defaultDashboardPending) return;

    const liveRights = rights && rights.LiveReportRights ? rights.LiveReportRights : [];
    const defaultDashboard = liveRights.find(
      (one) => one.IsDefault && one.enable !== false
    );
    const route = this.getNormalizedRoute(defaultDashboard && defaultDashboard.RouteName);
    const currentPath = this.props.location
      ? this.props.location.pathname
      : window.location.pathname;

    // Clear the flag first so "/" stops waiting, then navigate. A route of "/" (or
    // no default at all) means we stay put and MachineStateChart renders. If the
    // user already moved off "/" while the rights were loading, leave them there.
    this.setState({ defaultDashboardPending: false }, () => {
      if (route && route !== "/" && currentPath === "/") {
        this.props.history.push(route);
      }
    });
  };

  // The master lists this component pulls in on mount. They are independent of
  // one another, so they are fetched together rather than in a chain.
  masterDataKeys = [
    "equipment",
    "equipmentgroup",
    "downtimereason",
    "qualityreason",
    "tool",
    "component",
  ];

  // Builds the state patch for one master list without applying it, so the mount
  // path can merge all of them into a single setState instead of re-rendering
  // this (very large) component once per list.
  // Returns null when there is nothing to apply.
  buildMasterDataPatch = (key, data) => {
    if (!data) return null;

    switch (key) {
      case "equipment": {
        const filterBy = { All: true };
        const macGroups = ["All"];
        data.forEach((one) => {
          if (!macGroups.includes(one.EquipmentGroup)) {
            macGroups.push(one.EquipmentGroup);
            filterBy[one.EquipmentGroup] = true;
          }
        });
        macGroups.sort((a, b) => (a > b ? 1 : b > a ? -1 : 0));
        return { equipList: data, macGroups: macGroups, filterBy: filterBy };
      }

      case "equipmentgroup":
        return { equipGroups: data };

      case "downtimereason": {
        const sorted = data
          .slice()
          .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        return {
          downtimeReasonList: sorted,
          // Preserved verbatim from the original mount code. Note the condition
          // is always true, so this yields an array of `true` - kept as-is to
          // keep this refactor behaviour-neutral rather than silently changing
          // whatever downstream depends on it.
          reasonList: sorted.map(
            (one) => one.Reason !== "Down" || one.Reason !== "down"
          ),
        };
      }

      case "qualityreason":
        return { qualityReasonList: data };

      case "tool":
        return { toolList: data };

      case "component":
        return { componentList: data };

      case "actionTaken":
        return { actionTakenList: data };

      default:
        return null;
    }
  };

  // Applies one master list immediately. Used as the background-refresh callback
  // for storeDataInLocalStorage, so a stale entry that gets revalidated after
  // first paint still lands in state.
  applyMasterData = (key, data) => {
    const patch = this.buildMasterDataPatch(key, data);
    if (patch) this.setState(patch);
  };

  ///////////////////////// this is the function to store the data into localstorage, from the API when logged in into an company and then Provide data from the local storage instead of calling api ////////////////////
  // Resolves to the array for `apiName`, from localStorage when possible.
  //
  //   fresh cache -> returned as-is, no network call at all
  //   stale cache -> returned immediately, refreshed in the background
  //   no cache    -> awaited network call, then cached
  //
  // Concurrent callers for the same key share a single request, so several
  // reports mounting at once no longer each fire their own GET.
  //
  // `onRefresh` is optional and only fires when a background refresh lands, which
  // lets a caller re-render with fresh data without blocking the first paint.
  // Every existing caller passes one argument and keeps its old behaviour.
  storeDataInLocalStorage = (apiName, onRefresh) =>
    masterCache.getMasterData(apiName, onRefresh);

  getLiveReportDisplayName = (report = {}) =>
    report.DisplayName || report.displayName || report.data || "";

  handleUpdateEquips = async () => {
    this.setState({ querySuccess: true });
    try {
      let equipmentdata = await this.storeDataInLocalStorage("equipment");
      this.setState({ equipList: equipmentdata, querySuccess: false });
    } catch (err) {
      this.setState({ querySuccess: false });
      toast.success(`${err}`, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: {
          background: "red", // Set your desired background color
          color: "white", // Set your desired text color
        },
      });
    }
  };
  schema = {
    DateTime: joi.date().required().label("DateTime"),
    Shift: joi.string().required().label("Shift"),
    UserId: joi.string(),
    InitiateBreakdown: joi.bool(),
    BreakdownType: joi.string(),
    BreakdownDesc: joi.string(),
    Equips: joi.array(),
    Remarks: joi.string().allow("").allow(null),
    EndCurrentJob: joi.bool(),
    TransferTypeTool: joi.string(),
    IsTransferTool: joi.boolean()
  };

  handleOnUpdate = (data) => {
    // // consol(this.state.navSelected)
    // // consol(data)
    const urlArr = this.state.navSelected.split("/");
    let navSelected;
    if (urlArr[3] == "add") {
      navSelected = `/${urlArr[1]}/${urlArr[2]}/list`;
      this.setState({ navSelected: `/${urlArr[1]}/${urlArr[2]}/list` });
    }

    if (
      this.state.navSelected === "/setting/usergroup/list" ||
      (urlArr[3] == "add" &&
        this.state.navSelected === "/setting/usergroup/list")
    ) {
      this.setState({ actionStatus: "update", userGroupData: data });
      this.props.history.push("/setting/usergroup/add");
    }
    if (
      this.state.navSelected === "/setting/operation/list" ||
      (urlArr[3] == "add" &&
        this.state.navSelected === "/setting/operation/list")
    ) {
      this.setState({ actionStatus: "update", operationMasterData: data });
      this.props.history.push("/setting/operation/add");
    }
    if (
      this.state.navSelected === "/setting/consumablegroup/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/consumablegroup/list")
    ) {
      this.setState({ actionStatus: "update", consumableGroupData: data });
      this.props.history.push("/setting/consumablegroup/add");
    }

    if (
      this.state.navSelected === "/setting/consumablemaster/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/consumablemaster/list")
    ) {
      this.setState({ actionStatus: "update", consumableMasterData: data });
      this.props.history.push("/setting/consumablemaster/add");
    }
    if (
      this.state.navSelected === "/setting/equipmentgroup/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/equipmentgroup/list")
    ) {
      this.setState({ actionStatus: "update", equipmentGroupData: data });
      this.props.history.push("/setting/equipmentgroup/add");
    }
    if (
      this.state.navSelected === "/setting/equipmenttype/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/equipmenttype/list")
    ) {
      this.setState({ actionStatus: "update", equipmentTypeData: data });
      this.props.history.push("/setting/equipmenttype/add");
    }
    if (
      this.state.navSelected === "/setting/equipmentlocation/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/equipmentlocation/list")
    ) {
      this.setState({ actionStatus: "update", equipmentLocationData: data });
      this.props.history.push("/setting/equipmentlocation/add");
    }
    if (
      this.state.navSelected === "/setting/equipmentmodel/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/equipmentmodel/list")
    ) {
      this.setState({ actionStatus: "update", equipmentModelData: data });
      this.props.history.push("/setting/equipmentmodel/add");
    }
    if (
      this.state.navSelected === "/setting/equipment/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/equipment/list")
    ) {
      this.setState({ actionStatus: "update", equipmentData: data });
      this.props.history.push("/setting/equipment/add");
    }
    if (
      this.state.navSelected === "/setting/weldingfixture/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/weldingfixture/list")
    ) {
      this.setState({ actionStatus: "update", weldingFixtureData: data });
      this.props.history.push("/setting/weldingfixture/add");
    }
    if (
      this.state.navSelected === "/setting/equipmenthourlyrate/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/equipmenthourlyrate/list")
    ) {
      this.setState({ actionStatus: "update", equipmentData: data });
      this.props.history.push("/setting/equipmenthourlyrate/add");
    }
    if (
      this.state.navSelected === "/setting/operatormaster/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/operatormaster/list")
    ) {
      this.setState({ actionStatus: "update", operatorMasterData: data });
      this.props.history.push("/setting/operatormaster/add");
    }
    if (
      this.state.navSelected === "/setting/rejectionstage/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/rejectionstage/list")
    ) {
      this.setState({ actionStatus: "update", rejectionStage: data });
      this.props.history.push("/setting/rejectionstage/add");
    }
    if (
      this.state.navSelected === "/setting/partspercyclereason/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/partspercyclereason/list")
    ) {
      this.setState({ actionStatus: "update", partsPerCycleReason: data });
      this.props.history.push("/setting/partspercyclereason/add");
    }
    if (
      this.state.navSelected === "/setting/downtimereasongroup/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/downtimereasongroup/list")
    ) {
      this.setState({ actionStatus: "update", downTimeReasonGroupData: data });
      this.props.history.push("/setting/downtimereasongroup/add");
    }
    if (
      this.state.navSelected === "/setting/downtimereason/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/downtimereason/list")
    ) {
      this.setState({ actionStatus: "update", downTimeReasonData: data });
      this.props.history.push("/setting/downtimereason/add");
    }
    if (
      this.state.navSelected === "/setting/qualityreasongroup/list" ||
      (urlArr[3] === "add" &&
        this.state.navSceleted === "/setting/qualityreasongroup/list")
    ) {
      this.setState({ actionStatus: "update", qualityReasonGroupData: data });
      this.props.history.push("/setting/qualityreasongroup/add");
    }
    if (
      this.state.navSelected === "/setting/qualityreason/list" ||
      (urlArr[3] === "add" &&
        this.state.navSceleted === "/setting/qualityreason/list")
    ) {
      this.setState({ actionStatus: "update", qualityReasonData: data });
      this.props.history.push("/setting/qualityreason/add");
    }
    if (
      this.state.navSelected === "/setting/toolmaster/list" ||
      (urlArr[3] === "add" &&
        this.state.navSceleted === "/setting/toolmaster/list")
    ) {
      this.setState({ actionStatus: "update", toolMasterData: data });
      this.props.history.push("/setting/toolmaster/add");
    }
    if (
      this.state.navSelected === "/setting/toolCode/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/toolCode/list")
    ) {
      this.setState({ actionStatus: "update", toolCodeData: data });
      this.props.history.push("/setting/toolCode/add");
    }
    if (
      this.state.navSelected === "/setting/rawmaterial/list" ||
      (urlArr[3] === "add" &&
        this.state.navSceleted === "/setting/rawmaterial/list")
    ) {
      this.setState({ actionStatus: "update", rawMaterialData: data });
      this.props.history.push("/setting/rawmaterial/add");
    }

    if (
      this.state.navSelected === "/setting/component/list" ||
      (urlArr[3] === "add" &&
        this.state.navSceleted === "/setting/component/list")
    ) {
      this.setState({ actionStatus: "update", componentData: data });
      this.props.history.push("/setting/component/add");
    }
    if (
      this.state.navSelected === "/setting/shiftsetting/list" ||
      (urlArr[3] === "add" &&
        this.state.navSceleted === "/setting/shiftsetting/list")
    ) {
      this.setState({ actionStatus: "update", shiftSettingData: data });
      this.props.history.push("/setting/shiftsetting/add");
    }
    if (
      this.state.navSelected === "/setting/customer/list" ||
      (urlArr[3] === "add" &&
        this.state.navSceleted === "/setting/customer/list")
    ) {
      this.setState({ actionStatus: "update", customerData: data });
      this.props.history.push("/setting/customer/add");
    }
    if (
      this.state.navSelected === "/setting/userrights/list" ||
      (urlArr[3] === "add" &&
        this.state.navSceleted === "/setting/userrights/list")
    ) {
      this.setState({ actionStatus: "update", userRightsData: data });
      this.props.history.push("/setting/userrights/add");
    }
    if (
      this.state.navSelected === "/setting/user/list" ||
      (urlArr[3] === "add" && this.state.navSceleted === "/setting/user/list")
    ) {
      this.setState({ actionStatus: "update", userData: data });
      // // consol(data)
      this.props.history.push("/setting/user/add");
    }
    if (
      this.state.navSelected === "/setting/employeerole/list" ||
      (urlArr[3] === "add" && this.state.navSceleted === "/setting/employeerole/list")
    ) {
      // Since EmployeeRole is a single-page CRUD component, we don't need to redirect
      // The component handles edit/view operations internally via modals
      this.setState({ actionStatus: "update" });
    }
    if (
      this.state.navSelected === "/setting/employee/list" ||
      (urlArr[3] === "add" && this.state.navSceleted === "/setting/employee/list")
    ) {
      // Since EmployeeMaster is a single-page CRUD component, we don't need to redirect
      // The component handles edit/view operations internally via modals
      this.setState({ actionStatus: "update" });
    }
    if (
      this.state.navSelected === "/setting/customequipmentgroup/list" ||
      (urlArr[3] == "add" &&
        this.state.navSceleted === "/setting/customequipmentgroup/list")
    ) {
      this.setState({ actionStatus: "update", customEquipmentGroupData: data });
      this.props.history.push("/setting/customequipmentgroup/add");
    }
  };

  handleDataEntryUpdate = (key, data, url, actionStatus) => {
    this.setState({ [key]: data, actionStatus });
    this.props.history.push(url);
  };

  handleSettingsNavigation = (path, navSelected = path) => (e) => {
    if (e) {
      e.preventDefault();
    }

    this.props.history.push(path);
    this.setState({
      navSelected,
      activityDashboardState: false,
      andonDashboardState: false,
      cardDashboardState: false,
      macStateDashboardState: false,
    });
  };

  sortSettingsItems = (items = []) =>
    [...items]
      .filter(Boolean)
      .sort((first, second) =>
        first.label.localeCompare(second.label, undefined, {
          sensitivity: "base",
        })
      );

  renderSettingsItems = (items, parentId) =>
    this.sortSettingsItems(items).map((item) => {
      if (item.children && item.children.length > 0) {
        const firstChild = (item.children || []).filter(Boolean)[0];
        return (
          <li key={item.id}>
            <a
              className="text-white"
              style={{ cursor: "pointer" }}
              onClick={
                firstChild
                  ? this.handleSettingsNavigation(
                    firstChild.path,
                    firstChild.path
                  )
                  : undefined
              }
            >
              {item.label}
            </a>
          </li>
        );
      }

      return (
        <li key={item.id}>
          <a
            className="text-white"
            href={item.path}
            style={{ cursor: "pointer" }}
            onClick={this.handleSettingsNavigation(
              item.path,
              item.navSelected || item.path
            )}
          >
            {item.label}
          </a>
        </li>
      );
    });

  // Returns only the settings entries that are groups (have children).
  getSettingsGroups = (items = []) =>
    (items || [])
      .filter(Boolean)
      .filter((item) => item.children && item.children.length > 0);

  // Finds the settings group (and matching child) that owns the current route.
  findActiveSettingsGroup = (items, currentPath) => {
    const groups = this.getSettingsGroups(items);
    const matchPath = (child) => {
      if (!child || !child.path) return false;
      if (currentPath === child.path) return true;
      const base = child.path.replace(/\/(list|add|view|edit)$/i, "");
      return base && currentPath.startsWith(base + "/");
    };
    for (const group of groups) {
      const activeChild = group.children.filter(Boolean).find(matchPath);
      if (activeChild) {
        return { group, activeChild };
      }
    }
    return null;
  };

  // Renders an Antd Tabs bar for the settings group that owns the current
  // route. Each tab simply navigates to the existing child route, so no
  // underlying functionality changes.
  renderSettingsTabBar = (items) => {
    const currentPath = this.props.location
      ? this.props.location.pathname
      : window.location.pathname;
    const match = this.findActiveSettingsGroup(items, currentPath);
    if (!match) {
      return null;
    }
    const { group, activeChild } = match;
    const tabItems = group.children.filter(Boolean).map((child) => ({
      key: child.path,
      label: child.label,
    }));
    return (
      <div
        className="settings-tabs"
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          background: "#fff",
          padding: "10px 16px 0",
          borderBottom: "1px solid #e5e9f0",
          boxShadow: "0 2px 6px rgba(15,32,39,.06)",
        }}
      >
        <style>{`
          .settings-tabs .ant-tabs-nav { margin-bottom: 0; }
          .settings-tabs .ant-tabs-nav::before { border-bottom: 0 !important; }
          .settings-tabs .ant-tabs-nav-list { gap: 4px; }
          .settings-tabs .ant-tabs-tab {
            margin: 0 !important;
            padding: 6px 16px !important;
            border: 1px solid #dce1e8 !important;
            border-bottom: 0 !important;
            border-radius: 8px 8px 0 0 !important;
            background: #f4f6f9 !important;
            transition: background .15s ease, color .15s ease;
          }
          .settings-tabs .ant-tabs-tab .ant-tabs-tab-btn {
            color: #55627a !important;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: .2px;
          }
          .settings-tabs .ant-tabs-tab:hover { background: #e9eef5 !important; }
          .settings-tabs .ant-tabs-tab:hover .ant-tabs-tab-btn { color: #2d6aa0 !important; }
          .settings-tabs .ant-tabs-tab.ant-tabs-tab-active {
            background: linear-gradient(135deg,#0f2027,#2c5364) !important;
            border-color: transparent !important;
            box-shadow: 0 2px 8px rgba(15,32,39,.22);
          }
          .settings-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
            color: #fff !important;
            font-weight: 700;
          }
          .settings-tabs .ant-tabs-ink-bar { display: none; }
        `}</style>
        <div
          className="settings-tabs-group"
          style={{
            fontSize: 11,
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: ".6px",
            color: "#2d6aa0",
            marginBottom: 6,
          }}
        >
          {group.label}
        </div>
        <Tabs
          type="card"
          size="small"
          activeKey={activeChild.path}
          onChange={(key) => this.handleSettingsNavigation(key, key)()}
          items={tabItems}
        />
      </div>
    );
  };

  handleOnAdd = (urlPath, action, keyState, valueState) => {
    this.setState({ actionStatus: action, [keyState]: valueState });
  };

  handleToggleClick = () => {
    this.setState({ toggle: this.state.toggle ? false : true });
  };

  handleUserChangePassword = () => {
    this.setState({
      chnagePasswordModelState: true,
      chnagePasswordUserData: auth.getCurrentUser(),
    });
  };
  handleCloseChnagePassword = () => {
    this.setState({ chnagePasswordModelState: false });
  };

  handleUserRightsToVisibleOrNot = (dataMemebre, data, perType) => {
    const rights = this.state.userRights;
    let allow = false;
    if (rights != null) {
      rights[dataMemebre].map((one) => {
        if (one.data === data) {
          allow = one[perType];
        }
      });
    }
    return allow;
  };

  handleClickJobNavItem = () => { };
  hanldeClickOperatorNavItem = () => { };

  handleDownloadTableToExcel = (tableId, headingText) => {
    //exportHtmlTableToExcel(tableId, headingText);
    generateExcelFile(tableId, new Date(Date.now()), headingText);
  };
  handleDownloadTableToExceltext = (tableId, headingText) => {
    generateExcelTextFile(tableId, new Date(Date.now()), headingText);
  };
  handleApplyFilter = () => { };

  handleChangeActivityFilter = (e) => {
    const filterObj = { ...this.state.sortObj };
    filterObj[e.currentTarget.name] = e.currentTarget.value;
    localStorage.setItem("activityFilter", JSON.stringify(filterObj));
    this.setState({ sortObj: filterObj });
  };

  handleFilterAndSort = (e) => {
    const filterObj = { ...this.state.filterObj };
    filterObj[e.currentTarget.name] = e.currentTarget.value;
    this.setState({ filterObj: filterObj });
  };

  // ─── Dashboard Equipment Group filter (per-route localStorage) ────────
  loadDashboardEquipSelection = (path = window.location.pathname) => {
    this.setState({
      dashboardEquipmentGroups: readDashboardEquipGroups(path),
      dashboardUpperViewMode: readDashboardUpperViewMode(path),
    });
  };

  // Aggregated / By Equipment Type toggle that sits next to the Equipment Group filter.
  setDashboardUpperViewMode = (mode) => {
    const key = upperViewModeKey();
    try {
      if (key) localStorage.setItem(key, mode);
    } catch (e) {
      // Persisting the choice is best effort only.
    }
    this.setState({ dashboardUpperViewMode: mode });
  };

  persistDashboardEquipGroups = (next) => {
    const key = DASHBOARD_EQUIP_GROUP_KEYS[window.location.pathname];
    if (key) {
      localStorage.setItem(key, JSON.stringify(next));
    }
    this.setState({ dashboardEquipmentGroups: next });
  };

  handleToggleDashboardEquipGroup = (groupName) => {
    const current = this.state.dashboardEquipmentGroups || [];
    const next = current.includes(groupName)
      ? current.filter((g) => g !== groupName)
      : [...current, groupName];
    this.persistDashboardEquipGroups(next);
  };

  // "All" clears the selection (empty array => no filter sent to the API)
  handleSelectAllDashboardEquipGroups = () => {
    this.persistDashboardEquipGroups([]);
  };

  // Stable callback for the toggle_custom carousel children so memoization is
  // not invalidated by a new inline arrow function on every render.
  handleCarouselGetCurrentData = (data) => {
    this.setState({ customDashboardData: data });
  };

  // Build the carousel slides for /dashboard/toggle_custom. Memoized on the
  // inputs that actually matter so the heavy dashboard elements keep stable
  // references across NavBarUser's frequent re-renders. Without this, the
  // Carousel receives brand-new child elements on every render and the active
  // slide goes blank during/after a transition.
  getCarouselItems = (user) => {
    const signature = JSON.stringify({
      equipListLen: this.state.equipList ? this.state.equipList.length : 0,
      equipGroupsLen: this.state.equipGroups ? this.state.equipGroups.length : 0,
      filterBy: this.state.filterBy,
      filterObj: this.state.filterObj,
      groups: this.state.dashboardEquipmentGroups,
      upperViewMode: this.state.dashboardUpperViewMode,
      userId: user && user._id,
    });
    if (this._carouselSignature === signature && this._carouselItems) {
      return this._carouselItems;
    }
    this._carouselSignature = signature;
    this._carouselItems = [
      <DashBoardCustom
        getCurrentData={this.handleCarouselGetCurrentData}
        equipList={this.state.equipList}
        filterBy={this.state.filterBy}
        filterObj={this.state.filterObj}
        equipmentGroupFilter={this.state.dashboardEquipmentGroups}
        filterStorageKey="equipGroupFilter_toggleCustom"
        upperViewMode={this.state.dashboardUpperViewMode}
        user={user}
      />,
      <DashBoardDowntimeAndIncident
        getCurrentData={this.handleCarouselGetCurrentData}
        user={user}
        equipGroups={this.state.equipGroups}
        equips={this.state.equipList}
        equipmentGroupFilter={this.state.dashboardEquipmentGroups}
        filterStorageKey="equipGroupFilter_toggleCustom"
      />,
    ];
    return this._carouselItems;
  };

  handleFilterBy = (e) => {
    const filterObj = { ...this.state.filterBy };
    filterObj[e.currentTarget.name] = e.currentTarget.checked;
    if (e.currentTarget.name === "All") {
      this.state.macGroups.forEach((one) => {
        filterObj[one] = e.currentTarget.checked;
      });
    } else {
      filterObj["All"] = false;
    }
    this.setState({ filterBy: filterObj });
  };

  getReport = (report) => {
    let data = [];

    for (let i = 0; i < report.length; i++) {
      let obj = { ReportGroup: report[i].ReportGroup, Report: [] };
      obj.Report.push(report[i]);
      for (let j = i + 1; j < report.length; j++) {
        if (report[i].ReportGroup === report[j].ReportGroup) {
          obj.Report.push(report[j]);
          report.splice(j, 1);

          // i--;
          j--;
          // i=j-1
        }
      }
      data.push(obj);
    }
    return data;
  };

  handleGroupClick = (group) => {
    this.setState({ reportGroupClick: group });
  };

  handleReportSearch = (e) => {
    const query = e.target.value;
    this.setState({ reportSearchQuery: query, reportSearchFocused: true });
    if (!query.trim()) {
      this.setState({ reportSearchResults: [] });
      return;
    }
    const q = query.toLowerCase();
    const userReports = [];
    if (this.state.userRights && this.state.userRights.ReportRights) {
      this.state.userRights.ReportRights.forEach((r) => {
        if (r.enable) userReports.push({ ...r, _type: "report" });
      });
    }
    if (this.state.userRights && this.state.userRights.LiveReportRights) {
      this.state.userRights.LiveReportRights.forEach((r) => {
        if (r.enable) userReports.push({ ...r, _type: "live" });
      });
    }
    const results = userReports.filter((r) => {
      const name = (r.data || r.DisplayName || "").toLowerCase();
      if (name.includes(q)) return true;
      const master = this.state.reportMasterData.find((m) =>
        m.RouteName === r.RouteName ||
        m.RouteName?.toLowerCase() === r.RouteName?.toLowerCase() ||
        m.DisplayName?.toLowerCase() === (r.data || r.DisplayName || "").toLowerCase()
      );
      if (master && master.MetaTags && master.MetaTags.some((tag) => tag.toLowerCase().includes(q))) return true;
      if (master && master.Description && master.Description.toLowerCase().includes(q)) return true;
      return false;
    });
    this.setState({ reportSearchResults: results.slice(0, 10) });
  };

  getAndonDashboardData = (data) => {
    const andOnDasboardObj = { ...this.state.andOnDasboardObj };
    let arr = [];
    data.forEach((one) => {
      // Target Cycle Time / Target SPM are the job's ideal values. Alias them from
      // IdealCycleTime/IdealSPM when the API provides those (only if not already present).
      if (one.TargetCycleTime === undefined && one.IdealCycleTime !== undefined) {
        one.TargetCycleTime = one.IdealCycleTime;
      }
      if (one.TargetSPM === undefined && one.IdealSPM !== undefined) {
        one.TargetSPM = one.IdealSPM;
      }
      // Actual SPM is the achieved SPM for the running job. Alias from
      // JobAverageSPM/AverageSPM when the API does not send ActualSPM directly.
      if (one.ActualSPM === undefined && one.JobAverageSPM !== undefined) {
        one.ActualSPM = one.JobAverageSPM;
      }
      if (one.ActualSPM === undefined && one.AverageSPM !== undefined) {
        one.ActualSPM = one.AverageSPM;
      }
      let obj = {};
      Object.keys(one).forEach((key) => {
        if (andOnDasboardObj[key] || key === "DeviceConfig") {
          obj[key] = one[key];
        }
      });
      arr.push(obj);
    });
    localStorage.setItem("andon", JSON.stringify(andOnDasboardObj));
    this.setState({ andOnData: data, andonDashboardData: arr });
  };

  handleOnChangeSelect = (e) => {
    const andOnDasboardObj = { ...this.state.andOnDasboardObj };
    andOnDasboardObj["DeviceConfig"] = true;
    const andOnData = [...this.state.andOnData];
    if (andOnDasboardObj[e.currentTarget.name]) {
      andOnDasboardObj[e.currentTarget.name] = false;
    } else {
      andOnDasboardObj[e.currentTarget.name] = true;
    }

    let arr = [];
    andOnData.forEach((one) => {
      let obj = {};
      Object.keys(andOnDasboardObj).forEach((key) => {
        if (andOnDasboardObj[key]) {
          obj[key] = one[key];
        }
      });
      arr.push(obj);
    });
    localStorage.setItem("andon", JSON.stringify(andOnDasboardObj));
    this.setState({ andOnDasboardObj, andonDashboardData: arr });
  };

  handleGetAddJobData = (jobData) => {
    this.setState({ JobData: jobData });
  };

  handleCancel = () => {
    this.setState({ open: false });
  };
  handleOnChange = (e) => {
    const { name, value } = e.target;
    if (value && value !== "Select Plant") {
      this.setState({ Plant: value });

      // Save plant in localStorage
      localStorage.setItem("plant", value);
      // Prepare token API call with fetch
      fetch(api.dataEntryUrl + 'token', {
        method: 'POST',
        headers: {
          'company': value,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          company: value,
          email: auth.getCurrentUser().email,
          plant: jwtDecode(auth.getJwt()).Plants, // Use the selected plant or fallback to the current value
        }),
      })
        .then((res) => {
          if (!res.ok) throw new Error('Network response was not ok');
          return res.text(); // <-- Important: parse as plain text
        })
        .then((token) => {

          localStorage.setItem("token", token); // Store plain string
          http.setJwt(token, value); // Use the token
          // Restart the COCO AI Assistant only once the new plant's token is in place.
          this.setState((s) => ({ assistantEpoch: (s.assistantEpoch || 0) + 1 }));
          // Switching company means every master list belongs to the old tenant.
          // Clears the sidecar metadata too, which the seven removeItem() calls
          // that used to sit here did not.
          masterCache.clearAllMasterData();
          // Optional: refresh the page
          this.triggerReloadAllTabs();
          // window.location.reload(true);
        })
        .catch((error) => {
          console.error("Error fetching token:", error);
        });

    }
  };

  showModal = () => {
    this.setState({ open: true });
  };
  stopCountdown = () => {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval); // Clear the interval
      this.countdownInterval = null; // Reset the interval reference
    }
    this.handleClose();
    this.setState({
      EnableDataEntry: false,
      countdown: null,
      SplitError: false,
    }); // Reset the countdown and state
  };

  handelEnabledataentry = async (data1, data2, data3) => {
    const EquipmentDowntimeList = (data2.find(one => one?.Equipment == data1[0]))?.ListOfEvents
    const DowntimeReason = EquipmentDowntimeList.filter(one => new Date(one?.From).getTime() == new Date(data1[4]).getTime() && new Date(one?.Till).getTime() == new Date(data1[5]).getTime())


    const downtimeReason = DowntimeReason[0]?.DowntimeReason;

    if (downtimeReason != null) {  // Covers both null & undefined


      const hasUpdatePermission = this.handleUserRightsToVisibleOrNot("DynamicDataRights", "Downtime", "update");

      if (!hasUpdatePermission) {
        // swal({
        //   title: "Warning!",
        //   text: "Permission to edit reason denied.",
        //   icon: "warning",
        //   button: {
        //     text: "OK",
        //     className: "swal-button--danger", // Optional: Custom styling
        //   },
        //   dangerMode: true,
        // });
        // return;
      }
    }



    this.setState({ Entrytype: "Normal" }); //
    if (this.state.EnableDataEntry) {
      this.handleChartEvent(data1, data2, data3);
    }
  };
  // handelEnableDowntimeEntry = (e, type) => {

  //   // Check if the timer exists and clear it
  //   if (this.countdownTimer) {
  //     this.stopCountdown();
  //   }

  //   if (e) {
  //     // Enable data entry
  //     if (type === "reset") {
  //       clearInterval(this.countdownInterval);

  //       this.setState({ EnableDataEntry: e }, () => {
  //         this.startCountdown();
  //       });
  //     } else {
  //       this.setState({ EnableDataEntry: e }, () => {
  //         this.startCountdown();
  //       });
  //     }
  //   } else {
  //     // Disable data entry and stop countdown
  //     this.stopCountdown();
  //   }
  // };
  startCountdown = () => {
    this.setState({ countdown: 60, EnableDataEntry: true }); // Initialize countdown

    // Clear any existing interval to avoid duplicates
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    // Start a new interval
    this.countdownInterval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.countdown <= 1) {
          this.stopCountdown();
          return { countdown: 0 };
        }
        return { countdown: prevState.countdown - 1 };
      });
    }, 1000);
  };



  getTransferTypeToolList = async (component, tool) => {
    axios.put(api.dataEntryUrl + 'getTransferTypeTool', { ComponentId: component, ToolId: tool })
      .then(res => {
        this.setState({ transferTypeTools: res.data });
      })
      .catch(err => {
        console.log(`${err}`, 'Error Getting Transfer Type Tools');
      });
  }

  getJobForThisDown = (donwFrom, downTill, equipName, states = []) => {
    const filterEquipmentObj = states.find((one) => one.Equipment == equipName);
    if (filterEquipmentObj) {
      const job = filterEquipmentObj.Jobs.find((one) => (new Date(one.From) <= new Date(donwFrom)) && new Date(one.Till) >= new Date(downTill));
      if (job) {
        return job
      }
      return null
    }
  }

  CheckIsOpenBreakdown = async (toold, equipment) => {
    try {
      const result = await axios.put(api.dataEntryUrl + '/openBreakdown', { MoldId: toold, EquipmentId: equipment });
      if (result.data) {
        this.setState({ InitiateBreakdown: false, breakdownData: result.data });
      } else {
        this.setState({ InitiateBreakdown: true, breakdownData: null })
      }
    }
    catch (err) {
      swal(`${err}`);
    }
  }

  stopCountdown = () => {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval); // Clear the interval
      this.countdownInterval = null; // Reset the interval reference
    }
    this.setState({
      EnableDataEntry: false,
      countdown: null,
      modelState: false,
      SplitError: false,
    }); // Reset the countdown and state
  };
  handleChartEvent = async (evt, data, states) => {
    this.setState({ states: [...data] });
    const noOfReasons = 2;

    let events = evt[1].split("-");
    if (events[0].trim() == "Job") {
      if (this.state.entryType.Single) {
        const machineStates = [...data];
        let filterEquipmentObj = machineStates.filter(
          (one) => one.Equipment == evt[0]
        );

        this.setState({
          modelStateJob: true,
          updateEventJobs:
            filterEquipmentObj.length > 0 ? filterEquipmentObj[0].Jobs : [],
          updateEquipEvent:
            filterEquipmentObj.length > 0 ? filterEquipmentObj[0] : {},
        });
      } else {
        swal("job update allowed only in Single mode", { dangerMode: true });
      }
    } else {
      const reason = evt[1]
      if (reason !== "Down" && !this.handleUserRightsToVisibleOrNot(
        "DynamicDataRights",
        "Downtime",
        "update"
      )) {
        swal("Do not have permission to update dowtime", { dangerMode: true })
        return
      }
      if (reason == "Down" && !this.handleUserRightsToVisibleOrNot(
        "DynamicDataRights",
        "Downtime",
        "write"
      )) {
        swal("Do not have permission to write dowtime", { dangerMode: true })
        return
      }
      if (/*evt[1] !== 'Running' &&*/ this.getSystemState(evt) !== "Break") {
        const selectedEquipment = this.state.equipList.find(
          (equip) => equip.EquipmentID === evt[0]
        );
        const inputData = {};
        inputData.From = evt[4];
        inputData.Till = evt[5];
        inputData.Equips = [selectedEquipment];
        const job = this.getJobForThisDown(evt[4], evt[5], selectedEquipment.EquipmentID, _.cloneDeep(data));
        if (job) {
          await this.CheckIsOpenBreakdown(job.ToolID, selectedEquipment.EquipmentID);
          this.getTransferTypeToolList(job.Component, job.ToolID)
        }

        this.setState({
          selectedEquipment,
          noOfReasons,
          breakdownData: null,
          // Split: this.generateSplits(
          //   evt[4],
          //   evt[5],
          //   noOfReasons - 1,(selectedEquipment && selectedEquipment?.DownTimeThresold ? selectedEquipment.DownTimeThresold : 0),selectedEquipment
          // ),
        });
        let downtimeReasons = await axios.get(api.dataEntryUrl + "downtimegroup");
        let filtered = downtimeReasons.data.filter(
          (item) => item.DownTimeReasonGroup !== "default"
        );
        if (this.state.entryType.Single) {
          let selectdeReason = { ...this.state.selectdeReason };
          let selectedReason = { ...this.state.selectedReason };
          let reasonList = await axios.get(api.dataEntryUrl + "downtimereason");
          // let downtimeGroups = await axios.put(api.dataEntryUrl + 'downtimereason', { ReasonGroup: reasonList.data.filter(one=>one.Reason==evt[1])[0]._id });
          selectdeReason["Reason"] = evt[1];
          selectedReason["Reason"] = evt[1];
          let filteredReasonListData = reasonList.data;
          const matchedReason = reasonList.data.find((one) => one.Reason == evt[1]);
          if (matchedReason) {
            selectdeReason["ReasonGroup"] = matchedReason.ReasonGroup;
            selectedReason["ReasonGroup"] = matchedReason.ReasonGroup;
            if (!this.state.HideDownTimeGroup) {
              filteredReasonListData = reasonList.data.filter(
                (one) => one.ReasonGroup == matchedReason.ReasonGroup
              );
            }
          }
          if (
            data
              .filter((one) => one.Equipment == evt[0])[0]
              .ListOfEvents.filter(
                (one) =>
                  new Date(one.From).getTime() == new Date(evt[4]).getTime() &&
                  new Date(one.Till).getTime() == new Date(evt[5]).getTime()
              ).length > 0
          ) {
            let remarks = data
              .filter((one) => one.Equipment == evt[0])[0]
              .ListOfEvents.filter(
                (one) =>
                  new Date(one.From).getTime() == new Date(evt[4]).getTime() &&
                  new Date(one.Till).getTime() == new Date(evt[5]).getTime()
              )[0];
            selectdeReason["Remarks"] = remarks.Remarks;
            selectedReason["Remarks"] = remarks.Remarks;
          }

          this.setState({
            modelState: true,
            reasonList: filteredReasonListData,
            selectedReason: selectedReason,
            selectdeReason: selectdeReason,
            updateEvent: evt,
            radioStateSingle: evt[1],
            reasonGroupList: filtered,
            chartEventClickNo: this.state.chartEventClickNo + 1,
          });
        }
        if (this.state.entryType.Multiple) {
          const updateEventMultiple = [...this.state.updateEventMultiple];

          let filer = updateEventMultiple.filter(
            (one) => this.getSystemState(one) == this.getSystemState(evt)
          );

          if (updateEventMultiple.length == 0) {
            updateEventMultiple.push(evt);
            this.setState({
              updateEventMultiple,
              reasonGroupList: filtered,
              systemGenerated: false,
              // Start a fresh multi-selection on Down; the user opts into Running via the toggle.
              radioStateSingle: "Down",
            });
          } else {
            if (filer.length > 0) {
              let existsEvent = updateEventMultiple.filter(
                (one) =>
                  new Date(one[4]).getTime() == new Date(evt[4]).getTime() &&
                  new Date(one[5]).getTime() == new Date(evt[5]).getTime() &&
                  one[0] == evt[0]
              );
              if (existsEvent.length > 0) {
              } else {
                updateEventMultiple.push(evt);
                this.setState({
                  updateEventMultiple,
                  reasonGroupList: filtered,
                  systemGenerated: false,
                });
              }
            } else {
              this.setState({ systemGenerated: true });
              swal("update only same system generated state at one time", {
                dangerMode: true,
              });
            }
          }
        }
      }
    }
  };

  setRunningState = (updateEvent) => {
    return new Promise((resolve, reject) => {
      let filterMac;
      this.state.states.filter((obj) => {
        if (obj.Equipment == updateEvent[0]) {
          filterMac = obj.ListOfEvents.filter((one) => {
            if (
              new Date(updateEvent[4]).getTime() ==
              new Date(one.From).getTime() &&
              new Date(updateEvent[5]).getTime() == new Date(one.Till).getTime()
            ) {
              return one;
            }
          });
        }
      });
      axios
        .patch(api.dataEntryUrl + "running", {
          old: {
            Shift: filterMac[0].Shift,
            Equipment: updateEvent[0],
            State: updateEvent[1],
            From: updateEvent[4],
            Till: updateEvent[5],
          },
          new: {
            actionTaken: this.state.selectdeReason.actionTaken,
            Shift: updateEvent[0].Shift,
            Equipment: updateEvent[0],
            Remarks: this.state.selectedReason.Remarks,
            InitiateBreakdown: this.state.selectdeReason.InitiateBreakdown,
            ...this.getBreakdownFieldsForPayload(this.state.selectedReason.Reason, this.state.selectdeReason, this.state.selectedReason.Remarks),
            TransferTypeTool: this.state.selectdeReason.TransferTypeTool,
            IsTransferTool: this.state.transferTypeTools.length > 0 ? true : false,
            EndCurrentJob: this.state.selectedReason.EndCurrentJob,
            Reason: this.state.selectedReason.Reason,
            ReasonGroup: this.state.selectedReason.ReasonGroup,
            From: updateEvent[4],
            Till: updateEvent[5],
          },
        })
        .then((result) => {
          const { n, nModified, ok } = result.data;
          if (n == 1 && nModified == 1 && ok == 1) {
            this.handelupdate(true, [{ Equipment: updateEvent[0] }]);
            resolve("Update");
          } else {
            resolve("NotUpdate");
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  handleOnChangeRadio = (e) => {
    this.setState({ radioStateSingle: e.currentTarget.value });
  };

  handleClose = () => {
    this.setState({
      modelState: false,
      chartEventClickNo: 1,
      SplitError: false,
      radioStateSingle: "Down",
    });
  };

  // The Down/Running toggle is only rendered when the selected period was system-Running
  // and the company allows converting it. Only then may "Running" in radioStateSingle be
  // trusted; otherwise it is a leftover from an earlier click (Multiple mode never sets
  // it) and the user is applying a downtime reason, not marking the period Running.
  isRunningUpdate = () => {
    if (this.state.radioStateSingle !== "Running") return false;
    const firstEvent = this.state.entryType.Single
      ? this.state.updateEvent
      : this.state.updateEventMultiple[0];
    return (
      this.getSystemState(firstEvent) === "Running" &&
      !!this.state.company?.canConvertRunningToDown
    );
  };
  // getSystemState = (evt) => {
  //   if (evt) {
  //     let filterMachine = this.state.machineStates.filter(
  //       (one) => one.Equipment == evt[0]
  //     );
  //     if (filterMachine.length > 0) {
  //       let filterMacDoc = filterMachine[0].ListOfEvents.filter((oneDoc) => {
  //         if (
  //           new Date(oneDoc.From).getTime() == new Date(evt[4]).getTime() &&
  //           new Date(oneDoc.Till).getTime() == new Date(evt[5]).getTime()
  //         ) {
  //           return oneDoc;
  //         }
  //       });
  //       if (filterMacDoc.length > 0) return filterMacDoc[0].SystemState;
  //     }
  //   }

  //   return "";
  // };
  getSystemState = (evt, states) => {
    if (evt) {
      let filterMachine = this.state.states.filter(
        (one) => one.Equipment == evt[0]
      );

      if (filterMachine.length > 0) {
        let filterMacDoc = filterMachine[0].ListOfEvents.filter((oneDoc) => {
          if (
            new Date(oneDoc.From).getTime() == new Date(evt[4]).getTime() &&
            new Date(oneDoc.Till).getTime() == new Date(evt[5]).getTime()
          ) {
            return oneDoc;
          }
        });
        if (filterMacDoc.length > 0) return filterMacDoc[0].SystemState;
      }
    }

    return "";
  };

  handelupdate = (value, data) => {
    this.setState({ reload: value, updateData: data });
  };
  handleClickOK = (inputData) => {
    const errors = validation.validate(inputData, this.schema);
    // consol(errors)
    this.setState({ errors: errors || {} });
    if (errors) return;
    inputData.UserId = this.props.user._id;
    inputData.Equips = this.props.equips;
    this.setState({ querySuccess: true, equipFilter: false });
    axios
      .post(api.dataEntryUrl + "GetMachineActivityForHistorical", inputData)
      .then((result) => {
        const groupList = [...this.state.equipmentGroupList];
        result.data.forEach((one) => {
          if (
            groupList.filter((group) => group.name == one.EquipmentGroup)
              .length == 0
          ) {
            let obj = { name: one.EquipmentGroup, enable: true };
            groupList.push(obj);
          }
        });

        groupList.sort((a, b) =>
          a.name > b.name ? 1 : b.name > a.name ? -1 : 0
        );
        this.setState({
          selectdeReason: { InitiateBreakdown: true },
          breakdownData: null,
          equipFilter: false,
          machineStates: result.data,
          equipmentGroupList: groupList,
          states: [...result.data],
          querySuccess: false,
          updateEventMultiple: [],
        });
      })
      .catch((err) => {
        this.setState({ querySuccess: false });

        swal(`${err}`);
      });
  };

  handleOnChangeReason = (e, type, idx) => {
    const selectdeReason = { ...this.state.selectdeReason };
    let obj = JSON.parse(e.currentTarget.value);

    // Prevent selection of Open Breakdown reasons in Multiple/All or Split modes
    if (obj && obj.IsOpenBreakdown && (this.state.entryType.Multiple || this.state.entryType.All || type === 'Split')) {
      swal({
        title: "Invalid Selection",
        text: "Open Breakdown reasons cannot be selected when entering multiple downtime entries. Please select a different reason or use Single entry mode.",
        icon: "warning",
        button: "OK"
      });
      return;
    }

    // Check if this is an Open Breakdown reason and validate job existence
    if (obj && obj.IsOpenBreakdown) {
      const currentDowntimeEvent = this.state.updateEvent;
      let equipmentName, downtimeFrom, downtimeTill;

      if (type === 'Split' && this.state.Split && this.state.Split[idx]) {
        // For split entries, get equipment and time from the split data
        const splitData = this.state.Split[idx];
        equipmentName = splitData.Equips && splitData.Equips[0] ? splitData.Equips[0].EquipmentID : currentDowntimeEvent[0];
        downtimeFrom = splitData.from;
        downtimeTill = splitData.till;
      } else {
        // For single/multiple entries, get from updateEvent
        equipmentName = currentDowntimeEvent[0];
        downtimeFrom = currentDowntimeEvent[4];
        downtimeTill = currentDowntimeEvent[5];
      }

      const hasJob = this.checkJobExistsForDowntime(equipmentName, downtimeFrom, downtimeTill);

      if (!hasJob) {
        swal({
          title: "Job Required",
          text: "You need to create a job first to enter the Open breakdown reason to open a ticket in TMS",
          icon: "warning",
          button: "OK"
        });
        return;
      }
    }

    if (obj && obj.AutoEndCurrentJob) {
      alertReasonEndsRunningJob(obj.Reason, this.state.entryType.Multiple || this.state.entryType.All);
    }

    selectdeReason[e.currentTarget.name] = obj.Reason;
    if (this.state.HideDownTimeGroup) {
      selectdeReason['ReasonGroup'] = (this.state.reasonList.find(one => one.Reason === obj.Reason))?.ReasonGroup;

    }
    const errors = validation.validate(selectdeReason, this.schemaForModel);

    if (obj && obj.enableActionTaken) {
      this.setState({ ActionTakenForReason: obj.enableActionTaken });
    } else {
      this.setState({ ActionTakenForReason: false });
    }
    //  this.setState({ errors: errors || {} });
    //  if (errors) return;
    if (type === 'Split') {
      const { Split } = this.state;
      const data = [...Split];


      if (!Array.isArray(data)) {
        data = []; // or throw an error depending on your use case
      }

      if (!data[idx]) {
        data[idx] = {};
      }

      if (!data[idx]['DowntimeReason']) {
        data[idx]['DowntimeReason'] = {};
      }

      // Capture the row's previous reason before overwriting, so the end-job flag is only
      // cleared when it was the previous reason that forced it.
      const previousRowReasonForcedEndJob = this.checkReasonAutoEndsJob(data[idx]['DowntimeReason']['Reason']);

      data[idx]['DowntimeReason']['ActionTakenForReason'] = !!(obj && (obj.enableActionTaken ?? false));
      data[idx]['DowntimeReason'][e.currentTarget.name] = obj.Reason;
      // Split rows hold EndCurrentJob at row level, not under DowntimeReason.
      if (obj && obj.AutoEndCurrentJob) {
        data[idx]['EndCurrentJob'] = true;
      } else if (previousRowReasonForcedEndJob) {
        data[idx]['EndCurrentJob'] = false;
      }
      if (this.state.HideDownTimeGroup) {
        data[idx]['DowntimeReason']['ReasonGroup'] = (this.state.reasonList.find(one => one.Reason === obj.Reason)).ReasonGroup;
      }
      this.setState({ Split: data });
    }
    // A reason configured with "End Current Job" in the Downtime Reason master always ends
    // the running job, so mirror it into the entry state to keep the payload consistent with
    // the locked tick. Moving to a reason that is not configured that way clears it again,
    // but only when the previous reason was what set it, so a deliberate manual tick is
    // preserved. The server enforces the rule from the master either way.
    const previousReasonForcedEndJob = this.checkReasonAutoEndsJob(this.state.selectedReason?.Reason);
    if (obj && obj.AutoEndCurrentJob) {
      obj.EndCurrentJob = true;
      selectdeReason['EndCurrentJob'] = true;
    } else if (previousReasonForcedEndJob) {
      if (obj) obj.EndCurrentJob = false;
      selectdeReason['EndCurrentJob'] = false;
    } else if (obj) {
      obj.EndCurrentJob = selectdeReason['EndCurrentJob'] ?? false;
    }
    this.setState({
      selectedReason: obj,
      selectdeReason,
      errors: errors || {},
    });
  };

  handleOnChangeActionChange = (e, type, idx) => {
    try {
      const { name, value } = e.currentTarget;

      if (!name) {
        console.error("Missing name in event target.");
        return;
      }

      const selectdeReason = { ...this.state.selectdeReason };
      selectdeReason[name] = value;

      // Handle 'Split' type separately
      if (type === 'Split') {
        const { Split } = this.state;

        if (!Array.isArray(Split) || typeof idx !== 'number' || !Split[idx]) {
          console.error("Invalid index or Split data structure.");
          return;
        }

        const data = [...Split];

        // Ensure DowntimeReason exists and is an object
        if (!data[idx].DowntimeReason || typeof data[idx].DowntimeReason !== 'object') {
          data[idx].DowntimeReason = {};
        }

        data[idx].DowntimeReason[name] = value;


        this.setState({ Split: data });
      }

      // Update the selected reason state
      this.setState({ selectdeReason });

    } catch (error) {
      console.error("Error in handleOnChangeActionChange:", error);
    }
  };
  schemaForModel = {
    Reason: joi.string().required().label("Reason"),
    actionTaken: joi.string().optional().label("actionTaken"),
    ActionTakenForReason: joi.boolean(),
    ReasonGroup: joi.string().required().label("ReasonGroup"),
    Remarks: joi.string().allow("").allow(null),
    EndCurrentJob: joi.bool(),
    _id: joi.string(),
    Color: joi.string(),
    createdAt: joi.string(),
    InitiateBreakdown: joi.bool(),
    BreakdownType: joi.string(),
    BreakdownDesc: joi.string(),
    modified: joi.array(),
    updatedAt: joi.string(),
    ReasonType: joi.string(),
  };

  handleReasonUpdate = async () => {
    delete this.state.selectedReason.__v;
    // return
    if (this.state.Entrytype == "Split") {
      const newObj = [...this.state.Split];
      const oldObj = [...this.state.updateEvent];
      const error = newObj.filter(
        (one) =>
          one.DowntimeReason == undefined ||
          one.DowntimeReason?.Reason === "" ||
          one.DowntimeReason?.ReasonGroup === ""
      );

      if (error.length > 0) {
        swal("Please Fill Downtime Details");
        return;
      }

      // Prevent Open Breakdown reasons in split entries (Multiple Downtime Reason mode)
      const splitEntriesWithOpenBreakdown = newObj.filter(one =>
        one.DowntimeReason && this.checkReasonIsOpenBreakdown(one.DowntimeReason.Reason)
      );

      if (splitEntriesWithOpenBreakdown.length > 0) {
        swal({
          title: "Invalid Selection",
          text: "Open Breakdown reasons cannot be selected when entering multiple downtime entries. Please select a different reason or use Single entry mode.",
          icon: "warning",
          button: "OK"
        });
        return;
      }

      // newObj.forEach(one => one.DowntimeReason !== '')

      try {
        const result = await this.setDowntimeState1(oldObj, newObj);
        if (result == "Update") {
          this.setState({
            querySuccess: false,
            modelState: false,
            Entrytype: "Normal",
          });
          this.handleClickOK(this.state.inputData);
          swal("Update Success");
        } else {
          this.setState({
            querySuccess: false,
            modelState: false,
            Entrytype: "Normal",
          });
          this.handleClickOK(this.state.inputData);
          swal("Update Success");
        }
      } catch (error) {
        console.error("Error updating downtime:", error);
      }
    } else {
      // return;

      const { updateEvent, updateEventMultiple, inputData } = { ...this.state };
      const isRunningUpdate = this.isRunningUpdate();
      if (isRunningUpdate) {
        if (this.state.selectedReason == "") {
          swal("Please Select Downtime Reason");
          return;
        }
        if (this.state.entryType.Single) {
          this.setState({ querySuccess: true });
          this.setRunningState(updateEvent)
            .then((result) => {
              if (result == "Update") {
                this.setState({ querySuccess: false, modelState: false });
                this.setState({ Entrytype: "Normal" });

                this.handleUpdateMachineState([updateEvent]);

                swal("Update Success");
              } else {
                this.setState({ querySuccess: false, modelState: false });
                this.setState({ Entrytype: "Normal" });

                this.handleUpdateMachineState([updateEvent]);
                swal("Update Success");
              }
            })
            .catch((err) => {
              this.setState({ Entrytype: "Normal" });

              this.setState({ querySuccess: false });
              toast.success(`${err}`, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: {
                  background: "red", // Set your desired background color
                  color: "white", // Set your desired text color
                },
              });
            });
        }
        if (this.state.entryType.Multiple) {
          let arr = [];
          this.setState({ querySuccess: true });
          updateEventMultiple.forEach((one) => {
            let filterMac;
            this.state.states.filter((obj) => {
              if (obj.Equipment == one[0]) {
                filterMac = obj.ListOfEvents.filter((one1) => {
                  if (
                    new Date(one[4]).getTime() ==
                    new Date(one1.From).getTime() &&
                    new Date(one[5]).getTime() == new Date(one1.Till).getTime()
                  ) {
                    return one;
                  }
                });
              }
            });
            let obj = {
              old: {
                Shift: filterMac[0].Shift,
                Equipment: one[0],
                State: one[1],
                From: one[4],
                Till: one[5],
              },
              new: {
                Equipment: one[0],
                EndCurrentJob: this.state.selectedReason.EndCurrentJob,
                Remarks: this.state.selectedReason.Remarks,
                Reason: this.state.selectedReason.Reason,
                ReasonGroup: this.state.selectedReason.ReasonGroup,
                From: one[4],
                Till: one[5],
              },
            };
            arr.push(obj);
          });
          axios
            .patch(api.dataEntryUrl + "multipleRunning", { RunningArray: arr })
            .then((result) => {
              if (result.data == "Update") {
                this.setState({ querySuccess: false, modelState: false });
                this.setState({ Entrytype: "Normal" });

                this.handleUpdateMachineState(updateEventMultiple);
                swal("All Reasons Update Successfully");
              } else {
                this.setState({ querySuccess: false, modelState: false });
                this.setState({ Entrytype: "Normal" });

                this.handleUpdateMachineState(updateEventMultiple);
                swal("All Reasons Update Successfully");
              }
            })

            .catch((err) => {
              this.setState({ querySuccess: false });
              toast.success(`${err}`, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: {
                  background: "red", // Set your desired background color
                  color: "white", // Set your desired text color
                },
              });
            });
        }
      } else {
        if (!this.state.selectdeReason || !this.state.selectdeReason.Reason) {
          swal("Please Select Downtime Reason");
          return;
        }



        if (this.state.entryType.Single) {
          if (this.state.selectdeReason.Reason !== "Down") {

            // Check if this is an Open Breakdown reason and validate job existence before submission
            if (this.checkReasonIsOpenBreakdown(this.state.selectdeReason.Reason)) {
              const hasJob = this.checkJobExistsForDowntime(updateEvent[0], updateEvent[4], updateEvent[5]);

              if (!hasJob) {
                swal({
                  title: "Job Required",
                  text: "You need to create a job first to enter the Open breakdown reason to open a ticket in TMS",
                  icon: "warning",
                  button: "OK"
                });
                return;
              }
            }

            const errors = validation.validate(
              this.state.selectdeReason,
              this.schemaForModel
            );
            // consol(errors)
            this.setState({ errors: errors || {} });
            if (errors) return;

            this.setState({ querySuccess: true });
            // if (
            //   this.state.selectdeReason.InitiateBreakdown === true &&
            //   (!this.state.selectdeReason.BreakdownType ||
            //     this.state.selectdeReason.BreakdownType === "")
            // ) {
            //   swal("Please select Breakdown Type when initiating breakdown.", { icon: "warning", dangerMode: true });
            //   this.setState({ querySuccess: false });
            //   return;
            // }

            this.setDowntimeState(updateEvent)
              .then((apiResponse) => {
                const { result, tmsResult, jobResult } = apiResponse;
                const jobChanged = notifyJobResults(jobResult);
                if (result) {
                  this.handleUpdateMachineState([updateEvent]);
                  this.setState({
                    querySuccess: false,
                    modelState: false,
                    selectedBreakdownType: "",
                    selectdeReason: { InitiateBreakdown: true },
                    breakdownData: null,
                    selectedReason: {},
                    Split: [],
                    Entrytype: 'Normal',
                  });
                  swal(`Downtime reason updated successfully${tmsResult && tmsResult !== "" ? `, and ${tmsResult}` : ""}.`);
                } else {
                  this.handleUpdateMachineState([updateEvent]);
                  this.setState({ querySuccess: false, modelState: false });
                  swal("Not Update Some Internal Error");
                }
                if (jobChanged) this.handleClickOK(this.state.inputData);
              })
              .catch((err) => {
                this.setState({ querySuccess: false });
                toast.success(`${err}`, {
                  position: "bottom-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  style: {
                    background: "red", // Set your desired background color
                    color: "white", // Set your desired text color
                  },
                });
              });
          } else {
            swal("please select reason", { dangerMode: true });
          }
        }
      }

      if (this.state.entryType.Multiple && !isRunningUpdate) {

        // Prevent selection of Open Breakdown reasons for Multiple entry type
        if (this.checkReasonIsOpenBreakdown(this.state.selectdeReason.Reason)) {
          swal({
            title: "Invalid Selection",
            text: "Open Breakdown reasons cannot be selected when entering multiple downtime entries. Please select a different reason or use Single entry mode.",
            icon: "warning",
            button: "OK"
          });
          this.setState({ querySuccess: false });
          return;
        }

        let arr = [];
        this.setState({ querySuccess: true });
        updateEventMultiple.forEach((one) => {
          let filterMac;
          this.state.states.filter((obj) => {
            if (obj.Equipment == one[0]) {
              filterMac = obj.ListOfEvents.filter((one1) => {
                if (
                  new Date(one[4]).getTime() == new Date(one1.From).getTime() &&
                  new Date(one[5]).getTime() == new Date(one1.Till).getTime()
                ) {
                  return one;
                }
              });
            }
          });
          let obj = {
            old: {
              Shift: filterMac[0].Shift,
              Equipment: one[0],
              State: one[1],
              From: one[4],
              Till: one[5],
            },
            new: {
              Equipment: one[0],
              Remarks: this.state.selectdeReason.Remarks,
              EndCurrentJob: this.state.selectdeReason.EndCurrentJob,
              Reason: this.state.selectdeReason.Reason,
              ReasonGroup: this.state.selectdeReason.ReasonGroup,
              From: one[4],
              Till: one[5],
            },
          };
          arr.push(obj);
        });
        axios
          .patch(api.dataEntryUrl + "multipleDowntime", { DowntimeArray: arr })
          .then((result) => {
            const jobChanged = notifyMultipleJobResults(result.data);
            if (result.data == "Update") {
              this.setState({ querySuccess: false, modelState: false });
              this.handleUpdateMachineState(updateEventMultiple);
              swal("All Reasons Update Successfully");
            } else {
              this.setState({ querySuccess: false, modelState: false });
              this.handleUpdateMachineState(updateEventMultiple);
              swal("All Reasons Update Successfully");
            }
            if (jobChanged) this.handleClickOK(this.state.inputData);
          })

          .catch((err) => {
            this.setState({ querySuccess: false });
            toast.success(`${err}`, {
              position: "bottom-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: "red", // Set your desired background color
                color: "white", // Set your desired text color
              },
            });
          });
      }
    }
  };
  setDowntimeState1 = async (updateEvent, newObj) => {
    try {
      this.setState({ querySuccess: true });

      const newArray = [];
      let filterMac;
      this.state.states.filter((obj) => {
        if (obj.Equipment == updateEvent[0]) {
          filterMac = obj.ListOfEvents.filter((one) => {
            if (
              new Date(updateEvent[4]).getTime() ==
              new Date(one.From).getTime() &&
              new Date(updateEvent[5]).getTime() == new Date(one.Till).getTime()
            ) {
              return one;
            }
          });
        }
      });
      for (const one of this.state.Split) {
        // Create deep copies of updateEvent to avoid modifying state directly
        newArray.push({
          actionTaken: one.DowntimeReason?.actionTaken ?? "",
          Shift: filterMac[0].Shift,
          Equipment: one.Equips[0].EquipmentID,
          Remarks: one.DowntimeReason?.Remarks ?? "",
          Reason: one.DowntimeReason?.Reason,
          EndCurrentJob: one?.EndCurrentJob ?? false,
          ReasonGroup: one.DowntimeReason?.ReasonGroup,
          From: new Date(one.from),
          Till: new Date(one.till),
        });
      }
      const response = await axios.patch(
        api.dataEntryUrl + "split-multiple-downtimes",
        {
          old: {
            Shift: filterMac[0].Shift,
            Equipment: updateEvent[0],
            State: updateEvent[1],
            From: updateEvent[4],
            Till: updateEvent[5],
          },
          new: newArray,
        }
      );

      const { n, nModified, ok } = response.data;
      if (response.data === "Downtime update successful") {
        this.handelupdate(true, [{ Equipment: updateEvent[0] }]);
      }
      if (n === 1 && nModified === 1 && ok === 1) {
        this.setState({ querySuccess: false });
        return "Update";
      } else {
        this.setState({ querySuccess: false });
        return "NotUpdate";
      }
    } catch (error) {
      this.setState({ querySuccess: false });
      const errorMessage =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred while splitting the downtime.";
      swal({
        title: "Unable to Split Downtime",
        text: errorMessage,
        icon: "error",
        dangerMode: true,
      });
      throw error; // Rethrow error for proper handling
    }
  };
  setDowntimeState = (updateEvent) => {
    let filterMac;
    return new Promise((resolve, reject) => {
      this.state.states.filter((obj) => {
        if (obj.Equipment == updateEvent[0]) {
          filterMac = obj.ListOfEvents.filter((one) => {
            if (
              new Date(updateEvent[4]).getTime() ==
              new Date(one.From).getTime() &&
              new Date(updateEvent[5]).getTime() == new Date(one.Till).getTime()
            ) {
              return one;
            }
          });
        }
      });
      let InitiateBreakdown = _.cloneDeep(this.state.selectdeReason).InitiateBreakdown
      if (this.checkReasonIsOpenBreakdown(this.state.selectdeReason.Reason) && InitiateBreakdown) {
        if (!this.isBreakdownTypeEditingHidden(this.state.selectdeReason.Reason)) {
          if (!this.state.selectdeReason.BreakdownType) {
            swal("Please select Breakdown Type when initiating breakdown.", { dangerMode: true })
            this.setState({ querySuccess: false })
            return
          }
          if (this.state.selectdeReason.BreakdownType == "Others") {
            swal("Please enter breakdown type for initiating breakdown in TMS.", { dangerMode: true })
            this.setState({ querySuccess: false })
            return
          }
          if (!this.state.selectdeReason.BreakdownDesc) {
            this.setState({ querySuccess: false })
            swal("Please enter breakdown description to initiate breakdown in TMS.", { dangerMode: true })
            return
          }
        }
      } else {
        InitiateBreakdown = false;
      }
      axios
        .patch(api.dataEntryUrl + "downtime", {
          old: {
            Shift: filterMac[0].Shift,
            Equipment: updateEvent[0],
            State: updateEvent[1],
            From: updateEvent[4],
            Till: updateEvent[5],
          },
          new: {
            actionTaken: this.state.selectdeReason.actionTaken,
            InitiateBreakdown: InitiateBreakdown,
            ...this.getBreakdownFieldsForPayload(this.state.selectdeReason.Reason, this.state.selectdeReason, this.state.selectedReason.Remarks),
            TransferTypeTool: this.state.selectdeReason.TransferTypeTool,
            IsTransferTool: this.state.transferTypeTools.length > 0 ? true : false,
            Shift: filterMac[0].Shift,
            Equipment: updateEvent[0],
            Remarks: this.state.selectedReason.Remarks,
            Reason: this.state.selectedReason.Reason,
            EndCurrentJob: this.state.selectedReason.EndCurrentJob,
            ReasonGroup: this.state.selectedReason.ReasonGroup,
            From: updateEvent[4],
            Till: updateEvent[5],
          },
        })
        .then((downtimeEntryResult) => {
          resolve(downtimeEntryResult.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  handleOnChangeReasonGroup = async (e, type, idx) => {
    // console.log(e.currentTarget, type, idx, "kdfgvkdfvk");
    const selectdeReason = { ...this.state.selectdeReason };
    const reasonSplitGroupList = [...this.state.reasonSplitGroupList];
    let obj = JSON.parse(e.currentTarget.value);
    selectdeReason[e.currentTarget.name] = obj.DownTimeReasonGroup;
    let downtimeReasons = await axios.put(api.dataEntryUrl + "downtimereason", {
      ReasonGroup: obj._id,
    });
    selectdeReason["Reason"] = downtimeReasons.data.length > 0 ? downtimeReasons.data[0].Reason : "";
    if (type === "Split") {
      const { Split } = this.state;
      const data = [...Split];


      data[idx]['DowntimeReason'] = selectdeReason
      if (downtimeReasons && downtimeReasons.data && downtimeReasons.data[0].enableActionTaken) {
        data[idx]['DowntimeReason']['ActionTakenForReason'] = true;

      } else {
        data[idx]['DowntimeReason']['ActionTakenForReason'] = false;

      }

      reasonSplitGroupList[idx] = { selectdeReason, ReasonList: downtimeReasons.data }


      this.setState({
        Split: data,
        reasonSplitGroupList
      });
    } {



      const errors = validation.validate(selectdeReason, this.schemaForModel);
      // console.log(errors, "vfdudfub", idx);
      this.setState({ errors: errors || {} });
      if (errors) return;

      if (
        downtimeReasons &&
        Array.isArray(downtimeReasons.data) &&
        downtimeReasons.data.length > 0 &&
        typeof downtimeReasons.data[0].enableActionTaken === 'boolean'
      ) {
        this.setState({ ActionTakenForReason: downtimeReasons.data[0].enableActionTaken });
      } else {
        this.setState({ ActionTakenForReason: false });
      }

      this.setState({
        reasonList: downtimeReasons.data,
        selectdeReason: selectdeReason,
        selectedReason: selectdeReason,

        errors: errors || {},
      });
    }
  };
  handleUpdateMachineState = (downtimeArr) => {
    this.setState({ querySuccess: true });
    const { selectedReason, machineStates } = { ...this.state };
    downtimeArr.forEach((downtime, index) => {
      let oneEquipMacState = machineStates.filter(
        (one) => one.Equipment == downtime[0]
      );
      if (oneEquipMacState.length > 0) {
        if (
          machineStates.filter((one) => one.Equipment == downtime[0])[0]
            .ListOfEvents.length > 0
        ) {
          let filterState = machineStates
            .filter((one) => one.Equipment == downtime[0])[0]
            .ListOfEvents.filter((oneMac) => {
              if (
                new Date(oneMac.From).getTime() ==
                new Date(downtime[4]).getTime() &&
                new Date(oneMac.Till).getTime() ==
                new Date(downtime[5]).getTime()
              ) {
                return oneMac;
              }
            });

          // return

          if (filterState.length > 0) {
            machineStates
              .filter((one) => one.Equipment == downtime[0])[0]
              .ListOfEvents.filter(
                (oneMac) =>
                  new Date(oneMac.From).getTime() ==
                  new Date(downtime[4]).getTime() &&
                  new Date(oneMac.Till).getTime() ==
                  new Date(downtime[5]).getTime()
              )[0].State = selectedReason.Reason;
            machineStates
              .filter((one) => one.Equipment == downtime[0])[0]
              .ListOfEvents.filter(
                (oneMac) =>
                  new Date(oneMac.From).getTime() ==
                  new Date(downtime[4]).getTime() &&
                  new Date(oneMac.Till).getTime() ==
                  new Date(downtime[5]).getTime()
              )[0].Color = selectedReason.Color;
            machineStates
              .filter((one) => one.Equipment == downtime[0])[0]
              .ListOfEvents.filter(
                (oneMac) =>
                  new Date(oneMac.From).getTime() ==
                  new Date(downtime[4]).getTime() &&
                  new Date(oneMac.Till).getTime() ==
                  new Date(downtime[5]).getTime()
              )[0].DowntimeReason = selectedReason.Reason;
            machineStates
              .filter((one) => one.Equipment == downtime[0])[0]
              .ListOfEvents.filter(
                (oneMac) =>
                  new Date(oneMac.From).getTime() ==
                  new Date(downtime[4]).getTime() &&
                  new Date(oneMac.Till).getTime() ==
                  new Date(downtime[5]).getTime()
              )[0].DowntimeGroup = selectedReason.ReasonGroup;
            machineStates
              .filter((one) => one.Equipment == downtime[0])[0]
              .ListOfEvents.filter(
                (oneMac) =>
                  new Date(oneMac.From).getTime() ==
                  new Date(downtime[4]).getTime() &&
                  new Date(oneMac.Till).getTime() ==
                  new Date(downtime[5]).getTime()
              )[0].Remarks = selectedReason.Remarks
                ? selectedReason.Remarks
                : null;
          }
        }
      }
    });
    this.setState({
      machineStates: machineStates,
      querySuccess: false,
      updateEventMultiple: [],
    });
  };

  handleSplitTimeChange = (e, idx, type, time) => {
    const data = [...this.state.Split];
    const selectedTime = e.currentTarget.value; // Example: "14:30"

    //  Get the date from the existing split's 'from' or 'till' field
    const baseDate = new Date(
      data[idx][type === "from" ? "till" : "from"] || data[idx][type]
    );
    if (isNaN(baseDate)) {
      swal("Invalid base date for time update.");
      return;
    }

    const [hours, minutes] = selectedTime.split(":").map(Number);

    const updatedDate = new Date(
      baseDate.getFullYear(),
      baseDate.getMonth(),
      baseDate.getDate(),
      hours,
      minutes
    );

    // ✅ Ensure 'till' is after 'from'
    if (
      type === "till" &&
      updatedDate.getTime() <= new Date(data[idx]?.from)?.getTime()
    ) {
      swal("The 'till' time must be greater than the 'from' time.");
      return;
    }

    // ✅ Update selected time (always in local format)
    data[idx][type] = updatedDate.toISOString();

    // ✅ If 'till' is updated, sync next split's 'from'
    if (type === "till" && idx + 1 < data.length) {
      data[idx + 1]["from"] = updatedDate.toISOString();
    }

    // ✅ Every slice needs a positive duration (the equipment threshold is not applied here)
    const allSlicesValid = data.every((split) => {
      const fromTime = new Date(split?.from)?.getTime();
      const tillTime = new Date(split?.till)?.getTime();

      return !!fromTime && !!tillTime && tillTime > fromTime;
    });

    if (!allSlicesValid) {
      // this.setState({ SplitError: true });
      swal(
        "Cannot split. Each downtime reason's 'Till' time must be after its 'From' time."
      );
      return;
    }

    // ✅ Update state
    this.setState({ Split: data, SplitError: false });
  };

  handleTabChange = (activeKey) => {
    const { selectedEquipment, updateEvent, noOfReasons } = this.state;
    // console.log("Active Tab:", activeKey);
    // Call your desired function here
    if (activeKey === "1") {
      // console.log("Single Downtime Reason tab selected");
      // Call specific function for this tab
      this.setState({
        Entrytype: "Normal",
        selectdeReason: {},
        selectedReason: {},
        Split: [],
        SplitError: false,
        reasonSplitGroupList: [],
      });
    } else if (activeKey === "2") {
      this.setState({
        Split: this.generateSplits(
          updateEvent[4],
          updateEvent[5],
          noOfReasons - 1,
          selectedEquipment
        ),

        Entrytype: "Split",
        selectdeReason: {},
        selectedReason: {},
        reasonSplitGroupList: [],
      });
      // console.log("Multiple Downtime Reason tab selected");
      // Call specific function for this tab
    }
  };
  // Slices are not held to the equipment's DownTimeThresold: that threshold decides what the
  // system records as downtime, and a downtime shorter than it must still be splittable.
  generateSplits = (from, till, splitCount, Equipment) => {
    if (!from || !till || splitCount <= 0) {
      throw new Error(
        "Invalid inputs. Please provide valid from, till, and splitCount."
      );
    }

    const fromTime = moment(from);
    const tillTime = moment(till);

    if (
      !fromTime.isValid() ||
      !tillTime.isValid() ||
      fromTime.isSameOrAfter(tillTime)
    ) {
      swal(
        "Cannot find Split. The 'from' time must be before the 'till' time."
      );
      throw new Error("Invalid date range. Ensure 'from' is before 'till'.");
    }

    const durationMs = tillTime.diff(fromTime, "milliseconds");
    const intervalMs = durationMs / (splitCount + 1);

    const splits = [];
    let currentStart = fromTime.clone();

    for (let i = 0; i <= splitCount; i++) {
      // The last slice ends exactly on the original 'till' so rounding never leaves a gap.
      const nextSplit = i === splitCount
        ? tillTime.clone()
        : currentStart.clone().add(intervalMs, "milliseconds");

      // Ensure both start and end of split are on the same day as the original 'from'
      const sameDayStart = currentStart.isSame(fromTime, "day");
      const sameDayEnd = nextSplit.isSame(fromTime, "day");

      if (sameDayStart && sameDayEnd) {
        // Full precision (not minute-truncated): a downtime shorter than a couple of minutes
        // would otherwise produce slices whose 'from' lands after their 'till'.
        splits.push({
          from: currentStart.toISOString(),
          till: nextSplit.toISOString(),
          differenceInSeconds: nextSplit.diff(currentStart, "seconds"),
          Equips: [Equipment],
        });
      } else {
        console.warn(
          "Skipped split due to crossing date.",
          {
            currentStart: currentStart.toString(),
            nextSplit: nextSplit.toString(),
          }
        );
      }

      currentStart = nextSplit.clone();
    }

    return splits;
  };

  handleOnChangeBreakdownInitiate = (e) => {
    const obj = { ...this.state.selectdeReason };
    obj[e.currentTarget.name] = e.currentTarget.checked;
    this.setState({ selectdeReason: obj });

  }

  handleOnChangeTransferType = (e) => {
    const obj = { ...this.state.selectdeReason };
    obj[e.currentTarget.name] = e.currentTarget.value;
    this.setState({ selectdeReason: obj });
  }

  getTabs = (event) => {
    if (this.getSystemState(event) == "Running") {
      if (this.state.radioStateSingle == "Running") {
        return []
      } else {
        return [
          "Single Downtime Reason",
        ]
      }

    } else {
      return [
        "Single Downtime Reason",
        "Multiple Downtime Reason",
      ]
    }


  }
  handleOnChangeRemarks = (e, type, idx) => {
    if (type === "Split") {
      const { Split } = this.state;
      const data = [...Split];
      if (e.currentTarget.name == "EndCurrentJob") {
        data[idx][e.currentTarget.name] = e.currentTarget.checked;
      } else {
        data[idx]["DowntimeReason"][e.currentTarget.name] =
          e.currentTarget.value;
      }
      this.setState({ Split: data });
    } else {
      const selectedReason = { ...this.state.selectedReason };
      const selectdeReason = { ...this.state.selectdeReason };
      if (e.currentTarget.name == "EndCurrentJob") {
        selectedReason[e.currentTarget.name] = e.currentTarget.checked;
        selectdeReason[e.currentTarget.name] = e.currentTarget.checked;
      } else {
        selectedReason[e.currentTarget.name] = e.currentTarget.value;
        selectdeReason[e.currentTarget.name] = e.currentTarget.value;
      }
      this.setState({
        selectedReason: selectedReason,
        selectdeReason: selectdeReason,
      });
    }
  };

  handleSubmitUserRights = (userRightsUpdate) => {
    const userRights = this.state.userRights;
    if (!userRights?._id || !userRightsUpdate?._id) {
      return;
    }
    const isFavourite = !userRightsUpdate.isFavourite;

    // Only the one flag is sent. PATCHing the whole rights document from here
    // would push back the copy this tab loaded at mount, undoing any rights
    // change made elsewhere since — and the same pattern on the rights screens
    // is what used to wipe the favourite again on the next save.
    axios
      .patch(api.dataEntryUrl + "userrights/" + userRights._id + "/favourite", {
        ReportId: userRightsUpdate._id,
        isFavourite,
      })
      .then((result) => {
        if (result.status === 200) {
          // The report objects in state.reports / state.favouriteReport are the
          // same references held in userRights.ReportRights, so updating them
          // here keeps both lists and the stars in sync.
          userRightsUpdate.isFavourite = isFavourite;
          (userRights.ReportRights || []).forEach((one) => {
            if (one._id == userRightsUpdate._id) {
              one.isFavourite = isFavourite;
            }
          });
          const isFavourate = (userRights.ReportRights || []).filter(
            (one) => one.enable && one.isFavourite
          );
          this.setState({
            userRights: userRights,
            favouriteReport: isFavourate,
          });
          if (isFavourite === false) {
            toast.success(
              `${userRightsUpdate.data} : is removed from favourate`,
              {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: {
                  background: "red", // Set your desired background color
                  color: "white", // Set your desired text color
                },
              }
            );
          } else {
            toast.success(`${userRightsUpdate.data} : is added to favourate`, {
              position: "bottom-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: "green", // Set your desired background color
                color: "white", // Set your desired text color
              },
            });
          }

          // swal("User Rights Update Successfully");
        } else {
          swal(`${result.statusText}`);
        }
      })
      .catch((err) => {
        this.setState({ querySuccess: false });
        toast.success(`${err}`, {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            background: "red", // Set your desired background color
            color: "white", // Set your desired text color
          },
        });
      });
  };

  render() {
    const user = auth.getCurrentUser();
    const { handleUserRightsToVisibleOrNot } = this;
    const { getSystemState } = this;
    const carouselItems = this.getCarouselItems(user);

    const {
      radioStateSingle,
      updateEvent,
      modelState,
      reasonGroupList,
      machineStates,
      reasonList,
      EnableDataEntry,
      countdown,
      updateEventMultiple,
      transferTypeTools,
      actionTakenList,
      HideDownTimeGroup,
    } = this.state;
    const {
      errors,
      shiftSetting,
      querySuccess,
      noOfReasons,
      CycleRun,
      Split,
      company,
      modelStateJob,
      updateEventJobs,
      modelStateAdd,
      selectedEquipment,
      reasonSplitGroupList,
      ActionTakenForReason
    } = this.state;
    const { getRightsForAccess } = this.props;
    const isRunningAndCannotConvert = getSystemState(updateEvent, machineStates) === "Running" && !company?.canConvertRunningToDown;
    const settingsMenuItems = [
      handleUserRightsToVisibleOrNot("StaticDataRights", "UserMaster", "read")
        ? {
          id: "settings-user",
          label: "User",
          children: [
            {
              id: "settings-user-list",
              label: "User",
              path: "/setting/user/list",
            },
            {
              id: "settings-user-group",
              label: "User Group",
              path: "/setting/usergroup/list",
            },
            {
              id: "settings-user-rights",
              label: "User Rights",
              path: "/setting/userrights/list",
            },
            {
              id: "settings-user-rights-manager",
              label: "User Rights Manager",
              path: "/setting/UserRightsManager",
            },
          ],
        }
        : null,
      handleUserRightsToVisibleOrNot(
        "StaticDataRights",
        "Employee Master",
        "read"
      ) &&
        this.state.company &&
        this.state.company.allowSecondaryEmployees
        ? {
          id: "settings-employee",
          label: "Employee",
          children: [
            {
              id: "settings-employee-master",
              label: "Employee Master",
              path: "/setting/employee/list",
            },
            {
              id: "settings-employee-role",
              label: "Employee Role",
              path: "/setting/employeerole/list",
            },
          ],
        }
        : null,
      (() => {
        const equipmentChildren = [
          ...(handleUserRightsToVisibleOrNot(
            "StaticDataRights",
            "EquipmentMaster",
            "read"
          )
            ? [
              {
                id: "settings-equipment-list",
                label: "Equipment",
                path: "/setting/equipment/list",
              },
              {
                id: "settings-equipment-group",
                label: "Equipment Group",
                path: "/setting/equipmentgroup/list",
              },
              {
                id: "settings-equipment-type",
                label: "Equipment Type",
                path: "/setting/equipmenttype/list",
              },
              {
                id: "settings-equipment-location",
                label: "Equipment Location",
                path: "/setting/equipmentlocation/list",
              },
              {
                id: "settings-equipment-model",
                label: "Equipment Model",
                path: "/setting/equipmentmodel/list",
              },
              {
                id: "settings-equipment-cutomegroup",
                label: "Custom Equipment Group",
                path: "/setting/customequipmentgroup/list",
              },
            ]
            : []),
          ...(handleUserRightsToVisibleOrNot(
            "StaticDataRights",
            "EquipmentHourlyRate",
            "read"
          )
            ? [
              {
                id: "settings-equipment-hourly-rate",
                label: "Equipment Hourly Rate",
                path: "/setting/equipmenthourlyrate/list",
              },
            ]
            : []),
          // Relay Templates and Condition Master live under Equipment and are
          // gated by the same EquipmentMaster rights the Equipment screens use.
          ...(handleUserRightsToVisibleOrNot(
            "StaticDataRights",
            "EquipmentMaster",
            "read"
          )
            ? [
              {
                id: "settings-relay-templates",
                label: "Relay Templates",
                path: "/setting/relay-templates",
              },
              {
                id: "settings-condition-master",
                label: "Condition Master",
                path: "/setting/conditions",
              },
            ]
            : []),
        ];
        return equipmentChildren.length
          ? {
            id: "settings-equipment",
            label: "Equipment",
            children: equipmentChildren,
          }
          : null;
      })(),
      handleUserRightsToVisibleOrNot(
        "StaticDataRights",
        "DowntimeMaster",
        "read"
      )
        ? {
          id: "settings-downtime",
          label: "Downtime",
          children: [
            {
              id: "settings-downtime-reason",
              label: "Downtime Reason",
              path: "/setting/downtimereason/list",
            },
            {
              id: "settings-downtime-reason-group",
              label: "Downtime Reason Group",
              path: "/setting/downtimereasongroup/list",
            },
            {
              id: "settings-downtime-action-taken",
              label: "Action Taken",
              path: "/setting/ActionTakenMaster",
            },
          ],
        }
        : null,
      handleUserRightsToVisibleOrNot(
        "StaticDataRights",
        "QualityMaster",
        "read"
      )
        ? {
          id: "settings-quality",
          label: "Quality",
          children: [
            {
              id: "settings-quality-reason",
              label: "Rejection Reason",
              path: "/setting/qualityreason/list",
            },
            {
              id: "settings-quality-reason-group",
              label: "Rejection Reason Group",
              path: "/setting/qualityreasongroup/list",
            },
            {
              id: "settings-quality-stage",
              label: "Rejection Stage",
              path: "/setting/rejectionstage/list",
            },
          ],
        }
        : null,
      handleUserRightsToVisibleOrNot(
        "StaticDataRights",
        "OperatorMaster",
        "read"
      )
        ? {
          id: "settings-operator-master",
          label: "Operator Master",
          path: "/setting/operatormaster/list",
        }
        : null,
      (() => {
        const componentChildren = [
          ...(handleUserRightsToVisibleOrNot(
            "StaticDataRights",
            "ComponentMaster",
            "read"
          )
            ? [
              {
                id: "settings-component-master",
                label: "Component Master",
                path: "/setting/component/list",
              },
            ]
            : []),
          ...(handleUserRightsToVisibleOrNot(
            "StaticDataRights",
            "OperationMaster",
            "read"
          )
            ? [
              {
                id: "settings-operation-master",
                label: "Operation Master",
                path: "/setting/operation/list",
              },
            ]
            : []),
          ...(handleUserRightsToVisibleOrNot(
            "StaticDataRights",
            "ComponentMaster",
            "update"
          ) &&
            handleUserRightsToVisibleOrNot(
              "StaticDataRights",
              "EquipmentMaster",
              "update"
            )
            ? [
              {
                id: "settings-machine-component-mapped",
                label: "Machine X Component Mapped",
                path: "/reporting/Component_Machine_Matrix",
              },
            ]
            : []),
          ...(handleUserRightsToVisibleOrNot(
            "StaticDataRights",
            "ComponentMaster",
            "read"
          )
            ? [
              {
                id: "settings-raw-material-master",
                label: "Raw Material Master",
                path: "/setting/rawmaterial/list",
              },
            ]
            : []),
        ];
        return componentChildren.length
          ? {
            id: "settings-component",
            label: "Component",
            children: componentChildren,
          }
          : null;
      })(),
      (() => {
        const toolChildren = [
          ...(handleUserRightsToVisibleOrNot(
            "StaticDataRights",
            "ToolMaster",
            "read"
          )
            ? [
              {
                id: "settings-tool-master",
                label: "Tool Master",
                path: "/setting/toolmaster/list",
              },
            ]
            : []),
          ...(handleUserRightsToVisibleOrNot(
            "StaticDataRights",
            "ToolMaster",
            "read"
          )
            ? [
              {
                id: "settings-machine-tool-mapped",
                label: "Machine X Tool Mapped",
                path: "/setting/TableMatrix",
              },
            ]
            : []),
          ...(handleUserRightsToVisibleOrNot(
            "StaticDataRights",
            "OperatorMaster",
            "read"
          )
            ? [
              {
                id: "settings-cavity-loss-reason",
                label: "Cavity Loss Reason",
                path: "/setting/partspercyclereason/list",
              },
            ]
            : []),
        ];
        return toolChildren.length
          ? {
            id: "settings-tool",
            label: "Tool",
            children: toolChildren,
          }
          : null;
      })(),
      // Shown for the Shift or the Secondary Shift right (the latter only while the company allows it).
      visibleShiftTypes(this.state.company, handleUserRightsToVisibleOrNot).length > 0
        ? {
          id: "settings-shift-management",
          label: "Shift Management",
          path: "/setting/shiftManagement",
        }
        : null,
      handleUserRightsToVisibleOrNot(
        "StaticDataRights",
        "CustomerMaster",
        "read"
      )
        ? {
          id: "settings-customer-master",
          label: "Customer Master",
          path: "/setting/customer/list",
        }
        : null,
      user && user.userType == "admin"
        ? {
          id: "settings-company",
          label: "Company Settings",
          path: "/setting/CompanySetting",
        }
        : null,
      this.state.company &&
        this.state.company.enableProjectPlanning &&
        handleUserRightsToVisibleOrNot(
          "StaticDataRights",
          "Project Master",
          "read"
        )
        ? {
          id: "settings-project-planning",
          label: "Project Planning",
          path: "/setting/projectplanning/view",
        }
        : null,
      this.state.company &&
        this.state.company.allowProcessParameter &&
        handleUserRightsToVisibleOrNot(
          "StaticDataRights",
          "Process Parameter Config",
          "read"
        )
        ? {
          id: "settings-process-parameter-config",
          label: "Process Parameter Config",
          path: "/setting/process-parameter-config",
        }
        : null,
    ];
    // const lazyComponent=React.lazy(()=>import("../User/Setting/Equipment/Equipment"))
    // // consol("lazyComponent")import UserComponent from './../Admin/User/UserComponent';
    // consol(lazyComponent)
    return (
      <>
        {/* {({ ref, onRequest, onExit }) => (
        <div
          ref={ref}
          style={{background:'white'}}
        > */}
        <div
          style={{ height: "100vh", overflow: "hidden" }}
          className="wrapper"
        >
          {this.handleAutoScrollSettingForOpPerfBoard()}
          {this.handleAutoScrollSetting()}
          {this.state.querySuccess ? <Loading /> : ""}
          <ChangePassword
            handleClose={this.handleCloseChnagePassword}
            modelState={this.state.chnagePasswordModelState}
            user={this.state.chnagePasswordUserData}
            userData={user ? user : ""}
          />
          <ToastContainer />
          {handleUserRightsToVisibleOrNot("StaticDataRights", "LeafnetBot", "read") &&
          !this.props.location.pathname.startsWith("/leafnet-bot") ? (
            <React.Suspense fallback={null}>
              {/* Re-keyed after a plant switch (assistantEpoch): a fresh conversation for the new plant. */}
              <PlantAssistantWidget
                key={`assistant-${this.state.assistantEpoch || 0}`}
                onOpenPage={() => {
                  this.props.history.push("/leafnet-bot");
                  this.setState({ navSelected: "/leafnet-bot" });
                }}
                onOpenReports={
                  REPORTS_ENABLED
                    ? () => {
                        this.props.history.push("/leafnet-bot/reports");
                        this.setState({ navSelected: "/leafnet-bot/reports" });
                      }
                    : undefined
                }
              />
            </React.Suspense>
          ) : null}

          <nav
            id="sidebar"
            style={{
              height: "100vh",
              overflowY: "auto",
              position: "relative",
            }}
            className={this.state.toggle ? "" : "active"}
          >
            <button
              onClick={this.handleToggleClick}
              className="ln-sb-collapse"
              aria-label="Collapse sidebar"
              style={{
                position: "absolute",
                top: "20px",
                right: "0",
                background: "#fff",
                border: "1px solid #d1d5db",
                borderRadius: "8px 0 0 8px",
                width: "16px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                color: "#002b49",
                zIndex: 10,
                boxShadow: "-2px 0 4px rgba(0,0,0,0.1)",
              }}
            >
              <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: "10px" }} />
            </button>
            <div
              className="sidebar-header"
              style={{
                padding: "24px 20px 18px",
                background: "linear-gradient(135deg, #0f2027 0%, #1e3a5f 55%, #2d6aa0 100%)",
                borderBottom: "1px solid rgba(255,255,255,0.08)",
              }}
            >
              {/* New UI only (hidden in classic by theme/newUi.css). */}
              <div className="ln-sb-brand">
                <LeafNetLogo size={34} title="LeafNet" />
                <span className="ln-sb-brand-name" aria-hidden="true">LEAFNET</span>
              </div>
              <div
                className="ln-sb-company"
                style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}
              >
                {this.state.company.logo && (
                  <img
                    src={this.state.company.logo}
                    className="avatar"
                    style={{
                      borderRadius: 8,
                      width: 150,
                      backgroundColor: "white",
                      objectFit: "contain",
                    }}
                  />
                )}
                <Text
                  strong
                  className="text-white text-center"
                  style={{ fontSize: 20, letterSpacing: 0.4, lineHeight: 1.3 }}
                >
                  {user && user.company ? user.company.toUpperCase() : ""}
                </Text>

                {this.state.Plant && jwtDecode(auth.getJwt())?.Plants && (
                  <Select
                    size="small"
                    value={this.state.Plant}
                    onChange={(value) => this.handleOnChange({ target: { name: 'Plant', value } })}
                    style={{ width: 190 }}
                    placeholder="Select Plant"
                    className="sidebar-plant-select"
                  >
                    {jwtDecode(auth.getJwt()).Plants.map((one) => (
                      <Option key={one.company} value={one.company}>
                        {one.company}
                      </Option>
                    ))}
                  </Select>
                )}
              </div>

              <div
                className="ln-sb-user"
                style={{
                  marginTop: 18,
                  padding: "12px 14px",
                  borderRadius: 10,
                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.1)",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                  <span
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.12)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <FontAwesomeIcon icon={faUser} style={{ color: "#fff", fontSize: 13 }} />
                  </span>
                  <div style={{ overflow: "hidden" }}>
                    <div
                      className="text-white"
                      style={{ fontSize: 13, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                      {user ? user.name : ""}
                    </div>
                    <div style={{ fontSize: 11, color: "rgba(255,255,255,0.6)", fontStyle: "italic" }}>
                      {user ? user.userType : ""}
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", gap: 8 }}>
                  <a
                    onClick={() => this.handleUserChangePassword()}
                    className="ln-sb-userbtn"
                    style={{
                      flex: 1,
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 6,
                      padding: "7px 10px",
                      borderRadius: 6,
                      background: "rgba(255,255,255,0.1)",
                      border: "1px solid rgba(255,255,255,0.18)",
                      color: "#fff",
                      fontSize: 12,
                      fontWeight: 600,
                      cursor: "pointer",
                      transition: "background 0.15s ease",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.18)")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.1)")}
                  >
                    <FontAwesomeIcon icon={faKey} style={{ fontSize: 11 }} />
                    Password
                  </a>
                  <a
                    onClick={() => {
                      auth.logout(user.email);
                      window.location = "/";
                    }}
                    className="ln-sb-logout"
                    style={{
                      flex: 1,
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 6,
                      padding: "7px 10px",
                      borderRadius: 6,
                      background: "linear-gradient(135deg, #dc2626, #ef4444)",
                      border: "none",
                      color: "#fff",
                      fontSize: 12,
                      fontWeight: 600,
                      cursor: "pointer",
                      boxShadow: "0 2px 6px rgba(220,38,38,0.35)",
                    }}
                  >
                    Logout
                    <FontAwesomeIcon icon={faSignOutAlt} style={{ fontSize: 11 }} />
                  </a>
                </div>
              </div>

              <UiModeSwitch />
            </div>

            <ul className="list-unstyled components" id="parent">
              <li style={{ padding: "10px 14px 6px", position: "relative" }}>
                <div style={{ position: "relative" }}>
                  <FontAwesomeIcon
                    icon={faSearch}
                    style={{
                      position: "absolute",
                      left: 12,
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "rgba(255,255,255,0.45)",
                      fontSize: 12,
                      pointerEvents: "none",
                    }}
                  />
                  <input
                    type="text"
                    placeholder="Search reports..."
                    value={this.state.reportSearchQuery}
                    onChange={this.handleReportSearch}
                    onFocus={() => this.setState({ reportSearchFocused: true })}
                    onBlur={() => setTimeout(() => this.setState({ reportSearchFocused: false }), 150)}
                    className="ln-sb-search"
                    style={{
                      width: "100%",
                      padding: "9px 12px 9px 34px",
                      borderRadius: 8,
                      border: "1px solid rgba(255,255,255,0.14)",
                      background: "rgba(255,255,255,0.06)",
                      color: "#fff",
                      fontSize: 13,
                      textAlign: "left",
                      outline: "none",
                    }}
                  />
                </div>
                {this.state.reportSearchResults.length > 0 && this.state.reportSearchFocused && (
                  <ul
                    className="ln-sb-search-results"
                    style={{
                      listStyle: "none",
                      padding: 6,
                      margin: "6px 0 0",
                      background: "#152a3a",
                      borderRadius: 8,
                      border: "1px solid rgba(255,255,255,0.14)",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.35)",
                      maxHeight: 220,
                      overflowY: "auto",
                      position: "absolute",
                      zIndex: 999,
                      left: -10,
                      width: "calc(100% + 6px)",
                    }}
                  >
                    {this.state.reportSearchResults.map((r, i) => (
                      <li
                        key={i}
                        style={{ padding: "7px 10px", borderRadius: 6, cursor: "pointer", fontSize: 13, color: "rgba(255,255,255,0.85)" }}
                        onMouseDown={(e) => {
                          e.preventDefault();
                          const route = r._type === "live"
                            ? (this.getNormalizedRoute(r.RouteName) || "/")
                            : `/reporting/${r.RouteName}`;
                          this.props.history.push(route);
                          this.setState({ reportSearchQuery: "", reportSearchResults: [], reportSearchFocused: false, activityDashboardState: false, andonDashboardState: false, cardDashboardState: false, macStateDashboardState: false });
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.08)")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                      >
                        {r.data || r.DisplayName}
                      </li>
                    ))}
                  </ul>
                )}
              </li>

              <li>
                <a
                  href="#live"
                  data-toggle="collapse"
                  aria-expanded="false"
                  aria-controls="reporting"
                  className="collapsed dropdown-toggle text-white"
                >
                  <FontAwesomeIcon icon={faTh} color="white" />
                  &nbsp;Live Reports
                </a>
                <ul
                  className="collapse list-unstyled"
                  id="live"
                  data-parent="#parent"
                >
                  {this.state.userRights &&
                    this.state.userRights.LiveReportRights &&
                    [...this.state.userRights.LiveReportRights]
                      .filter((item) => item.enable)
                      .sort((a, b) =>
                        this.getLiveReportDisplayName(a).localeCompare(
                          this.getLiveReportDisplayName(b)
                        )
                      )
                      .map((item, index) => (
                        <li key={index}>
                          <a
                            className="text-white"
                            href={item.RouteName}
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              const route = this.getNormalizedRoute(item.RouteName) || "/";
                              this.props.history.push(route);
                            }}
                          >
                            {this.getLiveReportDisplayName(item)}
                          </a>
                        </li>
                      ))}
                </ul>
              </li>
              <li>
                <a
                  href="#reporting"
                  data-toggle="collapse"
                  aria-expanded="false"
                  aria-controls="reporting"
                  className=" text-white collapsed dropdown-toggle text-white"
                >
                  <FontAwesomeIcon icon={faFile} color="white" />
                  &nbsp;Reporting
                </a>
                <ul
                  className="collapse list-unstyled"
                  id="reporting"
                  data-parent="#parent"
                >
                  {this.state.favouriteReport &&
                    this.state.favouriteReport.length > 0 && (
                      <li>
                        <a
                          href="#favourite"
                          data-toggle="collapse"
                          aria-expanded="false"
                          aria-controls="favourite"
                          className="text-white collapsed dropdown-toggle "
                          onClick={() => this.handleGroupClick("favourite")}
                        >
                          <FontAwesomeIcon
                            icon={faStar}
                            style={{
                              cursor: "pointer",
                              color: "gold",
                              fontSize: "13px",
                            }}
                          />
                          &nbsp;Favourite
                        </a>
                        <ul
                          className="collapse list-unstyled"
                          id={"favourite"}
                          data-parent="#favourite"
                        >
                          {this.state.favouriteReport
                            .sort((a, b) => a.data.localeCompare(b.data))
                            .map((one, index) => {
                              return (
                                <li
                                  key={one._id}
                                  id={"fav" + one._id}
                                  className="d-flex justify-content-between"
                                  style={{ cursor: "pointer" }}
                                >
                                  <a
                                    className="text-reset"
                                    href={`/reporting/${one.RouteName}`}
                                    style={{ cursor: "pointer", width: "90%" }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.props.history.push(
                                        `/reporting/${one.RouteName}`
                                      );
                                      const elements =
                                        document.querySelectorAll(
                                          "[id^='fav']"
                                        ); // Select all elements with id starting with 'fav'

                                      // Remove 'active' class from all elements
                                      elements.forEach((el) =>
                                        el.classList.remove("active")
                                      );

                                      // Add 'active' class only to the clicked element
                                      document
                                        .getElementById(`fav${one._id}`)
                                        .classList.add("active");

                                      this.setState({
                                        activityDashboardState: false,
                                        andonDashboardState: false,
                                        cardDashboardState: false,
                                        macStateDashboardState: false,
                                      });
                                    }}
                                  >
                                    {one.data}
                                  </a>

                                  <div
                                    style={{
                                      width: "10%",
                                      height: "35px", // Ensure a square container for proper centering
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        height: "48%",
                                        width: "1px",
                                        backgroundColor: "#9d9d9db3",
                                      }}
                                      className="mr-1"
                                    ></div>
                                    {one.isFavourite && one.isFavourite ? (
                                      <FontAwesomeIcon
                                        icon={faStar}
                                        onClick={() => {
                                          this.handleSubmitUserRights(one);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          color: "gold",
                                          fontSize: "13px",
                                        }}
                                      />
                                    ) : (
                                      <FontAwesomeIcon
                                        icon={faStar}
                                        onClick={() => {
                                          this.handleSubmitUserRights(one);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "13px",
                                        }}
                                      />
                                    )}
                                  </div>
                                </li>
                              );
                            })}
                        </ul>
                      </li>
                    )}
                  {this.state.reports
                    .sort((a, b) => a.ReportGroup && a.ReportGroup.localeCompare(b.ReportGroup))
                    .map((one, index) => {
                      return (
                        <li key={index}>
                          <a
                            href={`#${one.ReportGroup ? one.ReportGroup.replaceAll(/\s+/g, '') : ""}`}
                            onClick={() =>
                              this.handleGroupClick(one.ReportGroup)
                            }
                            data-toggle="collapse"
                            aria-expanded="false"
                            aria-controls={one.ReportGroup}
                            className="collapsed dropdown-toggle text-white"
                          >
                            <FontAwesomeIcon
                              icon={
                                this.state.reportGroupClick === one.ReportGroup
                                  ? faMinus
                                  : faPlus
                              }
                            />{" "}
                            {one.ReportGroup
                              ? one.ReportGroup.toUpperCase()
                              : ""}
                          </a>
                          <ul
                            className="collapse list-unstyled"
                            id={one.ReportGroup ? one.ReportGroup.replaceAll(/\s+/g, '') : ""}
                            data-parent="#reporting"
                          >
                            {one.Report.sort((a, b) =>
                              a.data.localeCompare(b.data)
                            ).map((one1, idx) => {

                              return (
                                <li
                                  key={one1._id}
                                  id={"report" + one1._id}
                                  className="d-flex "
                                  style={{ width: "100%" }}
                                >
                                  <a
                                    className="text-reset "
                                    href={`/reporting/${one1.RouteName}`}
                                    style={{
                                      cursor: "pointer",
                                      width: "90%",
                                      textDecoration: "none",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.props.history.push(
                                        `/reporting/${one1.RouteName}`
                                      );
                                      const elements =
                                        document.querySelectorAll(
                                          "[id^='report']"
                                        ); // Select all elements with id starting with 'report'

                                      // Remove 'active' class from all elements
                                      elements.forEach((el) =>
                                        el.classList.remove("active")
                                      );

                                      // Add 'active' class only to the clicked element
                                      document
                                        .getElementById(`report${one1._id}`)
                                        .classList.add("active");

                                      this.setState({
                                        activityDashboardState: false,
                                        andonDashboardState: false,
                                        cardDashboardState: false,
                                        macStateDashboardState: false,
                                      });
                                    }}
                                  // onClick={() => {

                                  //   this.setState({
                                  //     activityDashboardState: false,
                                  //     andonDashboardState: false,
                                  //     cardDashboardState: false,
                                  //     macStateDashboardState: false,
                                  //   });
                                  // }}
                                  >
                                    {one1.data}
                                  </a>
                                  <div
                                    style={{
                                      width: "10%",
                                      height: "35px", // Ensure a square container for proper centering
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        height: "48%",
                                        width: "1px",
                                        backgroundColor: "#9d9d9db3",
                                      }}
                                      className="mr-1"
                                    ></div>
                                    {one1.isFavourite ? (
                                      <FontAwesomeIcon
                                        icon={faStar}
                                        onClick={() => {
                                          this.handleSubmitUserRights(one1);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          color: "gold",
                                          fontSize: "13px",
                                        }}
                                      />
                                    ) : (
                                      <FontAwesomeIcon
                                        icon={faStar}
                                        onClick={() => {
                                          this.handleSubmitUserRights(one1);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "13px",
                                        }}
                                      />
                                    )}
                                  </div>
                                </li>
                              );
                            })}

                            {/* <li key="test_report">
                        <a className="text-white" href="#" style={{ cursor: 'pointer' }} onClick={() => { this.props.history.push(`/reporting/tool_production`); this.setState({ activityDashboardState: false, andonDashboardState: false, cardDashboardState: false, macStateDashboardState: false }) }}>Tool Production</a>
                      </li> */}
                          </ul>
                        </li>
                      );
                    })}

                  {/* <li>
                                                    <a href="/reporting/oee" style={{cursor:'pointer'}} onClick={(e)=>{ e.preventDefault(); this.props.history.push('/reporting/oee')}}>OEE</a>
                                                </li>
                                                <li>
                                                    <a href="/reporting/jobrun" style={{cursor:'pointer'}} onClick={(e)=>{ e.preventDefault(); this.props.history.push('/reporting/jobrun')}}>Job Runs</a>
                                                </li>

                                                <li>
                                                    <a href="/reporting/availability" style={{cursor:'pointer'}} onClick={(e)=>{ e.preventDefault(); this.props.history.push('/reporting/availability')}}>Availability</a>
                                                </li>
                                                <li>
                                                    <a href="/reporting/performance_bycomponent" style={{cursor:'pointer'}} onClick={(e)=>{ e.preventDefault(); this.props.history.push('/reporting/performance_bycomponent')}}>Performance Analysis By Component</a>
                                                </li>
                                                <li>
                                                    <a href="/reporting/performance_bymachine" style={{cursor:'pointer'}} onClick={(e)=>{ e.preventDefault(); this.props.history.push('/reporting/performance_bymachine')}}>Performance Analysis By Machine</a>
                                                </li>
                                                <li>
                                                    <a href="/reporting/operatorperformance" style={{cursor:'pointer'}} onClick={(e)=>{ e.preventDefault(); this.props.history.push('/reporting/operatorperformance')}}>Operator Performance</a>
                                                </li>
                                                <li>
                                                    <a href="/reporting/downtimeanalysis" style={{cursor:'pointer'}} onClick={(e)=>{ e.preventDefault(); this.props.history.push('/reporting/downtimeanalysis')}}>Downtime Analysis</a>
                                                </li>
                                                <li>
                                                    <a href="/reporting/qualityreport" style={{cursor:'pointer'}} onClick={(e)=>{ e.preventDefault(); this.props.history.push('/reporting/qualityreport')}}>Quality Report</a>
                                                </li> */}

                </ul>
              </li>
              <li>
                <a
                  href="#dataentry"
                  data-toggle="collapse"
                  aria-expanded="false"
                  className=" collapsed dropdown-toggle text-white"
                  aria-controls="dataentry"
                >
                  <FontAwesomeIcon icon={faDatabase} color="white" />
                  &nbsp;Data Entry
                </a>
                <ul
                  className="collapse list-unstyled"
                  id="dataentry"
                  data-parent="#parent"
                >
                  {/* <li >
                                        <a href="#downtime" onClick={()=>{this.props.history.push('/dataentry/downtime')}} data-toggle="collapse" aria-expanded="false" className='collapsed' aria-controls="downtime" className="dropdown-toggle text-white">Downtime</a>
                                        <ul className="collapse list-unstyled" id="downtime" data-parent="#dataentry">
                            
                                                <li>
                                                    <a href="/dataentry/downtime/view" style={{cursor:'pointer'}} onClick={(e)=>{ e.preventDefault(); this.props.history.push('/dataentry/downtime/view')}}>View</a>
                                                </li>
                                               
                        
                                    </ul>
                                </li> */}
                  {!handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "Downtime",
                    "none"
                  ) ? (
                    <li>
                      <a
                        className="text-white "
                        href="/dataentry/downtime/view"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.history.push("/dataentry/downtime/view");
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Downtime{" "}
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                  {/* <li >
                                        <a href="#component" onClick={()=>{this.props.history.push('/dataentry/component');this.setState({actionStatus:'add',dataEntryComponentData:{RunningStatus:'Running'}})}} data-toggle="collapse" aria-expanded="false" className='collapsed' aria-controls="component" className="dropdown-toggle text-white">Job Selection</a>
                                        <ul className="collapse list-unstyled" id="component" data-parent="#dataentry">
                            
                                                <li>
                                                    <a href="/dataentry/component/view" style={{cursor:'pointer'}} onClick={(e)=>{ e.preventDefault(); this.props.history.push('/dataentry/component/view')}}>View</a>
                                                </li>
                                               
                        
                                    </ul>
                                </li> */}
                  {!handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "JobSelection",
                    "none"
                  ) ? (
                    <li>
                      <a
                        className="text-white"
                        href="/dataentry/component/view"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.history.push("/dataentry/component/view");
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Job{" "}
                      </a>
                    </li>
                  ) : (
                    ""
                  )}

                  {!handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "JobSelection",
                    "none"
                  ) ? (
                    <li>
                      <a
                        className="text-white"
                        href="/dataentry/job/table"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.history.push("/dataentry/job/table");
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Job Entry Tabular{" "}
                      </a>
                    </li>
                  ) : (
                    ""
                  )}

                  {!handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "Quality",
                    "none"
                  ) ? (
                    <li>
                      <a
                        className="text-white"
                        href="/dataentry/quality"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.history.push("/dataentry/quality");
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Quality
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                  {this.state.company && this.state.company.allowWFManpowerDataEntry ? (
                    <li>
                      <a
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/dataentry/custom/view");
                          this.setState({
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                            customDashboardState: false,
                          });
                        }}
                      >
                        WF Manpower
                      </a>
                    </li>
                  ) : (
                    ""
                  )}

                  {this.state.company && this.state.company.IsCustomerPlanScheduleEnable && this.handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "Customer Plan Schedule Access",
                    "read"
                  ) ? (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/setting/customer/schedule");
                          this.setState({
                            navSelected: "/setting/customer/schedule",
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Schedule Inventory
                      </a>
                    </li>
                  ) : (
                    ""
                  )}

                  {!handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "Employee",
                    "none"
                  ) && this.state.company && this.state.company.allowSecondaryEmployees ? (
                    <li>
                      <a
                        className="text-white"
                        href="/dataentry/employee"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.history.push("/dataentry/employee");
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Employee
                      </a>
                    </li>
                  ) : (
                    ""
                  )}

                  {this.state.company && this.state.company.enableProjectPlanning && handleUserRightsToVisibleOrNot("DynamicDataRights", "Project Data Entry", "read") ? (
                    <li>
                      <a
                        className="text-white"
                        href="/dataentry/project/view"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.history.push("/dataentry/project/view");
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Project
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>


              </li>

              <li>
                <a
                  href="#setting"
                  data-toggle="collapse"
                  aria-expanded="false"
                  className=" collapsed dropdown-toggle text-white"
                  aria-controls="setting"
                >
                  <FontAwesomeIcon icon={faCog} color="white" />
                  &nbsp;Settings
                </a>
                <ul
                  className="collapse list-unstyled"
                  id="setting"
                  data-parent="#parent"
                >
                  {this.renderSettingsItems(settingsMenuItems, "setting")}
                  {false && (
                    <>
                      {handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "UserMaster",
                        "read"
                      ) ? (
                        <li>
                          <a
                            href="#user"
                            data-toggle="collapse"
                            aria-expanded="false"
                            aria-controls="user"
                            className="collapsed dropdown-toggle text-white"
                          >
                            User
                          </a>
                          <ul
                            className="collapse list-unstyled"
                            id="user"
                            data-parent="#setting"
                          >
                            <li data-parent="#user">
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    "/setting/usergroup/list"
                                  );
                                  this.setState({
                                    navSelected: "/setting/usergroup/list",
                                    cardDashboardState: false,
                                    andonDashboardState: false,
                                    macStateDashboardState: false,
                                    activityDashboardState: false,
                                  });
                                }}
                              >
                                User Group
                              </a>
                            </li>
                            <li>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    "/setting/userrights/list"
                                  );
                                  this.setState({
                                    navSelected: "/setting/userrights/list",
                                    cardDashboardState: false,
                                    andonDashboardState: false,
                                    macStateDashboardState: false,
                                    activityDashboardState: false,
                                  });
                                }}
                              >
                                User Rights
                              </a>
                            </li>
                            <li>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    "/setting/UserRightsManager"
                                  );
                                  this.setState({
                                    navSelected: "/setting/UserRightsManager",
                                    cardDashboardState: false,
                                    andonDashboardState: false,
                                    macStateDashboardState: false,
                                    activityDashboardState: false,
                                  });
                                }}
                              >
                                User Rights Manager
                              </a>
                            </li>
                            <li>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push("/setting/user/list");
                                  this.setState({
                                    navSelected: "/setting/user/list",
                                    cardDashboardState: false,
                                    andonDashboardState: false,
                                    macStateDashboardState: false,
                                    activityDashboardState: false,
                                  });
                                }}
                              >
                                User
                              </a>
                            </li>
                          </ul>
                        </li>
                      ) : (
                        ""
                      )}

                      {handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "Employee Master",
                        "read"
                      ) ? (
                        this.state.company && this.state.company.allowSecondaryEmployees ? (
                          <li>
                            <a
                              href="#employee"
                              data-toggle="collapse"
                              aria-expanded="false"
                              aria-controls="employee"
                              className="collapsed dropdown-toggle text-white"
                            >
                              Employee
                            </a>
                            <ul
                              className="collapse list-unstyled"
                              id="employee"
                              data-parent="#setting"
                            >
                              <li data-parent="#employee">
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    this.props.history.push(
                                      "/setting/employeerole/list"
                                    );
                                    this.setState({
                                      navSelected: "/setting/employeerole/list",
                                      cardDashboardState: false,
                                      andonDashboardState: false,
                                      macStateDashboardState: false,
                                      activityDashboardState: false,
                                    });
                                  }}
                                >
                                  Employee Role
                                </a>
                              </li>
                              <li data-parent="#employee">
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    this.props.history.push(
                                      "/setting/employee/list"
                                    );
                                    this.setState({
                                      navSelected: "/setting/employee/list",
                                      cardDashboardState: false,
                                      andonDashboardState: false,
                                      macStateDashboardState: false,
                                      activityDashboardState: false,
                                    });
                                  }}
                                >
                                  Employee Master
                                </a>
                              </li>
                            </ul>
                          </li>
                        ) : null
                      ) : (
                        ""
                      )}

                      {handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "EquipmentMaster",
                        "read"
                      ) ? (
                        <li>
                          <a
                            href="#equipment"
                            data-toggle="collapse"
                            aria-expanded="false"
                            aria-controls="equipment"
                            className="collapsed dropdown-toggle text-white"
                          >
                            Equipment
                          </a>
                          <ul
                            className="collapse list-unstyled"
                            id="equipment"
                            data-parent="#setting"
                          >
                            <li>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    "/setting/equipmentgroup/list"
                                  );
                                  this.setState({
                                    navSelected: "/setting/equipmentgroup/list",
                                    activityDashboardState: false,
                                    andonDashboardState: false,
                                    cardDashboardState: false,
                                    macStateDashboardState: false,
                                  });
                                }}
                              >
                                Equipment Group
                              </a>
                            </li>
                            <li>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    "/setting/equipmenttype/list"
                                  );
                                  this.setState({
                                    navSelected: "/setting/equipmenttype/list",
                                    activityDashboardState: false,
                                    andonDashboardState: false,
                                    cardDashboardState: false,
                                    macStateDashboardState: false,
                                  });
                                }}
                              >
                                Equipment Type
                              </a>
                            </li>
                            <li>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    "/setting/equipmentlocation/list"
                                  );
                                  this.setState({
                                    navSelected: "/setting/equipmentlocation/list",
                                    andonDashboardState: false,
                                    cardDashboardState: false,
                                    macStateDashboardState: false,
                                    customDashboardState: false,
                                  });
                                }}
                              >
                                Equipment Location
                              </a>
                            </li>
                            <li>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    "/setting/equipmentmodel/list"
                                  );
                                  this.setState({
                                    navSelected: "/setting/equipmentmodel/list",
                                    andonDashboardState: false,
                                    cardDashboardState: false,
                                    macStateDashboardState: false,
                                    customDashboardState: false,
                                  });
                                }}
                              >
                                Equipment Model
                              </a>
                            </li>
                            <li>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    "/setting/equipment/list"
                                  );
                                  this.setState({
                                    navSelected: "/setting/equipment/list",
                                    activityDashboardState: false,
                                    andonDashboardState: false,
                                    cardDashboardState: false,
                                    macStateDashboardState: false,
                                  });
                                }}
                              >
                                Equipment
                              </a>
                            </li>
                            <li>
                              <a
                                href="#"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push("/setting/customequipmentgroup/list");
                                  this.setState({
                                    navSelected: "/setting/customequipmentgroup/list",
                                    andonDashboardState: false,
                                    cardDashboardState: false,
                                    macStateDashboardState: false,
                                    customDashboardState: false,
                                  });
                                }}
                              >
                                Custom Equipment Group
                              </a>
                            </li>
                          </ul>
                        </li>
                      ) : (
                        ""
                      )}

                      {handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "EquipmentHourlyRate",
                        "read"
                      ) ? (
                        <li>
                          <a
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.props.history.push(
                                "/setting/equipmenthourlyrate/list"
                              );
                              this.setState({
                                navSelected: "/setting/equipmenthourlyrate/list",
                                activityDashboardState: false,
                                andonDashboardState: false,
                                cardDashboardState: false,
                                macStateDashboardState: false,
                              });
                            }}
                          >
                            Equipment Hourly Rate
                          </a>

                          {/* <a href="#equipmenthourlyrate" data-toggle="collapse" aria-expanded="false" aria-controls="equipmenthourlyrate" className="collapsed dropdown-toggle text-white">Equipment</a>
                  <ul className="collapse list-unstyled" id="equipmenthourlyrate" data-parent="#setting">
 
                    <li>
                      <a style={{ cursor: 'pointer' }} onClick={() => { this.props.history.push('/setting/equipmenthourlyrate/list'); this.setState({ navSelected: '/setting/equipmenthourlyrate/list', activityDashboardState: false, andonDashboardState: false, cardDashboardState: false, macStateDashboardState: false }) }}>Equipment Hourly Rate</a>
                    </li>
                  </ul> */}
                        </li>
                      ) : (
                        ""
                      )}

                      {handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "DowntimeMaster",
                        "read"
                      ) ? (
                        <li>
                          <a
                            href="#downtime"
                            data-toggle="collapse"
                            aria-expanded="false"
                            aria-controls="downtime"
                            className="collapsed dropdown-toggle text-white"
                          >
                            Downtime
                          </a>
                          <ul
                            className="collapse list-unstyled"
                            id="downtime"
                            data-parent="#setting"
                          >
                            <li>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    "/setting/downtimereasongroup/list"
                                  );
                                  this.setState({
                                    navSelected:
                                      "/setting/downtimereasongroup/list",
                                    activityDashboardState: false,
                                    andonDashboardState: false,
                                    cardDashboardState: false,
                                    macStateDashboardState: false,
                                  });
                                }}
                              >
                                Dowtime Reason Group
                              </a>
                            </li>
                            <li>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    "/setting/downtimereason/list"
                                  );
                                  this.setState({
                                    navSelected: "/setting/downtimereason/list",
                                    activityDashboardState: false,
                                    andonDashboardState: false,
                                    cardDashboardState: false,
                                    macStateDashboardState: false,
                                  });
                                }}
                              >
                                Downtime Reason
                              </a>
                            </li>
                            <li>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    "/setting/ActionTakenMaster"
                                  );
                                  this.setState({
                                    navSelected: "/setting/ActionTakenMaster",
                                    activityDashboardState: false,
                                    andonDashboardState: false,
                                    cardDashboardState: false,
                                    macStateDashboardState: false,
                                  });
                                }}
                              >
                                Action Taken
                              </a>
                            </li>

                          </ul>
                        </li>
                      ) : (
                        ""
                      )}
                      {handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "QualityMaster",
                        "read"
                      ) ? (
                        <li>
                          <a
                            href="#quality"
                            data-toggle="collapse"
                            aria-expanded="false"
                            aria-controls="quality"
                            className=" collapsed dropdown-toggle text-white"
                          >
                            Quality
                          </a>
                          <ul
                            className="collapse list-unstyled"
                            id="quality"
                            data-parent="#setting"
                          >
                            <li>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    "/setting/qualityreasongroup/list"
                                  );
                                  this.setState({
                                    navSelected: "/setting/qualityreasongroup/list",
                                    activityDashboardState: false,
                                    andonDashboardState: false,
                                    cardDashboardState: false,
                                    macStateDashboardState: false,
                                  });
                                }}
                              >
                                Rejection Reason Group
                              </a>
                            </li>
                            <li>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    "/setting/qualityreason/list"
                                  );
                                  this.setState({
                                    navSelected: "/setting/qualityreason/list",
                                    activityDashboardState: false,
                                    andonDashboardState: false,
                                    cardDashboardState: false,
                                    macStateDashboardState: false,
                                  });
                                }}
                              >
                                Rejection Reason
                              </a>
                            </li>
                            <li>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    "/setting/rejectionstage/list"
                                  );
                                  this.setState({
                                    navSelected: "/setting/rejectionstage/list",
                                    activityDashboardState: false,
                                    andonDashboardState: false,
                                    cardDashboardState: false,
                                    macStateDashboardState: false,
                                  });
                                }}
                              >
                                Rejection Stage
                              </a>
                            </li>
                          </ul>
                        </li>
                      ) : (
                        ""
                      )}

                      {handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "OperatorMaster",
                        "read"
                      ) ? (
                        <li>
                          <a
                            className="text-white"
                            href="/setting/operatormaster/list"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push(
                                "/setting/operatormaster/list"
                              );
                              this.setState({
                                navSelected: "/setting/operatormaster/list",
                                activityDashboardState: false,
                                andonDashboardState: false,
                                cardDashboardState: false,
                                macStateDashboardState: false,
                              });
                            }}
                          >
                            Operator Master
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "OperatorMaster",
                        "read"
                      ) ? (
                        <li>
                          <a
                            className="text-white"
                            href="/setting/partspercyclereason/list"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push(
                                "/setting/partspercyclereason/list"
                              );
                              this.setState({
                                navSelected: "/setting/partspercyclereason/list",
                                activityDashboardState: false,
                                andonDashboardState: false,
                                cardDashboardState: false,
                                macStateDashboardState: false,
                              });
                            }}
                          >
                            Cavity Loss Reason
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "ComponentMaster",
                        "read"
                      ) ? (
                        <li>
                          <a
                            className="text-white"
                            href="/setting/component/list"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push("/setting/component/list");
                              this.setState({
                                navSelected: "/setting/component/list",
                                activityDashboardState: false,
                                andonDashboardState: false,
                                cardDashboardState: false,
                                macStateDashboardState: false,
                              });
                            }}
                          >
                            Component Master
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "OperationMaster",
                        "read"
                      ) ? (
                        <li>
                          <a
                            className="text-white"
                            href="/setting/operation/list"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push("/setting/operation/list");
                              this.setState({
                                navSelected: "/setting/operation/list",
                                activityDashboardState: false,
                                andonDashboardState: false,
                                andonDashboardState: false,
                                cardDashboardState: false,
                              });
                            }}
                          >
                            Operation Master
                          </a>
                        </li>
                      ) : (
                        ""
                      )}

                      {handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "ToolMaster",
                        "read"
                      ) ? (
                        <li>
                          <a
                            className="text-white"
                            href="/setting/toolmaster/list"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push("/setting/toolmaster/list");
                              this.setState({
                                navSelected: "/setting/toolmaster/list",
                                activityDashboardState: false,
                                andonDashboardState: false,
                                cardDashboardState: false,
                                macStateDashboardState: false,
                              });
                            }}
                          >
                            Tool Master
                          </a>
                        </li>
                      ) : (
                        ""
                      )}

                      {handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "ToolMaster",
                        "read"
                      ) ? (
                        <li>
                          <a
                            className="text-white"
                            href="/setting/TableMatrix"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push("/setting/TableMatrix");
                              this.setState({
                                navSelected: "/setting/TableMatrix",
                                activityDashboardState: false,
                                andonDashboardState: false,
                                cardDashboardState: false,
                                macStateDashboardState: false,
                              });
                            }}
                          >
                            Machine X Tool Mapped
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "ComponentMaster",
                        "read"
                      ) ? (
                        <li>
                          <a
                            className="text-white"
                            href="/setting/rawmaterial/list"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push("/setting/rawmaterial/list");
                              this.setState({
                                navSelected: "/setting/rawmaterial/list",
                                activityDashboardState: false,
                                andonDashboardState: false,
                                cardDashboardState: false,
                                macStateDashboardState: false,
                              });
                            }}
                          >
                            Raw Material Master
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {(handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "ComponentMaster",
                        "update"
                      ) && handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "EquipmentMaster",
                        "update"
                      )) ? (
                        <li>
                          <a
                            className="text-white"
                            href="/reporting/Component_Machine_Matrix"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push("/reporting/Component_Machine_Matrix");
                              this.setState({
                                navSelected: "/reporting/Component_Machine_Matrix",
                                activityDashboardState: false,
                                andonDashboardState: false,
                                cardDashboardState: false,
                                macStateDashboardState: false,
                              });
                            }}
                          >
                            Machine X Component Mapped
                          </a>
                        </li>
                      ) : (
                        ""
                      )}

                      {/* {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "ShiftMaster",
                    "read"
                  ) ? (
                    <li>
                      <a
                        className="text-white"
                        href="/setting/shiftsetting/list"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => { e.preventDefault();
                          this.props.history.push("/setting/shiftsetting/list");
                          this.setState({
                            navSelected: "/setting/shiftsetting/list",
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Shift
                      </a>
                    </li>
                  ) : (
                    ""
                  )} */}

                      {visibleShiftTypes(this.state.company, handleUserRightsToVisibleOrNot).length > 0 ? (
                        <li>
                          <a
                            className="text-white"
                            href="/setting/shiftManagement"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push("/setting/shiftManagement");
                              this.setState({
                                navSelected: "/setting/shiftManagement",
                                activityDashboardState: false,
                                andonDashboardState: false,
                                cardDashboardState: false,
                                macStateDashboardState: false,
                              });
                            }}
                          >
                            Shift Management
                          </a>
                        </li>
                      ) : (
                        ""
                      )}

                      {handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        "CustomerMaster",
                        "read"
                      ) ? (
                        <li>
                          <a
                            className="text-white"
                            href="/setting/customer/list"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push("/setting/customer/list");
                              this.setState({
                                navSelected: "/setting/customer/list",
                                activityDashboardState: false,
                                andonDashboardState: false,
                                cardDashboardState: false,
                                macStateDashboardState: false,
                              });
                            }}
                          >
                            Customer Master
                          </a>
                        </li>
                      ) : (
                        ""
                      )}

                      {/* {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "CustomerMaster",
                    "read"
                  ) ? (
                    <li>
                      <a
                        className="text-white"
                        href="/setting/TragetMultiplier"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => { e.preventDefault();
                          this.props.history.push("/setting/TragetMultiplier");
                          this.setState({
                            navSelected: "/setting/TragetMultiplier",
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Target Multiplier
                      </a>
                    </li>
                  ) : (
                    ""
                  )} */}

                      {(user && user.userType == 'admin') ? (
                        <li>
                          <a
                            className="text-white"
                            href="/setting/CompanySetting"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push("/setting/CompanySetting");
                              this.setState({
                                navSelected: "/setting/CompanySetting",
                                activityDashboardState: false,
                                andonDashboardState: false,
                                cardDashboardState: false,
                                macStateDashboardState: false,
                              });
                            }}
                          >
                            Company Setting
                          </a>
                        </li>
                      ) : (
                        ""
                      )}

                      {this.state.company && this.state.company.enableProjectPlanning && handleUserRightsToVisibleOrNot("StaticDataRights", "Project Master", "read") ? (
                        <li>
                          <a
                            className="text-white"
                            href="/setting/projectplanning/view"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push("/setting/projectplanning/view");
                              this.setState({
                                navSelected: "/setting/projectplanning/view",
                                activityDashboardState: false,
                                andonDashboardState: false,
                                cardDashboardState: false,
                                macStateDashboardState: false,
                              });
                            }}
                          >
                            Project Planning
                          </a>
                        </li>
                      ) : (
                        ""
                      )}

                      {this.state.company && this.state.company.allowProcessParameter && handleUserRightsToVisibleOrNot("StaticDataRights", "Process Parameter Config", "read") ? (
                        <li>
                          <a
                            className="text-white"
                            href="/setting/process-parameter-config"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push("/setting/process-parameter-config");
                              this.setState({
                                navSelected: "/setting/process-parameter-config",
                                activityDashboardState: false,
                                andonDashboardState: false,
                                cardDashboardState: false,
                                macStateDashboardState: false,
                              });
                            }}
                          >
                            Process Parameter Config
                          </a>
                        </li>
                      ) : (
                        ""
                      )}

                    </>
                  )}
                </ul>
              </li>
              {handleUserRightsToVisibleOrNot("StaticDataRights", "Support", "read") ? (
                <li>
                  <a
                    className="text-white"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.props.history.push("/support");
                      this.setState({
                        navSelected: "/support",
                        activityDashboardState: false,
                        andonDashboardState: false,
                        cardDashboardState: false,
                        macStateDashboardState: false,
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faHeadset} color="white" />
                    &nbsp;Support
                  </a>
                </li>
              ) : null}
              {handleUserRightsToVisibleOrNot("StaticDataRights", "LeafnetBot", "read") ? (
                <li>
                  <a
                    className="text-white"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.props.history.push("/leafnet-bot");
                      this.setState({
                        navSelected: "/leafnet-bot",
                        activityDashboardState: false,
                        andonDashboardState: false,
                        cardDashboardState: false,
                        macStateDashboardState: false,
                      });
                    }}
                  >
                    <CocoLogo className="pa-logo-nav" />
                    COCO AI Assistant
                  </a>
                </li>
              ) : null}
              {/* <li className=''>
              <a className="text-white"  style={{ cursor: 'pointer' }} onClick={() => { this.props.history.push('/setting/faq'); this.setState({ navSelected: '/setting/faq', activityDashboardState: false, andonDashboardState: false, cardDashboardState: false, macStateDashboardState: false }) }}><FontAwesomeIcon icon={faQuestion} color='white'  />&nbsp;FAQ</a>

            </li> */}
            </ul>


            <div className="mt-5 text-center ln-sb-footer">
              <p className="small mb-0">
                Version:{api.UIVersion}/{this.state.version}
              </p>
              <p className="small mb-0">&copy; Copyright 2021 Leafnet</p>
              <p className="small">
                Powered By{" "}
                <a
                  title="DRITI TECHNOLOGIES LLP"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://drititech.com"
                >
                  DRITI TECHNOLOGIES LLP
                </a>
              </p>
            </div>
          </nav>

          {!this.state.toggle && (
            <button
              className="sidebar-expand-btn"
              onClick={this.handleToggleClick}
              style={{
                position: "fixed",
                left: "0",
                top: "20px",
                zIndex: 1060,
                background: "#002b49",
                border: "none",
                borderRight: "2px solid #fff",
                borderTop: "2px solid #fff",
                borderBottom: "2px solid #fff",
                borderRadius: "0 12px 12px 0",
                width: "16px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                color: "#fff",
                boxShadow: "2px 0 8px rgba(0,0,0,0.3)",
              }}
            >
              <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: "10px" }} />
            </button>
          )}

          <div
            id="content"
            style={{
              padding: 0,
              width:
                this.state.windowWidth > 768 && this.state.toggle
                  ? 'calc(100% - 250px)'
                  : '100%'
            }}
          >

            <Route
              path="/setting/toolCode/add"
              render={(props) => (
                <ToolCodeMaster
                  dataRightsKey="StaticDataRights"
                  userRights={this.state.userRights}
                  getRightsForAccess={handleUserRightsToVisibleOrNot}
                  {...props}
                  toolCodeData={this.state.toolCodeData}
                  actionStatus={this.state.actionStatus}
                  toolMasterList={this.state.toolMasterList}
                />
              )}
            />

            <Route
              path="/setting/toolCode/list"
              render={(props) => (
                <ToolCodeMasterTable
                  dataRightsKey="StaticDataRights"
                  userRights={this.state.userRights}
                  getRightsForAccess={handleUserRightsToVisibleOrNot}
                  {...props}
                  handleOnAdd={this.handleOnAdd}
                  onUpdate={this.handleOnUpdate}
                />
              )}
            />

            {/* <button
            id="sidebarCollapse"
            onClick={this.handleToggleClick}
            className="btn btn-sm btn-info"
          >
            <FontAwesomeIcon icon={faAlignLeft} />
          </button> */}

            {LIVE_REPORT_ROUTES.includes(window.location.pathname) && (
              <>
                {this.state.activityDashboardState ? (
                  <nav className="d-flex w-100 navbar navbar-expand-lg mb-1 p-4">
                    <div className="container-fluid px-4">
                      {this.state.activityDashboardState ? (
                        <React.Fragment>
                          <button
                            className="btn btn-dark d-inline-block d-lg-none"
                            type="button"
                            data-toggle="collapse"
                            data-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                          >
                            <FontAwesomeIcon icon={faAlignJustify} />
                          </button>

                          <div
                            className="collapse navbar-collapse"
                            id="navbarSupportedContent"
                          >

                            <ul className="nav navbar-nav ">
                              <li>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <label className="small ">
                                      Number Of Machine Screen:
                                    </label>
                                  </div>
                                  <div className="col-lg-6">
                                    <input
                                      placeholder="number"
                                      defaultValue={
                                        this.state.sortObj.NoOfMachineScreen
                                      }
                                      onChange={this.handleChangeActivityFilter}
                                      className="form-control form-control-sm"
                                      name="NoOfMachineScreen"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <label className="small ">
                                      Display For(Sec):
                                    </label>
                                  </div>
                                  <div className="col-lg-6">
                                    <input
                                      placeholder="seconds"
                                      defaultValue={this.state.sortObj.DisplayFor}
                                      onChange={this.handleChangeActivityFilter}
                                      className="form-control form-control-sm"
                                      name="DisplayFor"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="row">
                                  <div className="col-lg-3">
                                    <label className="small ">SortBy:</label>
                                  </div>
                                  <div className="col">
                                    <select
                                      onChange={this.handleChangeActivityFilter}
                                      value={this.state.sortObj.SortBy}
                                      name="SortBy"
                                      className="form-control form-control-sm"
                                    >
                                      <option value={"Name"}>Name</option>
                                      <option value={"EquipmentGroup"}>
                                        Equipment Group
                                      </option>
                                      <option value={"EquipmentType"}>
                                        Equipment Type
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                              {/* <li>
                          <button onClick={this.handleApplyFilter} className="btn btn-sm btn-primary">Apply</button>
                        </li> */}
                            </ul>
                          </div>
                        </React.Fragment>
                      ) : (
                        ""
                      )}
                    </div>
                  </nav>
                ) : (
                  <nav
                    className="navbar navbar-expand-lg m-0 py-0 navbar-light bg-light"
                    style={{ padding: 0, minHeight: "40px" }}
                  >
                    <div className="container-fluid px-1">

                      {/* Sits at the left of this row; the Equipment Group block below
                          keeps its ml-auto and stays pinned to the right. */}
                      {upperViewModeKey(window.location.pathname) && (
                        <div
                          className="d-flex align-items-center"
                          style={{
                            background: "#eef0f4",
                            borderRadius: 8,
                            padding: 3,
                            gap: 3,
                          }}
                        >
                          {[
                            { mode: UPPER_VIEW_AGGREGATED, label: "Aggregated" },
                            { mode: UPPER_VIEW_BY_TYPE, label: "By Equipment Type" },
                          ].map((tab) => (
                            <button
                              key={tab.mode}
                              type="button"
                              onClick={() =>
                                this.setDashboardUpperViewMode(tab.mode)
                              }
                              style={{
                                border: "none",
                                borderRadius: 6,
                                padding: "3px 14px",
                                fontSize: "0.82rem",
                                fontWeight: 600,
                                cursor: "pointer",
                                background:
                                  this.state.dashboardUpperViewMode === tab.mode
                                    ? "#2f54eb"
                                    : "transparent",
                                color:
                                  this.state.dashboardUpperViewMode === tab.mode
                                    ? "#fff"
                                    : "#5a6472",
                              }}
                            >
                              {tab.label}
                            </button>
                          ))}
                        </div>
                      )}

                      {DASHBOARD_EQUIP_GROUP_KEYS[window.location.pathname] && (
                        <div
                          className="ml-auto d-flex align-items-center"
                          style={{ position: "relative" }}
                        >
                          <label
                            className="small mb-0 mr-2"
                            style={{ fontWeight: 700, color: "#374151" }}
                          >
                            Equipment Group
                          </label>
                          <div className="dropdown">
                            <button
                              type="button"
                              className="btn btn-sm d-flex align-items-center"
                              style={{
                                minWidth: "170px",
                                justifyContent: "space-between",
                                background: "#fff",
                                border: "1px solid #d1d5db",
                                borderRadius: "8px",
                                boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                                fontWeight: 600,
                                color: "#1f2937",
                              }}
                              onClick={() =>
                                this.setState({
                                  dashboardEquipGroupDropdownOpen:
                                    !this.state.dashboardEquipGroupDropdownOpen,
                                })
                              }
                            >
                              <span className="d-flex align-items-center">
                                {this.state.dashboardEquipmentGroups.length === 0 ? (
                                  "All Groups"
                                ) : (
                                  <>
                                    <span
                                      style={{
                                        background: "#2563eb",
                                        color: "#fff",
                                        borderRadius: "10px",
                                        fontSize: "11px",
                                        fontWeight: 700,
                                        padding: "1px 8px",
                                        marginRight: "6px",
                                      }}
                                    >
                                      {this.state.dashboardEquipmentGroups.length}
                                    </span>
                                    Selected
                                  </>
                                )}
                              </span>
                              <span
                                style={{
                                  marginLeft: "8px",
                                  fontSize: "10px",
                                  color: "#6b7280",
                                  transform: this.state
                                    .dashboardEquipGroupDropdownOpen
                                    ? "rotate(180deg)"
                                    : "none",
                                  transition: "transform 0.15s ease",
                                }}
                              >
                                ▼
                              </span>
                            </button>
                            {this.state.dashboardEquipGroupDropdownOpen && (
                              <div
                                className="shadow"
                                style={{
                                  position: "absolute",
                                  right: 0,
                                  left: "auto",
                                  top: "calc(100% + 6px)",
                                  zIndex: 1060,
                                  minWidth: "240px",
                                  background: "#fff",
                                  border: "1px solid #e5e7eb",
                                  borderRadius: "10px",
                                  overflow: "hidden",
                                }}
                              >
                                <div
                                  className="d-flex justify-content-between align-items-center"
                                  style={{
                                    padding: "10px 14px",
                                    borderBottom: "1px solid #f0f0f0",
                                    background: "#f9fafb",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 700,
                                      color: "#374151",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.04em",
                                    }}
                                  >
                                    Filter by Group
                                  </span>
                                  {this.state.dashboardEquipmentGroups.length >
                                    0 && (
                                      <button
                                        type="button"
                                        onClick={
                                          this.handleSelectAllDashboardEquipGroups
                                        }
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                          color: "#2563eb",
                                          fontSize: "12px",
                                          fontWeight: 600,
                                          cursor: "pointer",
                                          padding: 0,
                                        }}
                                      >
                                        Clear
                                      </button>
                                    )}
                                </div>
                                <div
                                  style={{
                                    maxHeight: "300px",
                                    overflowY: "auto",
                                    padding: "6px",
                                  }}
                                >
                                  {(() => {
                                    const allSelected =
                                      this.state.dashboardEquipmentGroups.length ===
                                      0;
                                    return (
                                      <label
                                        className="d-flex align-items-center"
                                        style={{
                                          margin: 0,
                                          padding: "8px 10px",
                                          borderRadius: "6px",
                                          cursor: "pointer",
                                          fontWeight: 600,
                                          color: allSelected ? "#2563eb" : "#1f2937",
                                          background: allSelected
                                            ? "#eff6ff"
                                            : "transparent",
                                        }}
                                        onMouseEnter={(e) => {
                                          if (!allSelected)
                                            e.currentTarget.style.background =
                                              "#f3f4f6";
                                        }}
                                        onMouseLeave={(e) => {
                                          if (!allSelected)
                                            e.currentTarget.style.background =
                                              "transparent";
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={allSelected}
                                          onChange={
                                            this
                                              .handleSelectAllDashboardEquipGroups
                                          }
                                          style={{ marginRight: "10px" }}
                                        />
                                        All Groups
                                      </label>
                                    );
                                  })()}
                                  {(this.state.equipGroups || []).map((group) => {
                                    const checked =
                                      this.state.dashboardEquipmentGroups.includes(
                                        group.EquipmentGroup
                                      );
                                    return (
                                      <label
                                        key={group._id || group.EquipmentGroup}
                                        className="d-flex align-items-center"
                                        style={{
                                          margin: 0,
                                          padding: "8px 10px",
                                          borderRadius: "6px",
                                          cursor: "pointer",
                                          fontWeight: checked ? 600 : 400,
                                          color: checked ? "#2563eb" : "#374151",
                                          background: checked
                                            ? "#eff6ff"
                                            : "transparent",
                                        }}
                                        onMouseEnter={(e) => {
                                          if (!checked)
                                            e.currentTarget.style.background =
                                              "#f3f4f6";
                                        }}
                                        onMouseLeave={(e) => {
                                          if (!checked)
                                            e.currentTarget.style.background =
                                              "transparent";
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={checked}
                                          onChange={() =>
                                            this.handleToggleDashboardEquipGroup(
                                              group.EquipmentGroup
                                            )
                                          }
                                          style={{ marginRight: "10px" }}
                                        />
                                        {group.EquipmentGroup}
                                      </label>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {window.location.pathname ==
                        "/dashboard/operator_per_board" ? (
                        <React.Fragment>
                          <button
                            className="btn btn-dark d-inline-block d-lg-none "
                            type="button"
                            data-toggle="collapse"
                            data-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                          >
                            <FontAwesomeIcon icon={faAlignJustify} />
                          </button>

                          <div
                            className="collapse navbar-collapse  d-flex flex-row-reverse mx-4"
                            id="navbarSupportedContent"
                          >
                            <ul className="nav navbar-nav ">
                              {window.location.pathname ==
                                "/dashboard/operator_per_board" ? (
                                <li className="nav-item ml-2 ">
                                  <a
                                    style={{ marginTop: -9, cursor: "pointer" }}
                                    className="nav-link"
                                    onClick={() => {
                                      let obj = {};
                                      if (
                                        window.location.pathname ==
                                        "/dashboard/operator_per_board"
                                      ) {
                                        if (
                                          localStorage.getItem("op_per_board_state")
                                        ) {
                                          obj = JSON.parse(
                                            localStorage.getItem(
                                              "op_per_board_state"
                                            )
                                          );
                                        }
                                      }
                                      this.setState({
                                        autoScrolOpPerfModal: true,
                                        autoScrolOpPerfObj: obj,
                                      });
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faCog} />
                                  </a>
                                </li>
                              ) : (
                                <></>
                              )}

                              {this.state.andonDashboardData ? "" : ""}
                            </ul>
                          </div>
                        </React.Fragment>
                      ) : (
                        ""
                      )}

                      {this.state.cardDashboardState ||
                        this.state.macStateDashboardState ||
                        this.state.andonDashboardState ? (
                        <React.Fragment>
                          <button
                            className="btn btn-dark d-inline-block d-lg-none "
                            type="button"
                            data-toggle="collapse"
                            data-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                          >
                            <FontAwesomeIcon icon={faAlignJustify} />
                          </button>
                          {window.location.pathname == "/" && handleUserRightsToVisibleOrNot("DynamicDataRights", "Downtime", "write") && (
                            <>
                              <div className="">
                                <div className="mx-1">
                                  Downtime Entry : Disable{" "}
                                </div>
                              </div>

                              <Swtch
                                size="small"
                                checked={EnableDataEntry}
                                // onChange={(e) => this.setState({ EnableDataEntry: !this.state.EnableDataEntry })}
                                onChange={(e) => {

                                  this.setState({
                                    EnableDataEntry: !this.state.EnableDataEntry,
                                  });
                                }}
                              />
                              <div className="mx-1"> Enable</div>
                              <div className="mx-2">
                                {EnableDataEntry && (
                                  <DowntimeEntryInterval
                                    stopCountdown={this.stopCountdown}
                                    EnableDataEntry={EnableDataEntry}
                                  />
                                  // <div>
                                  //   <h6 className="bolder">
                                  //     Time remaining: {countdown} seconds
                                  //   </h6>
                                  // </div>
                                )}
                              </div>
                            </>
                          )}

                          {/* {window.location.pathname == "/"   &&(
                        <>
                          <div className="">
                            <div className="mx-1">
                              Downtime Entry : Disable{" "}
                            </div>
                          </div>

                          <Swtch
                            size="small"
                            checked={EnableDataEntry}
                            onChange={(e) => {handleUserRightsToVisibleOrNot(
                              "DynamicDataRights",
                              "Downtime",
                              "update"
                            ) ?this.handelEnableDowntimeEntry(e):
                            
                            swal({
                              title: "Warning!",
                              text: "Permission to edit reason denied.",
                              icon: "warning",
                              button: {
                                text: "OK",
                                className: "swal-button--danger", // Optional: Custom styling
                              },
                              dangerMode: true,
                            })
                          }}
                          />
                          <div className="mx-1"> Enable</div>
                          <div className="mx-2">
                            {EnableDataEntry && countdown !== null && (
                              <div>
                                <h6 className="bolder">
                                  Time remaining: {countdown} seconds
                                </h6>
                              </div>
                            )}
                          </div>
                        </>
                      )} */}
                          <div
                            className="collapse navbar-collapse  d-flex flex-row-reverse mx-4"
                            id="navbarSupportedContent"
                          >
                            <ul className="nav navbar-nav ">
                              {this.state.macStateDashboardState ? (
                                <li className="nav-item ">
                                  <div className="row mr-2">
                                    <div className="col-sm-8">
                                      <label className="small ">Job View : </label>
                                    </div>
                                    <div className="col-sm-2 mt-1 ">
                                      <input
                                        type="checkbox"
                                        checked={
                                          this.state.filterObj.JobView
                                            ? true
                                            : false
                                        }
                                        onChange={(e) => {
                                          const obj = { ...this.state.filterObj };
                                          obj.JobView = e.currentTarget.checked;
                                          localStorage.setItem(
                                            "macStateDashboardFilter",
                                            JSON.stringify(obj)
                                          );
                                          this.setState({ filterObj: obj });
                                        }}
                                      />
                                    </div>
                                  </div>
                                </li>
                              ) : (
                                ""
                              )}
                              {this.state.macStateDashboardState && hasRelayConfigured(this.state.equipList) ? (
                                <li className="nav-item ">
                                  <div className="row mr-2">
                                    <div className="col-sm-8">
                                      <label className="small ">Relay View : </label>
                                    </div>
                                    <div className="col-sm-2 mt-1 ">
                                      <input
                                        type="checkbox"
                                        checked={!!this.state.filterObj.RelayView}
                                        onChange={(e) => {
                                          const obj = { ...this.state.filterObj };
                                          obj.RelayView = e.currentTarget.checked;
                                          localStorage.setItem(
                                            "macStateDashboardFilter",
                                            JSON.stringify(obj)
                                          );
                                          this.setState({ filterObj: obj });
                                        }}
                                      />
                                    </div>
                                  </div>
                                </li>
                              ) : (
                                ""
                              )}
                              {this.state.cardDashboardState ||
                                this.state.macStateDashboardState ? (
                                <li className="nav-item">
                                  <div className="row align-items-center">
                                    {/* Filter Label */}
                                    <div className="col-lg-4">
                                      <label className="small mb-0">
                                        Filter By:
                                      </label>
                                    </div>

                                    {/* Filter Dropdown */}
                                    <div className="col-lg-8">
                                      <div className="btn-group">
                                        <button
                                          className="btn btn-secondary btn-sm dropdown-toggle text-white"
                                          type="button"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          Equipment Group
                                        </button>
                                        <ul className="dropdown-menu">
                                          {/* Render Dropdown Items */}
                                          {this.state.macGroups.map((group) => {
                                            const isChecked =
                                              this.state.filterBy[group];
                                            return (
                                              <li
                                                key={group}
                                                className="dropdown-item"
                                              >
                                                <input
                                                  type="checkbox"
                                                  name={group}
                                                  checked={isChecked}
                                                  onChange={this.handleFilterBy}
                                                  className="me-2"
                                                />
                                                {group}
                                              </li>
                                            );
                                          })}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              ) : (
                                ""
                              )}

                              {this.state.cardDashboardState ||
                                this.state.macStateDashboardState ? (
                                <li className="nav-item ml-1 ">
                                  <div className="row">
                                    <div className="col-sm-5">
                                      <label className="small ">Sort By : </label>
                                    </div>
                                    <div className="col">
                                      <select
                                        onChange={this.handleFilterAndSort}
                                        value={this.state.filterObj.SortBy}
                                        name="SortBy"
                                        className="form-control form-control-sm"
                                      >
                                        <option>Ascending</option>
                                        <option>Descending</option>
                                        {this.state.cardDashboardState ? (
                                          <>
                                            {" "}
                                            <option>Running On Top</option>
                                            <option>Not Running On Top</option>
                                            <option>OEE Ascending</option>
                                            <option>OEE Descending</option>
                                            <option>Availability Ascending</option>
                                            <option>Availability Descending</option>
                                            <option>Performance Ascending</option>
                                            <option>Performance Descending</option>
                                            <option>Quality Ascending</option>
                                            <option>Quality Descending</option>
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </select>
                                    </div>
                                  </div>
                                </li>
                              ) : (
                                <li className="nav-item">
                                  <div className="d-flex flex-column flex-md-row align-items-center">
                                    {/* View Section */}
                                    <div className="d-flex align-items-center me-3">
                                      <label className="small text-nowrap mb-0 me-2">
                                        View:
                                      </label>
                                      <div className="dropdown">
                                        <button
                                          className="btn btn-sm btn-secondary dropdown-toggle"
                                          type="button"
                                          id="dropdownMenuButton"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                          style={{
                                            backgroundColor: "white",
                                            color: "darkgray",
                                            border: 0,
                                          }}
                                        >
                                          <span className="small">Add Field</span>
                                        </button>
                                        <ul
                                          className="dropdown-menu"
                                          aria-labelledby="dropdownMenuButton"
                                          style={{ minWidth: "200px" }}
                                        >
                                          {this.state.andonDashboardData.length > 0
                                            ? Object.keys(
                                              this.state.andOnDasboardObj
                                            ).map((one) => {
                                              if (
                                                ![
                                                  "Equipment",
                                                  "ConnStatus",
                                                  "Shift",
                                                  "State",
                                                  "DeviceConfig",
                                                ].includes(one)
                                              ) {
                                                return (
                                                  <li
                                                    key={one}
                                                    className="dropdown-item"
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      id={one}
                                                      checked={
                                                        this.state
                                                          .andOnDasboardObj[one]
                                                      }
                                                      onChange={
                                                        this.handleOnChangeSelect
                                                      }
                                                      name={one}
                                                      className="me-2"
                                                    />
                                                    {one.charAt(0).toUpperCase() +
                                                      one
                                                        .slice(1)
                                                        .replace(
                                                          /([A-Z])/g,
                                                          " $1"
                                                        )
                                                        .trim()}
                                                  </li>
                                                );
                                              }
                                              return null;
                                            })
                                            : ""}
                                        </ul>
                                      </div>
                                    </div>

                                    {/* Sort and Filter Section */}
                                    <div className="d-flex align-items-center">
                                      {/* Sort Button */}
                                      <Button
                                        className="btn-sm btn-primary text-nowrap me-3"
                                        onClick={this.showModal}
                                      >
                                        Sort By:
                                      </Button>

                                      {/* Filter Section */}
                                      <div className="d-flex align-items-center">
                                        <label className="small text-nowrap mb-0 me-2">
                                          Filter By:
                                        </label>
                                        <div className="btn-group">
                                          <button
                                            className="btn btn-secondary btn-sm dropdown-toggle"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                            Equipment Group
                                          </button>
                                          <ul className="dropdown-menu">
                                            {this.state.macGroups.map((group) => {
                                              const obj = {
                                                ...this.state.filterBy,
                                              };
                                              return (
                                                <li
                                                  key={group}
                                                  className="dropdown-item"
                                                >
                                                  <input
                                                    name={group}
                                                    type="checkbox"
                                                    checked={obj[group]}
                                                    onChange={this.handleFilterBy}
                                                    className="me-2"
                                                  />
                                                  {group}
                                                </li>
                                              );
                                            })}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              )}

                              {this.state.cardDashboardState ||
                                this.state.andonDashboardState ||
                                this.state.macStateDashboardState ? (
                                <li className="nav-item ml-2 ">
                                  <a
                                    style={{ marginTop: -9, cursor: "pointer" }}
                                    className="nav-link"
                                    onClick={() => {
                                      let obj = {};
                                      if (this.state.cardDashboardState) {
                                        if (localStorage.getItem("card_state")) {
                                          obj = JSON.parse(
                                            localStorage.getItem("card_state")
                                          );
                                        }
                                      }
                                      if (this.state.macStateDashboardState) {
                                        if (localStorage.getItem("mac_state")) {
                                          obj = JSON.parse(
                                            localStorage.getItem("mac_state")
                                          );
                                        }
                                      }
                                      if (this.state.andOnDasboardObj) {
                                        if (localStorage.getItem("andon_state")) {
                                          obj = JSON.parse(
                                            localStorage.getItem("andon_state")
                                          );
                                        }
                                      }
                                      this.setState({
                                        modalSettingState: true,
                                        autoScrollObj: obj,
                                      });
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faCog} />
                                  </a>
                                </li>
                              ) : (
                                <></>
                              )}

                              {this.state.andonDashboardData ? "" : ""}
                            </ul>
                          </div>
                        </React.Fragment>
                      ) : (
                        ""
                      )}
                    </div>
                  </nav>
                )}
              </>
            )}
            <main
              style={{ height: "95vh", overflowY: "auto", overflowX: "hidden" }}
              className=" mx-1 "
            >


              {modelState && updateEvent.length > 0 && (
                <Modal
                  show={modelState}
                  onHide={this.handleClose}
                  backdrop="static"
                  keyboard={false}
                  size="lg"
                >
                  <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: 15, width: "100%" }}>
                      {updateEvent[0]} Downtime Reason Entry
                      <table className="table table-sm table-bordered table-hover small table-striped m-0">
                        <thead className="thead-dark">
                          <tr>
                            <th>Date</th>
                            <th>Machine</th>
                            {/* <th>Shift</th> */}
                            <th>From</th>
                            <th>Till</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.entryType.Single ||
                            this.state.entryType.Single == true ? (
                            <tr>
                              <td>{dateTime.getDateFormat(updateEvent[4])}</td>
                              <td>{updateEvent[0]}</td>
                              {/* <td>{this.state.inputData.Shift}</td> */}
                              <td>{dateTime.getTime(updateEvent[4])}</td>
                              <td>{dateTime.getTime(updateEvent[5])}</td>
                            </tr>
                          ) : (
                            updateEventMultiple.map((one) => {
                              return (
                                <tr>
                                  <td>{dateTime.getDateFormat(one[4])}</td>
                                  <td>{one[0]}</td>
                                  <td>
                                    {this.state.inputData &&
                                      this.state.inputData.Shift &&
                                      this.state.inputData.Shift}
                                  </td>
                                  <td>{dateTime.getTime(one[4])}</td>
                                  <td>{dateTime.getTime(one[5])}</td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                      {(this.state.entryType.Single ||
                        this.state.entryType.Single == true) ? (
                        getSystemState(updateEvent, machineStates) == "Running" && this.state.company?.canConvertRunningToDown ? (
                          <>
                            <input
                              type="radio"
                              value="Down"
                              onChange={this.handleOnChangeRadio}
                              checked={radioStateSingle !== "Running"}
                              name="state"
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;<label>Down</label>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <input
                              type="radio"
                              value="Running"
                              onChange={this.handleOnChangeRadio}
                              checked={radioStateSingle == "Running"}
                              name="state"
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;<label>Running</label>
                          </>
                        ) : (
                          ""
                        )
                      ) : getSystemState(updateEvent, machineStates) ==
                        "Running" ? (
                        <>
                          <input
                            type="radio"
                            value="Down"
                            onChange={this.handleOnChangeRadio}
                            checked={radioStateSingle !== "Running"}
                            name="state"
                          />
                          &nbsp;&nbsp;&nbsp;&nbsp;<label>Down</label>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <input
                            type="radio"
                            value="Running"
                            onChange={this.handleOnChangeRadio}
                            checked={radioStateSingle == "Running"}
                            name="state"
                          />
                          &nbsp;&nbsp;&nbsp;&nbsp;<label>Running</label>
                        </>
                      ) : (
                        ""
                      )}
                      {/* {(updateEvent &&
                        getSystemState(updateEvent, machineStates)) ==
                        "Running" ? (
                        <>
                          <input
                            type="radio"
                            value="Down"
                            onChange={this.handleOnChangeRadio}
                            checked={radioStateSingle !== "Running"}
                            name="state"
                          />
                          &nbsp;&nbsp;&nbsp;&nbsp;<label>Down</label>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <input
                            type="radio"
                            value="Running"
                            onChange={this.handleOnChangeRadio}
                            checked={radioStateSingle == "Running"}
                            name="state"
                          />
                          &nbsp;&nbsp;&nbsp;&nbsp;<label>Running</label>
                        </>
                      ) : (
                        ""
                      )} */}
                    </Modal.Title>
                  </Modal.Header>
                  {!isRunningAndCannotConvert && <Modal.Body>
                    {this.state.entryType.Multiple == true ? (
                      <div className="">
                        {!HideDownTimeGroup && <div
                          hidden={radioStateSingle == "Running"}
                          className="form-group text-center"
                        >
                          <label className="small">Downtime Group</label>
                          {/* <select className='form-control form-control-sm' onChange={this.handleOnChangeReasonGroup} name='ReasonGroup'>
                <option>--Select Downtime Reasons Groups--</option>
                {reasonGroupList.map(one => {
                  return <option value={JSON.stringify(one)}>{one.DownTimeReasonGroup}</option>
                  })}
                  </select> */}
                          <MultiSelect
                            name="ReasonGroup"
                            masterName="DownTimeReasonGroup"
                            objLevel={1}
                            all={reasonGroupList}
                            selected={this.state.selectdeReason["ReasonGroup"]}
                            handleOnChange={this.handleOnChangeReasonGroup}
                          />
                          {/* {errors.ReasonGroup && (
                    <p className="text-danger " style={{ fontSize: 11 }}>
                      {errors.ReasonGroup}
                    </p>
                  )} */}
                        </div>}
                        <div
                          hidden={radioStateSingle == "Running"}
                          className="form-group text-center"
                        >
                          <label className="small">Downtime Reason</label>
                          {/* <select className='form-control form-control-sm' onChange={this.handleOnChangeReason} name='Reason'>
                <option>--Select Downtime Reasons--</option>
                {reasonList.map(one => {
                  return <option value={JSON.stringify(one)}>{one.Reason}</option>
                })}
                </select> */}
                          <MultiSelect
                            name="Reason"
                            masterName="Reason"
                            objLevel={1}
                            all={this.getFilteredReasonList()}
                            selected={this.state.selectdeReason["Reason"]}
                            handleOnChange={this.handleOnChangeReason}
                          />

                          {/* {errors.Reason && (
                    <p className="text-danger " style={{ fontSize: 11 }}>
                      {errors.Reason}
                    </p>
                  )} */}
                        </div>

                        {(ActionTakenForReason || this.state.selectdeReason["actionTaken"]) && <div
                          // hidden={radioStateSingle == "Running"}
                          className="form-group text-center"
                        >

                          <label className="small">Action Taken</label>
                          {/* <select className='form-control form-control-sm' onChange={this.handleOnChangeReason} name='Reason'>
                                        <option>--Select Downtime Reasons--</option>
                                        {reasonList.map(one => {
                                          return <option value={JSON.stringify(one)}>{one.Reason}</option>
                                        })}
                                        </select> */}
                          <MultiSelect
                            name="actionTaken"
                            masterName="actionTaken"
                            objLevel={1}
                            all={actionTakenList}
                            selected={this.state.selectdeReason["actionTaken"]}
                            handleOnChange={this.handleOnChangeActionChange}
                          />

                          {errors.Reason && (
                            <p className="text-danger " style={{ fontSize: 11 }}>
                              {errors.actionTaken}
                            </p>
                          )}
                        </div>}
                        <div className="form-group text-center">
                          <label className="small">Remarks</label>
                          <textarea
                            rows="2"
                            cols="65"
                            maxLength="50"
                            value={this.state.selectdeReason.Remarks}
                            placeholder="enter remarks..."
                            onChange={this.handleOnChangeRemarks}
                            className="form-control form-control-sm"
                            name="Remarks"
                          />
                        </div>
                        {this.renderEndCurrentJobTick({
                          reason: this.state.selectedReason?.Reason,
                          checked: this.state.selectedReason?.EndCurrentJob,
                          onChange: this.handleOnChangeRemarks,
                          disabled: this.state.entryType.Multiple,
                        })}
                      </div>
                    ) : ((this.state.entryType.Single == true)) ? (
                      <Tabs
                        defaultActiveKey="1"
                        type="card"
                        size={"small"}
                        onChange={this.handleTabChange}
                        items={this.getTabs(updateEvent).map((_, i) => {
                          const id = (i + 1);
                          return {
                            label: `${_}`,
                            key: `${id}`,
                            children: (
                              <>
                                {id == 1 ? (
                                  <div>
                                    {(radioStateSingle == "Down") && (updateEvent && updateEvent[1] && updateEvent[1] == "Running") ?
                                      <>
                                        {
                                          <div
                                            hidden={radioStateSingle == "Running"}
                                            className="form-group text-center"
                                          >
                                            <Tabs
                                              type="line"
                                              activeKey={this.state.runningTab}
                                              onChange={this.onRunningTabChange}
                                            // Optional content that appears to the right of the tab labels

                                            >
                                              <TabPane
                                                tab={
                                                  <span>
                                                    {/* <HomeOutlined /> */}
                                                    Full Down
                                                  </span>
                                                }
                                                key="home"
                                              >
                                                {!HideDownTimeGroup && <div
                                                  hidden={radioStateSingle == "Running"}
                                                  className="form-group text-center"
                                                >




                                                  <label className="small">
                                                    Downtime Group
                                                  </label>

                                                  <MultiSelect
                                                    name="ReasonGroup"
                                                    masterName="DownTimeReasonGroup"
                                                    objLevel={1}
                                                    all={reasonGroupList}
                                                    selected={
                                                      this.state.selectdeReason &&
                                                      this.state.selectdeReason[
                                                      "ReasonGroup"
                                                      ]
                                                    }
                                                    handleOnChange={this.handleOnChangeReasonGroup}


                                                  />

                                                </div>}
                                                <div
                                                  hidden={radioStateSingle == "Running"}
                                                  className="form-group text-center"
                                                >
                                                  <label className="small">
                                                    Downtime Reason
                                                  </label>

                                                  <MultiSelect
                                                    name="Reason"
                                                    masterName="Reason"
                                                    objLevel={1}
                                                    all={reasonList}
                                                    selected={
                                                      this.state.selectdeReason["Reason"]
                                                    }
                                                    handleOnChange={
                                                      this.handleOnChangeReason
                                                    }
                                                  />

                                                </div>

                                              </TabPane>

                                              <TabPane
                                                tab={
                                                  <span>
                                                    {/* <SettingOutlined /> */}
                                                    Partial Down
                                                  </span>
                                                }
                                                key="PartialDown"
                                              >

                                                <div className="row  bg-success  text-white p-2">

                                                  {/* From label */}
                                                  <div className="col text-center bg-success">
                                                    <label className="mb-0">Running From:</label>


                                                    {/* From input */}
                                                    <input
                                                      type="time"
                                                      name="from"
                                                      disabled
                                                      value={moment(updateEvent[4]).format('HH:mm')}
                                                      className="form-control form-control-sm  "
                                                    />
                                                  </div>

                                                  {/* Between 1 */}
                                                  <div className="col">
                                                    <label className="mb-0">From:</label>
                                                    <input
                                                      type="time"
                                                      name="From"
                                                      min="08:00"
                                                      max="18:00"
                                                      className="form-control form-control-sm "
                                                      value={this.state.PartialDowntime.From || ''}
                                                      onChange={(e) => this.handleInnerTimeChange('From', e.target.value)}
                                                    />
                                                  </div>

                                                  {/* Between 2 */}
                                                  <div className="col">
                                                    <label className="mb-0">Till:</label>

                                                    <input
                                                      type="time"
                                                      name="Till"
                                                      min="08:00"
                                                      max="18:00"
                                                      className="form-control form-control-sm "
                                                      value={this.state.PartialDowntime.Till || ''}
                                                      onChange={(e) => this.handleInnerTimeChange('Till', e.target.value)}
                                                    />
                                                  </div>

                                                  {/* Till label */}
                                                  <div className="col text-center bg-success" >
                                                    <label className="mb-0">Running Till:</label>

                                                    {/* Till input */}
                                                    <input
                                                      type="time"
                                                      name="till"
                                                      disabled
                                                      value={moment(updateEvent[5]).format('HH:mm')}
                                                      className="form-control form-control-sm  "
                                                    />
                                                  </div>

                                                </div>

                                                {!HideDownTimeGroup && <div
                                                  hidden={radioStateSingle == "Running"}
                                                  className="form-group text-center"
                                                >




                                                  <label className="small">
                                                    Downtime Group
                                                  </label>

                                                  <MultiSelect
                                                    name="ReasonGroup"
                                                    masterName="DownTimeReasonGroup"
                                                    objLevel={1}
                                                    all={reasonGroupList}
                                                    selected={
                                                      this.state.selectdeReason &&
                                                      this.state.selectdeReason[
                                                      "ReasonGroup"
                                                      ]
                                                    }
                                                    handleOnChange={
                                                      this.handleOnChangeReasonGroup
                                                    }
                                                  />

                                                </div>}
                                                <div
                                                  hidden={radioStateSingle == "Running"}
                                                  className="form-group text-center"
                                                >
                                                  <label className="small">
                                                    Downtime Reason
                                                  </label>

                                                  <MultiSelect
                                                    name="Reason"
                                                    masterName="Reason"
                                                    objLevel={1}
                                                    all={reasonList}
                                                    selected={
                                                      this.state.selectdeReason["Reason"]
                                                    }
                                                    handleOnChange={
                                                      this.handleOnChangeReason
                                                    }
                                                  />

                                                </div>

                                                <div className="col p-2 ">          {/* black outer area */}


                                                </div>
                                              </TabPane>


                                            </Tabs>

                                            {/* {errors.ReasonGroup && (
                                  <p
                                    className="text-danger "
                                    style={{ fontSize: 11 }}
                                  >
                                    {errors.ReasonGroup}
                                  </p>
                                )} */}
                                          </div>}
                                      </> : <>
                                        {!HideDownTimeGroup && <div
                                          hidden={radioStateSingle == "Running"}
                                          className="form-group text-center"
                                        >




                                          <label className="small">
                                            Downtime Group
                                          </label>

                                          <MultiSelect
                                            name="ReasonGroup"
                                            masterName="DownTimeReasonGroup"
                                            objLevel={1}
                                            all={reasonGroupList}
                                            selected={
                                              this.state.selectdeReason &&
                                              this.state.selectdeReason[
                                              "ReasonGroup"
                                              ]
                                            }
                                            handleOnChange={this.handleOnChangeReasonGroup}


                                          />

                                        </div>}
                                        <div
                                          hidden={radioStateSingle == "Running"}
                                          className="form-group text-center"
                                        >
                                          <label className="small">
                                            Downtime Reason
                                          </label>

                                          <MultiSelect
                                            name="Reason"
                                            masterName="Reason"
                                            objLevel={1}
                                            all={reasonList}
                                            selected={
                                              this.state.selectdeReason["Reason"]
                                            }
                                            handleOnChange={
                                              this.handleOnChangeReason
                                            }
                                          />

                                        </div>
                                      </>}


                                    {ActionTakenForReason && this.state.InitiateBreakdown == true && <div
                                      // hidden={radioStateSingle == "Running"}
                                      className="form-group text-center"
                                    >

                                      <label className="small">Action Taken</label>
                                      {/* <select className='form-control form-control-sm' onChange={this.handleOnChangeReason} name='Reason'>
                <option>--Select Downtime Reasons--</option>
                {reasonList.map(one => {
                  return <option value={JSON.stringify(one)}>{one.Reason}</option>
                })}
                </select> */}
                                      <MultiSelect
                                        name="actionTaken"
                                        masterName="actionTaken"
                                        objLevel={1}
                                        all={actionTakenList}
                                        selected={this.state.selectdeReason["actionTaken"]}
                                        handleOnChange={this.handleOnChangeActionChange}
                                      />

                                      {errors.Reason && (
                                        <p className="text-danger " style={{ fontSize: 11 }}>
                                          {errors.actionTaken}
                                        </p>
                                      )}
                                    </div>}
                                    {reasonList.find(x => x.Reason == this.state.selectdeReason["Reason"]) && reasonList.find(x => x.Reason == this.state.selectdeReason["Reason"]).IsOpenBreakdown &&
                                      <div>
                                        {!this.state.breakdownData ?
                                          <div
                                            hidden={radioStateSingle == "Running"}
                                            className="form-group text-center d-flex"
                                          >

                                            {/* <div>
                                              <label className="small">Do you want to initiate breakdown?</label>
                                            </div>
                                            <div className="d-flex ml-3" >
                                              <input
                                                name="InitiateBreakdown"
                                                type="radio"
                                                checked={this.state.selectdeReason.InitiateBreakdown == true}
                                                onChange={(e) => this.handleOnChangeBreakdownInitiate({ currentTarget: { name: "InitiateBreakdown", checked: true } })}
                                              />
                                              <label className=" ml-1  mt-1 mr-2"> Yes</label>
                                              <input
                                                name="InitiateBreakdown"
                                                type="radio"
                                                checked={this.state.selectdeReason.InitiateBreakdown == false}
                                                onChange={(e) => this.handleOnChangeBreakdownInitiate({ currentTarget: { name: "InitiateBreakdown", checked: false } })}
                                              />
                                              <label className="ml-1  mt-1 mr-2"> No</label>
                                            </div> */}
                                          </div> : 'Tool breakdown is already initiated in TMS'}
                                        {/* {transferTypeTools.length > 1 && this.state.selectdeReason.InitiateBreakdown && <div>
                                          <label className="small">The component has a transfer-type tool. Please select the tool you want to initiate the breakdown.</label><br />
                                          {transferTypeTools && transferTypeTools.map((tool, index) => {
                                            return <label className="ml-3"><input type="radio" checked={tool == this.state.selectdeReason.TransferTypeTool} value={tool} name="TransferTypeTool" onChange={this.handleOnChangeTransferType} /> &nbsp; {tool}</label>
                                          })}
                                        </div>} */}
                                        {!this.state.breakdownData && this.state.selectdeReason.InitiateBreakdown && !this.isBreakdownTypeEditingHidden(this.state.selectdeReason["Reason"]) && <>
                                          <div className="justify-content-center ">
                                            <div className="form-group text-center">
                                              <label>Breakdown Type</label>
                                              <MultiSelect
                                                // 5isDisable={this.state.downTimeReason.BreakdownType === 'Down' ? true : false}
                                                name="BreakdownType" master={true} selected={this.state.selectedBreakdownType} handleOnChange={(e) => {
                                                  this.handleOnChangeTransferType(e);
                                                  this.setState({ selectedBreakdownType: e.currentTarget.value });
                                                }} masterName="RequestType" objLevel={1} all={this.state.breakdownTypes} />
                                              {errors && errors.BreakdownType && <div className="alert small alert-danger">{errors['BreakdownType']}</div>}
                                            </div>
                                          </div>
                                          {(this.state.selectedBreakdownType == "Others") &&
                                            <div className="justify-content-center ">
                                              <div className="form-group text-center">
                                                <label>Enter Breakdown Type</label>
                                                <input
                                                  // disabled={this.state.downTimeReason.BreakdownDesc === 'Down' ? true : false}
                                                  type="text"
                                                  className="form-control"
                                                  placeholder="Enter Breakdown Type"
                                                  name="BreakdownType"
                                                  onChange={this.handleOnChangeTransferType}
                                                // defaultValue={this.state.selectdeReason.BreakdownType}
                                                />
                                                {errors && errors.BreakdownType && <div className="alert small alert-danger">{errors['BreakdownType']}</div>}
                                              </div>
                                            </div>}
                                          <div className="justify-content-center">
                                            <div className="form-group text-center">
                                              <label>Breakdown Description</label>
                                              <input
                                                // disabled={this.state.downTimeReason.BreakdownDesc === 'Down' ? true : false}
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Breakdown Desc"
                                                name="BreakdownDesc"
                                                onChange={this.handleOnChangeTransferType}
                                                defaultValue={this.state.selectdeReason.BreakdownDesc}
                                              />
                                              {errors && errors.BreakdownDesc && <div className="alert small alert-danger">{errors['BreakdownDesc']}</div>}
                                            </div>
                                          </div></>}
                                      </div>}
                                    <div className="form-group text-center">
                                      <label className="small">Remarks</label>
                                      <textarea
                                        rows="2"
                                        cols="65"
                                        maxLength="50"
                                        value={
                                          this.state.selectdeReason.Remarks
                                        }
                                        placeholder="enter remarks..."
                                        onChange={this.handleOnChangeRemarks}
                                        className="form-control form-control-sm"
                                        name="Remarks"
                                      />
                                    </div>
                                    {this.renderEndCurrentJobTick({
                                      reason: this.state.selectedReason?.Reason,
                                      checked: this.state.selectedReason?.EndCurrentJob,
                                      onChange: this.handleOnChangeRemarks,
                                      disabled: this.state.entryType.Multiple,
                                    })}
                                  </div>
                                ) : (
                                  <div>
                                    <div className="p-2 border">
                                      {/* Input for Number of Reasons */}
                                      <div>
                                        <label htmlFor="noOfReasons">
                                          No. of Reasons :
                                        </label>

                                        <Space>
                                          <InputNumber
                                            onKeyDown={(e) =>
                                              e.preventDefault()
                                            } // Prevent key presses
                                            onKeyPress={(e) =>
                                              e.preventDefault()
                                            } // Prevent other keyboard actions
                                            onPaste={(e) => e.preventDefault()} // Prevent pasting into the input
                                            min={2}
                                            max={10}
                                            value={noOfReasons}
                                            onChange={(e) => {
                                              const reasonsCount = Number(e);
                                              if (reasonsCount > 0) {
                                                // console.log(this.generateSplits(updateEvent[4],updateEvent[5],reasonsCount),"current split data")
                                                this.setState({
                                                  Split: this.generateSplits(
                                                    updateEvent[4],
                                                    updateEvent[5],
                                                    reasonsCount - 1,
                                                    selectedEquipment &&
                                                      selectedEquipment?.DownTimeThresold
                                                      ? selectedEquipment.DownTimeThresold
                                                      : 0,
                                                    selectedEquipment
                                                  ),
                                                  noOfReasons: e,
                                                });
                                              } else {
                                                this.setState({ Split: [] });
                                              }
                                            }}
                                          />
                                          {/* <Button
        type="primary"
        onClick={() => {
          setValue(2);
        }}
      >
        Reset
      </Button> */}
                                        </Space>
                                      </div>

                                      <label className="mx-2">From :</label>
                                      <input
                                        type="datetime-local"
                                        disabled
                                        value={
                                          updateEvent[4]
                                            ? moment(updateEvent[4]).format(
                                              "YYYY-MM-DDTHH:mm"
                                            )
                                            : ""
                                        }
                                        name="split-212"
                                      />

                                      {/* Split Inputs */}
                                      {Split?.map((_, idx) => (
                                        <div className="border rounded mb-2 bg-light" key={idx}>
                                          <div className="px-3 py-2 border-bottom bg-white d-flex justify-content-between align-items-center">
                                            <strong>Part {idx + 1}</strong>
                                            <span className="small text-muted">
                                              {moment(_.from).format("HH:mm")} - {moment(_.till).format("HH:mm")}
                                            </span>
                                          </div>
                                          <div class="container text-center py-2">
                                            <div class="row">
                                              <div class="col-sm-3 p-2">
                                                <div className="row">
                                                  <div class="col-sm-9 p-1">
                                                    <div className="form-group text-left">
                                                      <label className="small font-weight-bold mb-1">
                                                        From
                                                      </label>
                                                      <input
                                                        className="form-control form-control-sm"
                                                        disabled
                                                        value={moment(
                                                          _.from
                                                        ).format("HH:mm")}
                                                        onChange={(e) => {
                                                          this.handleSplitTimeChange(
                                                            e,
                                                            idx,
                                                            "from",
                                                            {
                                                              from: moment(
                                                                updateEvent[4]
                                                              ).format(
                                                                "YYYY-MM-DDTHH:mm"
                                                              ),
                                                              till: moment(
                                                                updateEvent[5]
                                                              ).format(
                                                                "YYYY-MM-DDTHH:mm"
                                                              ),
                                                            }
                                                          );
                                                        }}
                                                        type="time"
                                                        name={`from-${idx + 1}`}
                                                      />
                                                    </div>
                                                  </div>
                                                  <div class="col-sm-9 p-1">
                                                    <div className="form-group text-left">
                                                      <label className="small font-weight-bold mb-1">
                                                        Till
                                                      </label>
                                                      <input
                                                        className="form-control form-control-sm"
                                                        min={"08:00"}
                                                        max={"18:00"}
                                                        onChange={(e) => {
                                                          this.handleSplitTimeChange(
                                                            e,
                                                            idx,
                                                            "till",
                                                            {
                                                              from: moment(
                                                                updateEvent[4]
                                                              ).format(
                                                                "YYYY-MM-DDTHH:mm"
                                                              ),
                                                              till: moment(
                                                                updateEvent[5]
                                                              ).format(
                                                                "YYYY-MM-DDTHH:mm"
                                                              ),
                                                            }
                                                          );
                                                        }}
                                                        disabled={
                                                          idx ==
                                                            Split.length - 1
                                                            ? true
                                                            : false
                                                        }
                                                        value={moment(
                                                          _.till
                                                        ).format("HH:mm")}
                                                        type="time"
                                                        name={`till-${idx + 1}`}
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-sm-9">
                                                <div class="row">
                                                  {!HideDownTimeGroup && <div class="col-8 col-sm-6">
                                                    <div
                                                      hidden={
                                                        radioStateSingle ==
                                                        "Running"
                                                      }
                                                      className="form-group text-center "
                                                    >
                                                      <label className="small">
                                                        Downtime Group
                                                      </label>

                                                      <MultiSelect
                                                        name="ReasonGroup"
                                                        masterName="DownTimeReasonGroup"
                                                        objLevel={1}
                                                        all={reasonGroupList}
                                                        selected={
                                                          (reasonSplitGroupList &&
                                                            reasonSplitGroupList[
                                                            idx
                                                            ] &&
                                                            reasonSplitGroupList[
                                                              idx
                                                            ].selectdeReason[
                                                            "ReasonGroup"
                                                            ]) ??
                                                          ""
                                                        }
                                                        handleOnChange={(e) =>
                                                          this.handleOnChangeReasonGroup(
                                                            e,
                                                            "Split",
                                                            idx
                                                          )
                                                        }
                                                      />

                                                      {/* {errors.ReasonGroup && (
                                                  <p
                                                    className="text-danger "
                                                    style={{ fontSize: 11 }}
                                                  >
                                                    {errors.ReasonGroup}
                                                  </p>
                                                )} */}
                                                    </div>
                                                  </div>}
                                                  <div class="col-4 col-sm-6">
                                                    <div
                                                      hidden={
                                                        radioStateSingle ==
                                                        "Running"
                                                      }
                                                      className="form-group text-center "
                                                    >
                                                      <label className="small">
                                                        Downtime Reason
                                                      </label>

                                                      <MultiSelect
                                                        name="Reason"
                                                        masterName="Reason"
                                                        objLevel={1}
                                                        all={HideDownTimeGroup == true ? this.getFilteredReasonList() :
                                                          (reasonSplitGroupList &&
                                                            reasonSplitGroupList[
                                                            idx
                                                            ] &&
                                                            reasonSplitGroupList[
                                                              idx
                                                            ].ReasonList
                                                            ? reasonSplitGroupList[
                                                              idx
                                                            ].ReasonList
                                                            : [])
                                                        }
                                                        selected={
                                                          (_ &&
                                                            _?.DowntimeReason &&
                                                            _.DowntimeReason[
                                                            "Reason"
                                                            ]) ??
                                                          ""
                                                        }
                                                        handleOnChange={(e) =>
                                                          this.handleOnChangeReason(
                                                            e,
                                                            "Split",
                                                            idx
                                                          )
                                                        }
                                                      />
                                                      {/* {errors.Reason && (_ && _?.DowntimeReason && _.DowntimeReason["Reason"] )  =='' && (
                                                  <p
                                                    className="text-danger "
                                                    style={{ fontSize: 11 }}
                                                  >
                                                    {errors.Reason}
                                                  </p>
                                                )} */}
                                                    </div>
                                                  </div>

                                                  {_?.DowntimeReason && reasonList.find(x => x.Reason == _?.DowntimeReason["Reason"]) && reasonList.find(x => x.Reason == _?.DowntimeReason["Reason"]).IsOpenBreakdown &&
                                                    <div>
                                                      <div>
                                                        <label className="small">To initiate a breakdown, please enter a single downtime entry.</label>
                                                      </div>
                                                    </div>}

                                                  {_?.DowntimeReason?.ActionTakenForReason ? (
                                                    <div className="form-group text-center">
                                                      <label className="small">Action Taken</label>

                                                      <MultiSelect
                                                        name="actionTaken"
                                                        masterName="actionTaken"
                                                        objLevel={1}
                                                        all={actionTakenList || []}
                                                        selected={(_ &&
                                                          _?.DowntimeReason &&
                                                          _.DowntimeReason[
                                                          "actionTaken"
                                                          ]) ??
                                                          ""}
                                                        handleOnChange={(e) => this.handleOnChangeActionChange(e, "Split", idx)}
                                                      />

                                                      {/* {errors.actionTaken && !_?.DowntimeReason?.actionTaken && (
                                                        <p className="text-danger" style={{ fontSize: 11 }}>
                                                          {errors.actionTaken}
                                                        </p>
                                                      )} */}
                                                    </div>
                                                  ) : null}
                                                  <div class="col-4 col-sm-6">
                                                    <div className="form-group text-center">
                                                      <label className="small">
                                                        Remarks
                                                      </label>
                                                      <textarea
                                                        rows="2"
                                                        cols="65"
                                                        maxLength="50"
                                                        value={
                                                          (_ &&
                                                            _?.DowntimeReason &&
                                                            _.DowntimeReason[
                                                            "Remarks"
                                                            ]) ??
                                                          ""
                                                        }
                                                        placeholder="enter remarks..."
                                                        onChange={(e) =>
                                                          this.handleOnChangeRemarks(
                                                            e,
                                                            "Split",
                                                            idx
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                        name="Remarks"
                                                      />
                                                    </div>
                                                  </div>
                                                  <div class="col-4 col-sm-6">
                                                    {this.renderEndCurrentJobTick({
                                                      reason: _?.DowntimeReason?.["Reason"],
                                                      checked: _?.EndCurrentJob,
                                                      onChange: (e) => this.handleOnChangeRemarks(e, "Split", idx),
                                                      disabled: this.state.entryType.Multiple,
                                                      wrapperClassName: "form-group text-center d-flex p-3",
                                                      labelClassName: "form-check-label small  ",
                                                    })}
                                                    <div class="col-6 col-sm-8">
                                                      {/* {reasonSplitGroupList[idx] && reasonSplitGroupList[idx].ReasonList && reasonSplitGroupList[idx].ReasonList.find(x => _?.DowntimeReason && x.Reason == _?.DowntimeReason["Reason"]) &&
                                                        reasonSplitGroupList[idx].ReasonList.find(x => _?.DowntimeReason && x.Reason == _?.DowntimeReason["Reason"]).IsOpenBreakdown &&
                                                        <div
                                                          className="form-group text-center d-flex"
                                                        >
                                                          <div>
                                                            <label className="small">Do you want to initiate breakdown?</label>
                                                          </div>
                                                          <div className="d-flex ml-3" >
                                                            <input
                                                              name={"InitiateBreakdown" + idx}
                                                              type="radio"
                                                              checked={_?.InitiateBreakdown == true}
                                                              onChange={(e) => this.handleOnChangeRemarks({ currentTarget: { name: "InitiateBreakdown", checked: true } }, "Split", idx)}
                                                            />
                                                            <label className=" ml-1  mt-1 mr-2"> Yes</label>
                                                            <input
                                                              name={"InitiateBreakdown" + idx}
                                                              type="radio"
                                                              checked={_?.InitiateBreakdown == false}
                                                              onChange={(e) => this.handleOnChangeRemarks({ currentTarget: { name: "InitiateBreakdown", checked: false } }, "Split", idx)}
                                                            />
                                                            <label className="ml-1  mt-1 mr-2"> No</label>
                                                          </div>
                                                        </div>} */}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}

                                      {/* { old: { Shift: , Equipment:, State: , From: , Till:  }, new: { Shift: , Equipment: , Remarks: , Reason: , EndCurrentJob: , ReasonGroup: , From: , Till:} } */}
                                      {/* Till Date/Time */}
                                      <label className="m-2">Till :</label>
                                      <input
                                        type="datetime-local"
                                        disabled
                                        value={
                                          updateEvent[5]
                                            ? moment(updateEvent[5]).format(
                                              "YYYY-MM-DDTHH:mm"
                                            )
                                            : ""
                                        }
                                        name="split-212"
                                      />
                                    </div>
                                  </div>
                                )}
                              </>
                            ),
                          };
                        })}
                      />
                    ) : this.state.entryType.Single == true &&
                      this.state.SelectedReason.Reason == "Running" ? (
                      <div className="">
                        {!HideDownTimeGroup && <div
                          hidden={radioStateSingle == "Running"}
                          className="form-group text-center"
                        >
                          <label className="small">Downtime Group</label>
                          {/* <select className='form-control form-control-sm' onChange={this.handleOnChangeReasonGroup} name='ReasonGroup'>
                <option>--Select Downtime Reasons Groups--</option>
                {reasonGroupList.map(one => {
                  return <option value={JSON.stringify(one)}>{one.DownTimeReasonGroup}</option>
                  })}
                  </select> */}
                          <MultiSelect
                            name="ReasonGroup"
                            masterName="DownTimeReasonGroup"
                            objLevel={1}
                            all={reasonGroupList}
                            selected={this.state.selectdeReason["ReasonGroup"]}
                            handleOnChange={this.handleOnChangeReasonGroup}
                          />
                          {/* {errors.ReasonGroup && (
                    <p className="text-danger " style={{ fontSize: 11 }}>
                      {errors.ReasonGroup}
                    </p>
                  )} */}
                        </div>}
                        <div
                          hidden={radioStateSingle == "Running"}
                          className="form-group text-center"
                        >
                          <label className="small">Downtime Reason</label>
                          {/* <select className='form-control form-control-sm' onChange={this.handleOnChangeReason} name='Reason'>
                <option>--Select Downtime Reasons--</option>
                {reasonList.map(one => {
                  return <option value={JSON.stringify(one)}>{one.Reason}</option>
                })}
                </select> */}
                          <MultiSelect
                            name="Reason"
                            masterName="Reason"
                            objLevel={1}
                            all={reasonList}
                            selected={this.state.selectdeReason["Reason"]}
                            handleOnChange={this.handleOnChangeReason}
                          />
                          {/* 
                  {errors.Reason && (
                    <p className="text-danger " style={{ fontSize: 11 }}>
                      {errors.Reason}
                    </p>
                  )} */}
                        </div>
                        {ActionTakenForReason && <div
                          // hidden={radioStateSingle == "Running"}
                          className="form-group text-center"
                        >

                          <label className="small">Action Taken</label>
                          {/* <select className='form-control form-control-sm' onChange={this.handleOnChangeReason} name='Reason'>
                                                                                    <option>--Select Downtime Reasons--</option>
                                                                                    {reasonList.map(one => {
                                                                                      return <option value={JSON.stringify(one)}>{one.Reason}</option>
                                                                                    })}
                                                                                    </select> */}
                          <MultiSelect
                            name="actionTaken"
                            masterName="actionTaken"
                            objLevel={1}
                            all={actionTakenList}
                            selected={this.state.selectdeReason["actionTaken"]}
                            handleOnChange={this.handleOnChangeActionChange}
                          />

                          {errors.Reason && (
                            <p className="text-danger " style={{ fontSize: 11 }}>
                              {errors.actionTaken}
                            </p>
                          )}
                        </div>}
                        <div className="form-group text-center">
                          <label className="small">Remarks</label>
                          <textarea
                            rows="2"
                            cols="65"
                            maxLength="50"
                            value={this.state.selectdeReason.Remarks}
                            placeholder="enter remarks..."
                            onChange={this.handleOnChangeRemarks}
                            className="form-control form-control-sm"
                            name="Remarks"
                          />
                        </div>

                        {this.renderEndCurrentJobTick({
                          reason: this.state.selectedReason?.Reason,
                          checked: this.state.selectedReason?.EndCurrentJob,
                          onChange: this.handleOnChangeRemarks,
                          disabled: this.state.entryType.Multiple,
                        })}
                      </div>
                    ) : (
                      <div className="">
                        {!HideDownTimeGroup && <div
                          hidden={radioStateSingle == "Running"}
                          className="form-group text-center"
                        >
                          <label className="small">Downtime Group</label>
                          {/* <select className='form-control form-control-sm' onChange={this.handleOnChangeReasonGroup} name='ReasonGroup'>
                <option>--Select Downtime Reasons Groups--</option>
                {reasonGroupList.map(one => {
                  return <option value={JSON.stringify(one)}>{one.DownTimeReasonGroup}</option>
                  })}
                  </select> */}
                          <MultiSelect
                            name="ReasonGroup"
                            masterName="DownTimeReasonGroup"
                            objLevel={1}
                            all={reasonGroupList}
                            selected={this.state.selectdeReason["ReasonGroup"]}
                            handleOnChange={this.handleOnChangeReasonGroup}
                          />
                          {/* {errors.ReasonGroup && (
                    <p className="text-danger " style={{ fontSize: 11 }}>
                      {errors.ReasonGroup}
                    </p>
                  )} */}
                        </div>}
                        <div
                          hidden={radioStateSingle == "Running"}
                          className="form-group text-center"
                        >
                          <label className="small">Downtime Reason</label>
                          {/* <select className='form-control form-control-sm' onChange={this.handleOnChangeReason} name='Reason'>
                <option>--Select Downtime Reasons--</option>
                {reasonList.map(one => {
                  return <option value={JSON.stringify(one)}>{one.Reason}</option>
                })}
                </select> */}
                          <MultiSelect
                            name="Reason"
                            masterName="Reason"
                            objLevel={1}
                            all={reasonList}
                            selected={this.state.selectdeReason["Reason"]}
                            handleOnChange={this.handleOnChangeReason}
                          />

                          {/* {errors.Reason && (
                    <p className="text-danger " style={{ fontSize: 11 }}>
                      {errors.Reason}
                    </p>
                  )} */}
                        </div>
                        <div className="form-group text-center">
                          <label className="small">Remarks</label>
                          <textarea
                            rows="2"
                            cols="65"
                            maxLength="50"
                            value={this.state.selectdeReason.Remarks}
                            placeholder="enter remarks..."
                            onChange={this.handleOnChangeRemarks}
                            className="form-control form-control-sm"
                            name="Remarks"
                          />
                        </div>

                        {this.renderEndCurrentJobTick({
                          reason: this.state.selectedReason?.Reason,
                          checked: this.state.selectedReason?.EndCurrentJob,
                          onChange: this.handleOnChangeRemarks,
                          disabled: this.state.entryType.Multiple,
                        })}
                      </div>
                    )}
                    {/* {this.state.entryType.Single== true ?  (
              <div className="">
                <div
                  hidden={radioStateSingle == "Running"}
                  className="form-group text-center"
                >
                  <label className="small">Downtime Group</label>
                 
                  <MultiSelect
                    name="ReasonGroup"
                    masterName="DownTimeReasonGroup"
                    objLevel={1}
                    all={reasonGroupList}
                    selected={this.state.selectdeReason["ReasonGroup"]}
                    handleOnChange={this.handleOnChangeReasonGroup}
                  />
                  {errors.ReasonGroup && (
                    <p className="text-danger " style={{ fontSize: 11 }}>
                      {errors.ReasonGroup}
                    </p>
                  )}
                </div>
                <div
                  hidden={radioStateSingle == "Running"}
                  className="form-group text-center"
                >
                  <label className="small">Downtime Reason</label>
                 
                  <MultiSelect
                    name="Reason"
                    masterName="Reason"
                    objLevel={1}
                    all={reasonList}
                    selected={this.state.selectdeReason["Reason"]}
                    handleOnChange={this.handleOnChangeReason}
                  />

                  {errors.Reason && (
                    <p className="text-danger " style={{ fontSize: 11 }}>
                      {errors.Reason}
                    </p>
                  )}
                </div>
                <div className="form-group text-center">
                  <label className="small">Remarks</label>
                  <textarea
                    rows="2"
                    cols="65"
                    maxLength="50"
                    value={this.state.selectdeReason.Remarks}
                    placeholder="enter remarks..."
                    onChange={this.handleOnChangeRemarks}
                    className="form-control form-control-sm"
                    name="Remarks"
                  />
                </div>

                <div className="form-group text-center ">
                  <label
                    className="form-check-label small mr-4 "
                    for="flexCheckChecked"
                  >
                    End Current Job
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    disabled={this.state.entryType.Multiple}
                    onChange={this.handleOnChangeRemarks}
                    name="EndCurrentJob"
                  />
                </div>
              </div>
            ) : ( */}
                    {/* <>
                {this.state.updateEventMultiple.length < 2 && this.state.entryType.Single== true &&   this.getSystemState(updateEvent) !== "Running" &&  radioStateSingle !== "Down" &&
                <Tabs
                  defaultActiveKey="1"
                  type="card"
                  size={"small"}
                  onChange={this.handleTabChange }
                  items={[
                    "Single Downtime Reason",
                    "Multiple Downtime Reason",
                  ].map((_, i) => {
                    const id = String(i + 1);
                    return {
                      label: `${_}`,
                      key: id,
                      children: (
                        <>
                          {id == 1 ? (
                            <div>
                              {" "}
                              <div
                                hidden={radioStateSingle == "Running"}
                                className="form-group text-center"
                              >
                                <label className="small">Downtime Group</label>

                                <MultiSelect
                                  name="ReasonGroup"
                                  masterName="DownTimeReasonGroup"
                                  objLevel={1}
                                  all={reasonGroupList}
                                  selected={
                                    this.state.selectdeReason["ReasonGroup"]
                                  }
                                  handleOnChange={
                                    this.handleOnChangeReasonGroup
                                  }
                                />
                                {errors.ReasonGroup && (
                                  <p
                                    className="text-danger "
                                    style={{ fontSize: 11 }}
                                  >
                                    {errors.ReasonGroup}
                                  </p>
                                )}
                              </div>
                              <div
                                hidden={radioStateSingle == "Running"}
                                className="form-group text-center"
                              >
                                <label className="small">Downtime Reason</label>

                                <MultiSelect
                                  name="Reason"
                                  masterName="Reason"
                                  objLevel={1}
                                  all={reasonList}
                                  selected={this.state.selectdeReason["Reason"]}
                                  handleOnChange={this.handleOnChangeReason}
                                />

                                {errors.Reason && (
                                  <p
                                    className="text-danger "
                                    style={{ fontSize: 11 }}
                                  >
                                    {errors.Reason}
                                  </p>
                                )}
                              </div>
                              <div className="form-group text-center">
                                <label className="small">Remarks</label>
                                <textarea
                                  rows="2"
                                  cols="65"
                                  maxLength="50"
                                  value={this.state.selectdeReason.Remarks}
                                  placeholder="enter remarks..."
                                  onChange={this.handleOnChangeRemarks}
                                  className="form-control form-control-sm"
                                  name="Remarks"
                                />
                              </div>
                              {this.renderEndCurrentJobTick({
                                reason: this.state.selectedReason?.Reason,
                                checked: this.state.selectedReason?.EndCurrentJob,
                                onChange: this.handleOnChangeRemarks,
                                disabled: this.state.entryType.Multiple,
                                alwaysShow: true,
                              })}
                            </div>
                          ) : (
                            <div>
                              <div className="p-2 border">
                                <div >
                                  <label htmlFor="noOfReasons">
                                    No. of Reasons :
                                  </label>

                                  <Space>
                                    <InputNumber
                                      onKeyDown={(e) => e.preventDefault()} // Prevent key presses
                                      onKeyPress={(e) => e.preventDefault()} // Prevent other keyboard actions
                                      onPaste={(e) => e.preventDefault()} // Prevent pasting into the input
                                      min={2}
                                      max={10}
                                      value={noOfReasons}
                                      onChange={(e) => {
                                        console.log(e, "duhvk");

                                        const reasonsCount = Number(e);
                                        if (reasonsCount > 0) {
                                          // console.log(this.generateSplits(updateEvent[4],updateEvent[5],reasonsCount),"current split data")
                                          this.setState({
                                            Split: this.generateSplits(
                                              updateEvent[4],
                                              updateEvent[5],
                                              reasonsCount - 1,(selectedEquipment && selectedEquipment?.DownTimeThresold ? selectedEquipment.DownTimeThresold : 0)
                                              ,selectedEquipment),
                                            noOfReasons: e,
                                          });
                                        } else {
                                          this.setState({ Split: [] });
                                        }
                                      }}
                                    />
                    
                                  </Space>
                                </div>

                                <label className="mx-2">From :</label>
                                <input
                                  type="datetime-local"
                                  disabled
                                  value={
                                    updateEvent[4]
                                      ? moment(updateEvent[4]).format(
                                          "YYYY-MM-DDTHH:mm"
                                        )
                                      : ""
                                  }
                                  name="split-212"
                                />

                                {Split?.map((_, idx) => (
                                  <div className="border" key={idx}>
                                    <div class="container text-center">
                                      <div class="row">
                                        <div class="col-sm-3 p-2">
                                          <div className="row">
                                            <div class="col-sm-9 p-1">
                                              <div className="form-group text-center ">
                                                <label>
                                                  &nbsp;&nbsp;&nbsp;From :{" "}
                                                  {idx + 1}
                                                </label>
                                                <input
                                                  disabled
                                                  value={moment(_.from).format(
                                                    "HH:mm"
                                                  )}
                                                  onChange={(e)=>{this.handleSplitTimeChange(e,idx,'from',{from:moment(updateEvent[4]).format(
                                                    "YYYY-MM-DDTHH:mm"
                                                  ),till:moment(updateEvent[5]).format(
                                                    "YYYY-MM-DDTHH:mm"
                                                  )})}}
                                                  type="time"
                                                  name={`from-${idx + 1}`}
                                                 
                                                />
                                              </div>
                                            </div>
                                            <div class="col-sm-9 p-1">
                                              <div className="form-group text-center ">
                                                <label>
                                                  &nbsp;&nbsp;&nbsp;&nbsp;Till :{" "}
                                                  {idx + 1}
                                                </label>
                                                <input
                                                  min={"08:00"}
                                                  max={"18:00"}
                                                  onChange={(e)=>{this.handleSplitTimeChange(e,idx,'till',{from:moment(updateEvent[4]).format(
                                                    "YYYY-MM-DDTHH:mm"
                                                  ),till:moment(updateEvent[5]).format(
                                                    "YYYY-MM-DDTHH:mm"
                                                  )})}}

                                                  disabled={
                                                    idx == Split.length - 1
                                                      ? true
                                                      : false
                                                  }
                                                  value={moment(_.till).format(
                                                    "HH:mm"
                                                  )}
                                                  type="time"
                                                  name={`till-${idx + 1}`}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-sm-9">
                                          <div class="row">
                                            <div class="col-8 col-sm-6">
                                              <div
                                                hidden={
                                                  radioStateSingle == "Running"
                                                }
                                                className="form-group text-center "
                                              >
                                                <label className="small">
                                                  Downtime Group
                                                </label>

                                                <MultiSelect
                                                  name="ReasonGroup"
                                                  masterName="DownTimeReasonGroup"
                                                  objLevel={1}
                                                  all={reasonGroupList}
                                                  selected={
                                                  (reasonSplitGroupList &&  reasonSplitGroupList[idx] && reasonSplitGroupList[idx].selectdeReason
                                                    [
                                                      "ReasonGroup"] )?? ''
                                                  }
                                                  handleOnChange={(e)=>
                                                    this.handleOnChangeReasonGroup(e,'Split',idx)
                                                  }
                                                />
                                                {console.log(reasonSplitGroupList,"dwiudui")}
                                                {errors.ReasonGroup && (
                                                  <p
                                                    className="text-danger "
                                                    style={{ fontSize: 11 }}
                                                  >
                                                    {errors.ReasonGroup}
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                            <div class="col-4 col-sm-6">
                                              <div
                                                hidden={
                                                  radioStateSingle == "Running"
                                                }
                                                className="form-group text-center "
                                              >
                                                <label className="small">
                                                  Downtime Reason
                                                </label>

                                                <MultiSelect
                                                  name="Reason"
                                                  masterName="Reason"
                                                  objLevel={1}
                                                  all={(reasonSplitGroupList && reasonSplitGroupList[idx] && reasonSplitGroupList[idx].ReasonList) ? reasonSplitGroupList[idx].ReasonList:[]}
                                                  selected={
                                                    (_ && _?.DowntimeReason && _.DowntimeReason[
                                                      "Reason"
] )?? ''
                                                  }
                                                  handleOnChange={
                                                    (e)=>this.handleOnChangeReason(e,"Split",idx)
                                                  }
                                                />

                                                {errors.Reason && (
                                                  <p
                                                    className="text-danger "
                                                    style={{ fontSize: 11 }}
                                                  >
                                                    {errors.Reason}
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                            <div class="col-4 col-sm-6">
                                              <div className="form-group text-center">
                                                <label className="small">
                                                  Remarks
                                                </label>
                                                <textarea
                                                  rows="2"
                                                  cols="65"
                                                  maxLength="50"
                                                  value={
                                                    (_ && _?.DowntimeReason && _.DowntimeReason["Remarks"] )?? ''}
                                                
                                                  placeholder="enter remarks..."
                                                  onChange={(e)=>
                                                    this.handleOnChangeRemarks(e,"Split",idx)
                                                  }
                                                  className="form-control form-control-sm"
                                                  name="Remarks"
                                                />
                                              </div>
                                            </div>
                                            <div class="col-4 col-sm-6">
                                              {this.renderEndCurrentJobTick({
                                                reason: _?.DowntimeReason?.["Reason"],
                                                checked: _?.EndCurrentJob,
                                                onChange: (e) => this.handleOnChangeRemarks(e, "Split", idx),
                                                disabled: this.state.entryType.Multiple,
                                                wrapperClassName: "form-group text-center d-flex p-3",
                                                labelClassName: "form-check-label small  ",
                                                alwaysShow: true,
                                              })}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}

                            
                                <label className="m-2">Till :</label>
                                <input
                                  type="datetime-local"
                                  disabled
                                  value={
                                    updateEvent[5]
                                      ? moment(updateEvent[5]).format(
                                          "YYYY-MM-DDTHH:mm"
                                        )
                                      : ""
                                  }
                                  name="split-212"
                                />
                              </div>
                            </div>
                          )}
                        </>
                      ),
                    };
                  })}
                />}
              </> */}
                    {/* ) */}
                    {/* } */}
                  </Modal.Body>}
                  <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleClose}>
                      Close
                    </Button>
                    {!isRunningAndCannotConvert && <Button
                      variant="primary"
                      onClick={() => {
                        if (this.state.SplitError) {
                          swal({
                            title: "Warning!",
                            text: "Cannot update unless the time split between downtime reasons is correct.",
                            icon: "warning",
                            button: {
                              text: "OK",
                              className: "swal-button--danger",
                            },
                            dangerMode: true,
                          });
                        } else {
                          if (this.state.runningTab === 'PartialDown' && radioStateSingle == 'Down') {


                            this.UpdatePartialDown(updateEvent)
                          } else {

                            this.handleReasonUpdate();
                          }
                        }
                      }}
                    >
                      Update Reason
                    </Button>}
                  </Modal.Footer>
                </Modal>
              )}

              {this.renderSettingsTabBar(settingsMenuItems)}
              <RouteErrorBoundary>
                <React.Suspense fallback={<Loading />}>
                  <Switch>
                    <Route
                      path="/setting/customequipmentgroup/add"
                      render={(props) => (
                        <CustomEquipmentGroup
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          customEquipmentGroupData={this.state.customEquipmentGroupData}
                          actionStatus={this.state.actionStatus}
                        />
                      )}
                    />
                    <Route
                      path="/setting/customequipmentgroup/list"
                      render={(props) => (
                        <CustomEquipmentGroupTable
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/"
                      exact
                      render={(props) => {
                        // Hold off only while the one-time default-landing-page decision
                        // is still pending, so the dashboard isn't mounted just to be
                        // replaced. After that, "/" always renders the Machine State
                        // Dashboard, including when it is reached from the menu.
                        if (this.state.defaultDashboardPending) {
                          return <Loading />;
                        }
                        return (
                          <MachineStateChart
                            refresh={true}
                            showRelay={true}
                            showRelayStates={!!this.state.filterObj.RelayView && hasRelayConfigured(this.state.equipList)}
                            id="Downtime"
                            EntryFrom={"Dashbaord"}
                            company={this.state.company}
                            stopCountdown={this.stopCountdown}
                            entryType={this.state.entryType}
                            getSystemState={this.getSystemState}
                            EnableDataEntry={this.state.EnableDataEntry}
                            data={machineStates}
                            toggle={this.state.toggle}
                            updateEventMultiple={updateEventMultiple}
                            {...props}
                            equipList={this.state.equipList}
                            handleUpdatechart={this.state.reload}
                            handelupdate={this.handelupdate}
                            updateData={this.state.updateData}
                            handleChartEvent={this.handelEnabledataentry}
                            filterBy={this.state.filterBy}
                            filterObj={this.state.filterObj}
                            user={user}
                            storeDataInLocalStorage={this.storeDataInLocalStorage}
                          />
                        );
                      }}
                    />
                    <Route
                      path="/dashboard/customs"
                      exact
                      render={(props) => (
                        <DashBoardCustom
                          {...props}
                          getCurrentData={(data) =>
                            this.setState({ customDashboardData: data })
                          }
                          equipList={this.state.equipList}
                          filterBy={this.state.filterBy}
                          filterObj={this.state.filterObj}
                          equipmentGroupFilter={this.state.dashboardEquipmentGroups}
                          filterStorageKey="equipGroupFilter_customs"
                          upperViewMode={this.state.dashboardUpperViewMode}
                          user={user}
                        />
                      )}
                    />
                    <Route
                      path="/dashboard/customs/groups"
                      exact
                      render={(props) => (
                        <GroupDashBoardCustom
                          {...props}
                          getCurrentData={(data) =>
                            this.setState({ customDashboardData: data })
                          }
                          equipList={this.state.equipList}
                          filterBy={this.state.filterBy}
                          filterObj={this.state.filterObj}
                          user={user}
                        />
                      )}
                    />
                    <Route
                      path="/dashboard/cardview"
                      exact
                      render={(props) => (
                        <DashBoard
                          {...props}
                          company={this.state.company}
                          equipList={this.state.equipList}
                          user={user}
                          filterBy={this.state.filterBy}
                          filterObj={this.state.filterObj}
                        />
                      )}
                    />
                    <Route
                      path="/dashboard/toggle_custom"
                      exact
                      render={(props) => (
                        <CarouselComponent {...props} components={carouselItems} />
                      )}
                    />
                    <Route
                      path="/dashboard/vg_dashboard"
                      exact
                      render={(props) => (
                        <VG_Dashboard
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          equipmentGroupFilter={this.state.dashboardEquipmentGroups}
                          filterStorageKey="equipGroupFilter_vgDashboard"
                          handleDownloadTableToExcel={this.handleDownloadTableToExcel}
                        />
                      )}
                    />
                    {this.state.equipList.length > 0 && (
                      <Route
                        path="/dashboard/AVGSpmDashboard"
                        exact
                        render={(props) => (
                          <AVGSpmDashboard
                            {...props}
                            equipGroups={this.state.equipGroups}
                            equips={this.state.equipList}
                            handleDownloadTableToExcel={
                              this.handleDownloadTableToExcel
                            }
                          />
                        )}
                      />
                    )}
                    <Route
                      path="/dashboard/dashBoard_dt_&_incident2"
                      exact
                      render={(props) => (
                        <DashBoardDowntimeAndIncident2
                          {...props}
                          getCurrentData={(data) =>
                            this.setState({ customDashboardData: data })
                          }
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          Plant={jwtDecode(auth.getJwt()).Plants}
                        />
                      )}
                    />
                    {this.state.equipList.length > 0 && this?.state?.downtimeReasonList?.length > 0 && (
                      <Route
                        path="/reporting/VG_PresShopReport"
                        exact
                        render={(props) => (
                          <VG_PresShopReport
                            {...props}
                            equipGroups={this.state.equipGroups}
                            reasons={this.state.downtimeReasonList}
                            equips={this.state.equipList}
                            handleDownloadTableToExcel={
                              this.handleDownloadTableToExcel
                            }
                          />
                        )}
                      />
                    )}
                    <Route
                      path="/reporting/daily_spm_report"
                      exact
                      render={(props) => (
                        <DailySPMReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={this.handleDownloadTableToExcel}
                        />
                      )}
                    />

                    <Route
                      path="/reporting/custom_shiftwise_cycles_report"
                      exact
                      render={(props) => (
                        <CustomShiftWiseProduction
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                        />
                      )}
                    />
                    <Route
                      path="/dashboard/groups"
                      exact
                      render={(props) => (
                        <DashboardCarousel
                          {...props}
                          user={user}
                          equipList={this.state.equipList}
                          equipGroups={this.state.equipGroups}
                          filterBy={this.state.filterBy}
                          filterObj={this.state.filterObj}
                          machineStates={machineStates}
                          updateEventMultiple={updateEventMultiple}
                          entryType={this.state.entryType}
                          EnableDataEntry={this.state.EnableDataEntry}
                          stopCountdown={this.stopCountdown}
                          getSystemState={this.getSystemState}
                          handleUpdatechart={this.state.reload}
                          handelupdate={this.handelupdate}
                          updateData={this.state.updateData}
                          handleChartEvent={this.handelEnabledataentry}
                        />
                      )}
                    />
                    <Route
                      path="/dashboard/dashBoard_dt_&_incident"
                      exact
                      render={(props) => (
                        <DashBoardDowntimeAndIncident
                          {...props}
                          getCurrentData={(data) =>
                            this.setState({ customDashboardData: data })
                          }
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          equipmentGroupFilter={this.state.dashboardEquipmentGroups}
                          filterStorageKey="equipGroupFilter_dtIncident"
                        />
                      )}
                    />
                    <Route
                      path="/dashboard/nagata/shopfloor"
                      exact
                      render={(props) => (
                        <DashboardNagata
                          refresh={false}
                          id="Downtime"
                          EntryFrom={"Dashbaord"}
                          company={this.state.company}
                          stopCountdown={this.stopCountdown}
                          entryType={this.state.entryType}
                          getSystemState={this.getSystemState}
                          EnableDataEntry={this.state.EnableDataEntry}
                          data={machineStates}
                          toggle={this.state.toggle}
                          updateEventMultiple={updateEventMultiple}
                          {...props}
                          equipList={this.state.equipList}
                          handleUpdatechart={this.state.reload}
                          handelupdate={this.handelupdate}
                          updateData={this.state.updateData}
                          handleChartEvent={this.handelEnabledataentry}
                          filterBy={this.state.filterBy}
                          filterObj={this.state.filterObj}
                          user={user}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/dashboard/nagata/concept2"
                      exact
                      render={(props) => (
                        <DashboardNagataConcept2
                          refresh={false}
                          id="Downtime"
                          EntryFrom={"Dashbaord"}
                          company={this.state.company}
                          stopCountdown={this.stopCountdown}
                          entryType={this.state.entryType}
                          getSystemState={this.getSystemState}
                          EnableDataEntry={this.state.EnableDataEntry}
                          data={machineStates}
                          toggle={this.state.toggle}
                          updateEventMultiple={updateEventMultiple}
                          {...props}
                          equipList={this.state.equipList}
                          handleUpdatechart={this.state.reload}
                          handelupdate={this.handelupdate}
                          updateData={this.state.updateData}
                          handleChartEvent={this.handelEnabledataentry}
                          filterBy={this.state.filterBy}
                          filterObj={this.state.filterObj}
                          user={user}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/dashboard1"
                      exact
                      render={(props) => (
                        <DashboardNagataConcept2
                          refresh={false}
                          id="Downtime"
                          EntryFrom={"Dashbaord"}
                          company={this.state.company}
                          stopCountdown={this.stopCountdown}
                          entryType={this.state.entryType}
                          getSystemState={this.getSystemState}
                          EnableDataEntry={this.state.EnableDataEntry}
                          data={machineStates}
                          toggle={this.state.toggle}
                          updateEventMultiple={updateEventMultiple}
                          {...props}
                          equipList={this.state.equipList}
                          handleUpdatechart={this.state.reload}
                          handelupdate={this.handelupdate}
                          updateData={this.state.updateData}
                          handleChartEvent={this.handelEnabledataentry}
                          filterBy={this.state.filterBy}
                          filterObj={this.state.filterObj}
                          user={user}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/dashboard2"
                      exact
                      render={(props) => (
                        <Dashboard2
                          refresh={false}
                          id="Downtime"
                          EntryFrom={"Dashbaord"}
                          company={this.state.company}
                          stopCountdown={this.stopCountdown}
                          entryType={this.state.entryType}
                          getSystemState={this.getSystemState}
                          EnableDataEntry={this.state.EnableDataEntry}
                          data={machineStates}
                          toggle={this.state.toggle}
                          updateEventMultiple={updateEventMultiple}
                          {...props}
                          equipList={this.state.equipList}
                          handleUpdatechart={this.state.reload}
                          handelupdate={this.handelupdate}
                          updateData={this.state.updateData}
                          handleChartEvent={this.handelEnabledataentry}
                          filterBy={this.state.filterBy}
                          filterObj={this.state.filterObj}
                          user={user}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/dashboard/operator_per_board"
                      exact
                      render={(props) => (
                        <OperatorPerformanceBoard
                          {...props}
                          equipList={this.state.equipList}
                          user={user}
                          company={this.state.company}

                          filterBy={this.state.filterBy}
                          filterObj={this.state.filterObj}
                          autoScrollObj={this.state.autoScrolOpPerfObj}
                        />
                      )}
                    />
                    <Route
                      path="/dashboard/cxoview"
                      exact
                      render={(props) => <OCXView {...props} user={user}
                        company={this.state.company}

                      />}
                    />
                    <Route
                      path="/dashboard/andon"
                      exact
                      render={(props) => (
                        <AndonDashboard
                          {...props}
                          handleCancel={this.handleCancel}
                          open={this.state.open}
                          equipList={this.state.equipList}
                          user={user}
                          filterBy={this.state.filterBy}
                          filterObj={this.state.filterObj}
                          configObj={this.state.andOnDasboardObj}
                          company={this.state.company}

                          autoScrollObj={this.state.autoScrollObj}
                          array={this.state.andonDashboardData}
                          getData={this.getAndonDashboardData}
                        />
                      )}
                    />
                    <Route
                      path="/dashboard/activity"
                      exact
                      render={(props) => (
                        <HourlyActivityDashboard
                          {...props}
                          filterObj={this.state.sortObj}
                          activityDashboardState={this.state.activityDashboardState}
                          equipList={this.state.equipList}
                          user={user}
                          company={this.state.company}

                          array={this.state.andonDashboardData}
                          getData={this.getAndonDashboardData}
                        />
                      )}
                    />
                    {company.IsCustomerPlanScheduleEnable && <Route
                      path="/setting/customer/schedule"
                      render={(props) => (
                        <CustomerSchedule
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          userGroupData={this.state.customerData}
                          actionStatus={this.state.actionStatus}
                        />
                      )}
                    />}
                    <Route
                      path="/setting/customer/add"
                      render={(props) => (
                        <CustomerMaster
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          userGroupData={this.state.customerData}
                          actionStatus={this.state.actionStatus}
                        />
                      )}
                    />
                    <Route
                      path="/setting/customer/list"
                      render={(props) => (
                        <CustomerTable
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    {/* <Route path='/setting/report' render={props => <ReportSetting {...props} userRights={this.state.userRights} getRightsForAccess={handleUserRightsToVisibleOrNot} handleOnAdd={this.handleOnAdd} onUpdate={this.handleOnUpdate} />} /> */}
                    <Route
                      path="/setting/usergroup/add"
                      render={(props) => (
                        <UserGroup
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="userGroups"
                          userGroupData={this.state.userGroupData}
                          actionStatus={this.state.actionStatus}
                        />
                      )}
                    />
                    <Route
                      path="/setting/usergroup/list"
                      render={(props) => (
                        <UserGroupTable
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="userGroups"
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/userrights/add"
                      render={(props) => (
                        <UserRights
                          {...props}
                          equipList={this.state.equipList}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          user={this.props.user}
                          userRightsData={this.state.userRightsData}
                          actionStatus={this.state.actionStatus}
                          userRightsList={this.state.userRightsList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/userrights/list"
                      render={(props) => (
                        <UserRightTable
                          {...props}
                          equipList={this.state.equipList}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          user={this.props.user}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/user/add"
                      render={(props) => (
                        <User
                          {...props}
                          equipList={this.state.equipList}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          user={this.state.userData}
                          actionStatus={this.state.actionStatus}
                          userList={this.state.userList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/user/list"
                      render={(props) => (
                        <UserTable
                          {...props}
                          user={user}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/employeerole/list"
                      render={(props) => (
                        this.state.company && this.state.company.allowSecondaryEmployees ? (
                          <EmployeeRole
                            {...props}
                            user={user}
                            userRights={this.state.userRights}
                            getRightsForAccess={handleUserRightsToVisibleOrNot}
                            handleOnAdd={this.handleOnAdd}
                            onUpdate={this.handleOnUpdate}
                          />
                        ) : (
                          <div className="text-center mt-5">
                            <h4>Access Denied</h4>
                            <p>Secondary employee features are not enabled for your company.</p>
                          </div>
                        )
                      )}
                    />
                    <Route
                      path="/setting/employee/list"
                      render={(props) => (
                        this.state.company && this.state.company.allowSecondaryEmployees ? (
                          <EmployeeMaster
                            {...props}
                            user={user}
                            userRights={this.state.userRights}
                            getRightsForAccess={handleUserRightsToVisibleOrNot}
                            handleOnAdd={this.handleOnAdd}
                            onUpdate={this.handleOnUpdate}
                          />
                        ) : (
                          <div className="text-center mt-5">
                            <h4>Access Denied</h4>
                            <p>Secondary employee features are not enabled for your company.</p>
                          </div>
                        )
                      )}
                    />
                    <Route
                      path="/setting/equipmentgroup/add"
                      render={(props) => (
                        <EquipmentGroup
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          dataRightsKey="equipmentGroups"
                          equipmentGroupData={this.state.equipmentGroupData}
                          actionStatus={this.state.actionStatus}
                          equipmentGroupList={this.state.equipmentGroupList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/equipmentgroup/list"
                      render={(props) => (
                        <EquipmentGroupTable
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          dataRightsKey="equipmentGroups"
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/equipmenttype/add"
                      render={(props) => (
                        <EquipmentType
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          equipmentTypeData={this.state.equipmentTypeData}
                          actionStatus={this.state.actionStatus}
                          equipmentTypeList={this.state.equipmentTypeList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/equipmenttype/list"
                      render={(props) => (
                        <EquipmentTypeTable
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/equipmentlocation/add"
                      render={(props) => (
                        <EquipmentLocation
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          equipmentLocationData={this.state.equipmentLocationData}
                          actionStatus={this.state.actionStatus}
                          equipmentLocationList={this.state.equipmentLocationList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/equipmentlocation/list"
                      render={(props) => (
                        <EquipmentLocationTable
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />

                    <Route
                      path="/setting/equipmentmodel/add"
                      render={(props) => (
                        <EquipmentModel
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          equipmentModelData={this.state.equipmentModelData}
                          actionStatus={this.state.actionStatus}
                          equipmentModelList={this.state.equipmentModelList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/equipmentmodel/list"
                      render={(props) => (
                        <EquipmentModelTable
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/equipment/add"
                      render={(props) => (
                        <Equipment
                          company={company}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="StaticDataRights"
                          {...props}
                          equipmentData={this.state.equipmentData}
                          actionStatus={this.state.actionStatus}
                          equipmentList={this.state.equipmentList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/equipment/list"
                      render={(props) => (
                        <EquipmentTable
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="StaticDataRights"
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/equipmenthourlyrate/add"
                      render={(props) => (
                        <EquipmentHourlyRate
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="StaticDataRights"
                          {...props}
                          equipmentData={this.state.equipmentData}
                          actionStatus={this.state.actionStatus}
                          equipmentList={this.state.equipmentList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/equipmenthourlyrate/list"
                      render={(props) => (
                        <EquipmentHourlyRateTable
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="StaticDataRights"
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/relay-templates"
                      render={(props) => (
                        <RelayTemplateModule
                          {...props}
                          basePath="/setting/relay-templates"
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                        />
                      )}
                    />
                    <Route
                      path="/setting/conditions"
                      render={(props) => (
                        <ConditionMasterModule
                          {...props}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                        />
                      )}
                    />
                    {company.allowProcessParameter && (
                      <Route
                        path="/setting/process-parameter-config"
                        render={(props) => (
                          <ProcessParameterConfigModule
                            {...props}
                            getRightsForAccess={handleUserRightsToVisibleOrNot}
                          />
                        )}
                      />
                    )}
                    <Route
                      path="/setting/consumablegroup/add"
                      render={(props) => (
                        <ConsumablesGroup
                          {...props}
                          consumableGroupData={this.state.consumableGroupData}
                          consumableGroupList={this.state.consumableGroupList}
                          actionStatus={this.state.actionStatus}
                        />
                      )}
                    />
                    <Route
                      path="/setting/consumablegroup/list"
                      render={(props) => (
                        <ConsumablesGroupTable
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/consumablemaster/add"
                      render={(props) => (
                        <ConsumablesMaster
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          consumableMasterData={this.state.consumableMasterData}
                          consumableMasterList={this.state.consumableMasterList}
                          actionStatus={this.state.actionStatus}
                        />
                      )}
                    />
                    <Route
                      path="/setting/consumablemaster/list"
                      render={(props) => (
                        <ConsumablesMasterTable
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/operatormaster/add"
                      render={(props) => (
                        <OperatorMaster
                          IsOperatorFilterByEqpGrpEnable={!!this.state.company?.IsOperatorFilterByEqpGrpEnable}

                          // IsOperatorFilterByEqpGrpEnable={this.state.company?.IsOperatorFilterByEqpGrpEnable ? this.state.company?.IsOperatorFilterByEqpGrpEnable :false}

                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="StaticDataRights"
                          {...props}
                          equipGroups={this.state.equipGroups}

                          operatorMasterData={this.state.operatorMasterData}
                          operatorMasterList={this.state.operatorMasterList}
                          actionStatus={this.state.actionStatus}
                        />
                      )}
                    />
                    <Route
                      path="/setting/operatormaster/list"
                      render={(props) => (
                        <OperatorMasterTable
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="StaticDataRights"
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/downtimereasongroup/add"
                      render={(props) => (
                        <DownTimeReasonGroup
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="StaticDataRights"
                          {...props}
                          downTimeReasonGroupData={
                            this.state.downTimeReasonGroupData
                          }
                          downTimeReasonGroupList={
                            this.state.downTimeReasonGroupList
                          }
                          actionStatus={this.state.actionStatus}
                        />
                      )}
                    />
                    <Route
                      path="/setting/downtimereasongroup/list"
                      render={(props) => (
                        <DownTimeReasonGroupTable
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="StaticDataRights"
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/downtimereason/add"
                      render={(props) => (
                        <DownTime
                          company={company}
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          downTimeReasonData={this.state.downTimeReasonData}
                          downTimeReasonList={this.state.downTimeReasonList}
                          actionStatus={this.state.actionStatus}
                        />
                      )}
                    />
                    <Route
                      path="/setting/downtimereason/list"
                      render={(props) => (
                        <DownTimeTable
                          company={company}
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/partspercyclereason/add"
                      render={(props) => (
                        <PartsPerCycleReason
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          data={this.state.partsPerCycleReason}
                          actionStatus={this.state.actionStatus}
                          qualityReasonGroupList={this.state.qualityReasonGroupList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/partspercyclereason/list"
                      render={(props) => (
                        <PartsPerCycleReasonTable
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/rejectionstage/add"
                      render={(props) => (
                        <RejectionStatge
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          stageData={this.state.rejectionStage}
                          actionStatus={this.state.actionStatus}
                          qualityReasonGroupList={this.state.qualityReasonGroupList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/rejectionstage/list"
                      render={(props) => (
                        <RejectionStageTable
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/qualityreasongroup/add"
                      render={(props) => (
                        <QualityReasonGroup
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          qualityReasonGroupData={this.state.qualityReasonGroupData}
                          actionStatus={this.state.actionStatus}
                          qualityReasonGroupList={this.state.qualityReasonGroupList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/qualityreasongroup/list"
                      render={(props) => (
                        <QualityReasonGroupTable
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/qualityreason/add"
                      render={(props) => (
                        <QualityReason
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          qualityReasonData={this.state.qualityReasonData}
                          actionStatus={this.state.actionStatus}
                          qualityReasonList={this.state.qualityReasonList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/qualityreason/list"
                      render={(props) => (
                        <QualityReasonTable
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/toolmaster/add"
                      render={(props) => (
                        <ToolMaster
                          company={company}
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          toolMasterData={this.state.toolMasterData}
                          actionStatus={this.state.actionStatus}
                          toolMasterList={this.state.toolMasterList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/toolmaster/list"
                      render={(props) => (
                        <ToolMasterTable
                          company={company}
                          toggle={this.state.toggle}
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/rawmaterial/add"
                      render={(props) => (
                        <RawMaterialMaster
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          rawMaterialData={this.state.rawMaterialData}
                          actionStatus={this.state.actionStatus}
                          rawMaterialList={this.state.rawMaterialList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/rawmaterial/list"
                      render={(props) => (
                        <RawMaterialMasterTable
                          toggle={this.state.toggle}
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/TableMatrix"
                      exact
                      render={(props) => (
                        <ToolxMachine
                          {...props}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          tool={this.state.toolList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/setting/operation/add"
                      render={(props) => (
                        <OperationMaster
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          equipGroups={this.state.equipGroups}

                          dataRightsKey="operationMaster"
                          operationMasterData={this.state.operationMasterData}
                          actionStatus={this.state.actionStatus}
                        />
                      )}
                    />
                    <Route
                      path="/setting/operation/list"
                      render={(props) => (
                        <OperationTable
                          {...props}
                          userRights={this.state.userRights}
                          equipGroups={this.state.equipGroups}

                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="operationMaster"
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/component/add"
                      render={(props) => (
                        <ComponentTest
                          company={company}
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          setNavSelectedState={this.setNavSelectedState}
                          componentData={this.state.componentData}
                          actionStatus={this.state.actionStatus}
                          componentList={this.state.componentList}
                        />
                      )}
                    />
                    <Route
                      path="/setting/component/list"
                      render={(props) => (
                        <ComponentTable
                          company={company}
                          toggle={this.state.toggle}
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/shiftsetting/add"
                      render={(props) => (
                        <ShiftSetting
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          shiftSettingList={this.state.shiftSettingList}
                          shiftSettingData={this.state.shiftSettingData}
                          actionStatus={this.state.actionStatus}
                        />
                      )}
                    />
                    <Route
                      path="/setting/shiftsetting/list"
                      render={(props) => (
                        <ShiftTypeTabs
                          company={this.state.company}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          location={props.location}
                          history={props.history}
                          renderContent={(shiftType) => (
                            <ShiftSettingTable
                              dataRightsKey="StaticDataRights"
                              userRights={this.state.userRights}
                              getRightsForAccess={handleUserRightsToVisibleOrNot}
                              {...props}
                              shiftType={shiftType.key}
                              handleOnAdd={this.handleOnAdd}
                              onUpdate={this.handleOnUpdate}
                            />
                          )}
                        />
                      )}
                    />
                    <Route
                      path="/setting/shiftsetting/manage"
                      render={(props) => (
                        <ShiftSettingMaster
                          dataRightsKey="StaticDataRights"
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          {...props}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/setting/shiftManagement"
                      render={(props) => (
                        <ShiftTypeTabs
                          company={this.state.company}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          location={props.location}
                          history={props.history}
                          labelKey="managementLabel"
                          renderContent={(shiftType) => (
                            <ShiftManagement
                              dataRightsKey="StaticDataRights"
                              userRights={this.state.userRights}
                              getRightsForAccess={handleUserRightsToVisibleOrNot}
                              {...props}
                              shiftType={shiftType.key}
                              company={this.state.company}
                              handleOnAdd={this.handleOnAdd}
                              onUpdate={this.handleOnUpdate}
                            />
                          )}
                        />
                      )}
                    />
                    {/* //////////////////////////Data Entry Routes//////////////////////////////////////////////////////////////////////////// */}
                    <Route
                      path="/dataentry/downtime"
                      exact
                      render={(props) => (
                        <Downtime
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="DynamicDataRights"
                          {...props}
                        />
                      )}
                    />
                    <Route
                      path="/dataentry/custom/view"
                      render={(props) => (
                        <CustomForm1
                          compList={this.state.componentList}
                          userRights={this.state.userRights}
                          equips={this.state.equipList}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="DynamicDataRights"
                          {...props}
                          handleOnUpdate={this.handleDataEntryUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/dataentry/downtime/view"
                      exact
                      render={(props) => (
                        <DowntimeView
                          IsOperatorFilterByEqpGrpEnable={!!this.state.company?.IsOperatorFilterByEqpGrpEnable}
                          IsComponentEquipmentMatrixEnable={!!this.state.company?.IsComponentEquipmentMatrixEnable}
                          company={this.state.company}
                          userRights={this.state.userRights}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          user={user}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="DynamicDataRights"
                          {...props}
                        />
                      )}
                    />
                    <Route
                      path="/dataentry/erp"
                      exact
                      render={(props) => (
                        <ERP
                          company={this.state.company}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/logs"
                      exact
                      render={(props) => (
                        <ErpLogs
                          company={this.state.company}
                        />
                      )}
                    />
                    <Route
                      path="/dataentry/downtime/notification_click/:id/:DateTime"
                      exact
                      render={(props) => (
                        <NotificationClickDowntimeView
                          company={this.state.company}
                          userRights={this.state.userRights}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          user={user}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="DynamicDataRights"
                          {...props}
                        />
                      )}
                    />
                    <Route
                      path="/dataentry/component"
                      exact
                      render={(props) => (
                        <ComponentDataEntry
                          IsOperatorFilterByEqpGrpEnable={!!this.state.company?.IsOperatorFilterByEqpGrpEnable}
                          IsComponentEquipmentMatrixEnable={!!this.state.company?.IsComponentEquipmentMatrixEnable}

                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="DynamicDataRights"
                          {...props}
                          actionStatus={this.state.actionStatus}
                          dataEntryComponentData={this.state.dataEntryComponentData}
                        />
                      )}
                    />
                    <Route
                      path="/dataentry/component/view"
                      render={(props) => (
                        <ComponentView
                          IsOperatorFilterByEqpGrpEnable={!!this.state.company?.IsOperatorFilterByEqpGrpEnable}
                          IsComponentEquipmentMatrixEnable={!!this.state.company?.IsComponentEquipmentMatrixEnable}
                          toggle={this.state.toggle}
                          company={this.state.company}
                          compList={this.state.componentList}
                          userRights={this.state.userRights}
                          equips={this.state.equipList}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="DynamicDataRights"
                          {...props}
                          handleOnUpdate={this.handleDataEntryUpdate}
                        />
                      )}
                    />
                    <Route
                      path="/dataentry/job/table"
                      render={(props) => (
                        <JobEntryTabular
                          company={this.state.company}
                          compList={this.state.componentList}
                          userRights={this.state.userRights}
                          equips={this.state.equipList}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="DynamicDataRights"
                          {...props}
                          handleOnUpdate={this.handleDataEntryUpdate}
                        />
                      )}
                    />

                    <Route
                      path="/dataentry/quality"
                      exact
                      render={(props) => (
                        <Quality
                          toggle={this.state.toggle}
                          company={this.state.company}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="DynamicDataRights"
                          {...props}
                        />
                      )}
                    />
                    <Route
                      path="/dataentry/quality/view"
                      render={(props) => (
                        <QualityView
                          company={this.state.company}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="DynamicDataRights"
                          {...props}
                        />
                      )}
                    />
                    <Route
                      path="/dataentry/employee"
                      exact
                      render={(props) => (
                        this.state.company && this.state.company.allowSecondaryEmployees ? (
                          <EmployeeDataEntry
                            {...props}
                            user={user}
                            company={this.state.company}
                            userRights={this.state.userRights}
                            getRightsForAccess={handleUserRightsToVisibleOrNot}
                            dataRightsKey="DynamicDataRights"
                          />
                        ) : (
                          <div className="text-center mt-5">
                            <h4>Access Denied</h4>
                            <p>Secondary employee features are not enabled for your company.</p>
                          </div>
                        )
                      )}
                    />
                    <Route
                      path="/dataentry/project"
                      exact
                      render={(props) => (
                        <ProjectDataEntry
                          {...props}
                          company={this.state.company}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="DynamicDataRights"
                        />
                      )}
                    />
                    <Route
                      path="/dataentry/project/view"
                      render={(props) => (
                        <ProjectDataEntryView
                          {...props}
                          company={this.state.company}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="DynamicDataRights"
                        />
                      )}
                    />
                    <Route
                      path="/dataentry/consumable"
                      exact
                      render={(props) => (
                        <Consumable
                          {...props}
                          actionStatus={this.state.actionStatus}
                          dataEntryConsumableData={
                            this.state.dataEntryConsumableData
                          }
                        />
                      )}
                    />
                    <Route
                      path="/dataentry/consumable/view"
                      exact
                      render={(props) => (
                        <ConsumableView
                          {...props}
                          handleOnUpdate={this.handleDataEntryUpdate}
                        />
                      )}
                    />

                    <Route
                      path="/dataentry/ERP"
                      render={(props) => (
                        <ERP
                          company={this.state.company}
                          userRights={this.state.userRights}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                        // getRightsForAccess={handleUserRightsToVisibleOrNot}
                        // dataRightsKey="DynamicDataRights"
                        // {...props}
                        />
                      )}
                    />
                    <Route
                      path="/setting/projectplanning"
                      exact
                      render={(props) => (
                        <ProjectPlanning
                          {...props}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="StaticDataRights"
                        />
                      )}
                    />
                    <Route
                      path="/setting/projectplanning/view"
                      render={(props) => (
                        <ProjectPlanningView
                          {...props}
                          company={this.state.company}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="StaticDataRights"
                        />
                      )}
                    />
                    {/* /////////////////////////////////Reproting Routes////////////////////////////////////////////////////////// */}
                    <Route
                      path="/reporting/projectdetails"
                      exact
                      render={(props) => (
                        <ProjectDetails
                          {...props}
                          company={this.state.company}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          dataRightsKey="DynamicDataRights"
                        />
                      )}
                    />
                    <Route
                      path="/reporting/tool_production"
                      exact
                      render={(props) => (
                        <ToolProductionReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          user={user}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/reporting/tool_change"
                      exact
                      render={(props) => (
                        <ToolChangeReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          user={user}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/reporting/weldshop_mis_report"
                      exact
                      render={(props) => (
                        <NagataMISReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          user={user}
                          company={this.state.company}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/reporting/mis_report"
                      exact
                      render={(props) => (
                        <MisReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          user={user}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                        />
                      )}
                    />

                    <Route
                      path="/reporting/press_shop_mis_report"
                      exact
                      render={(props) => (
                        <NagataPressMISReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          user={user}
                          company={this.state.company}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/production_hourly3"
                      exact
                      render={(props) => (
                        <ProductionReportHourly3
                          {...props}
                          equipGroups={this.state.equipGroups}
                          user={user}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/cycle_duration"
                      exact
                      render={(props) => (
                        <CycleDuration
                          {...props}
                          equipGroups={this.state.equipGroups}
                          user={user}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/tool_run"
                      exact
                      render={(props) => (
                        <ToolRun
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/benchmark"
                      exact
                      render={(props) => (
                        <BenchMarkTable
                          {...props}
                          company={this.state.company}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          handleUpdateEquips={this.handleUpdateEquips}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/BenchMarkHistory"
                      exact
                      render={(props) => (
                        <BenchMarkHistory
                          {...props}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          handleUpdateEquips={this.handleUpdateEquips}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/reporting/detailed-production"
                      exact
                      render={(props) => (
                        <DetailedProduction
                          {...props}
                          qualityReason={this.state.qualityReasonList}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/reporting/energy-consumption"
                      exact
                      render={(props) => (
                        <EnergyConsumption
                          {...props}
                          qualityReason={this.state.qualityReasonList}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/detailed-production2"
                      exact
                      render={(props) => (
                        <DetailedProduction2
                          {...props}
                          qualityReason={this.state.qualityReasonList}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/batch_report"
                      exact
                      render={(props) => (
                        <BatchReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/production"
                      exact
                      render={(props) => (
                        <ProductionReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/production_summary"
                      exact
                      render={(props) => (
                        <ProductionSummaryReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/production_hourly2"
                      exact
                      render={(props) => (
                        <ProductionReportHourly2
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          user={user}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/production_hourly"
                      exact
                      render={(props) => (
                        <ProductionReportHourly
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          user={user}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/aew_production_summary"
                      exact
                      render={(props) => (
                        <AewProductionReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          user={user}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/fourm_report"
                      exact
                      render={(props) => (
                        <FourMReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          user={user}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                          generateExcelFile={this.generateExcelFile}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/downtime_analysis"
                      exact
                      render={(props) => (
                        <DowntimeAnalysisCumulative
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/downtime_analysis_machine"
                      exact
                      render={(props) => (
                        <DowntimeAnalysisMachine
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    {/* <Route path='/reporting/operator_performance' render={props => <OperatorPerformance {...props} />} />
              <Route path='/reporting/operator_performance_detailed' render={props => <OperatorPerfDetailed {...props} />} /> */}
                    <Route
                      path="/reporting/jobs_run"
                      exact
                      render={(props) => (
                        <JobRunReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    {/* <Route path='/reporting/quality_analysis' render={props => <QualityReport {...props} />} /> */}
                    <Route
                      path="/reporting/machine_oee"
                      exact
                      render={(props) => (
                        <Machine_OEE
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/premier_machine_oee"
                      exact
                      render={(props) => (
                        <Premier_Machine_OEE
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/availability"
                      exact
                      render={(props) => (
                        <Availability
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/machine_state"
                      exact
                      render={(props) => (
                        <HistoryMachineState
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/first_part"
                      exact
                      render={(props) => (
                        <FirstPartReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/machine_performance_overview"
                      exact
                      render={(props) => (
                        <Performance_Overview
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/machine_performance_detailed"
                      exact
                      render={(props) => (
                        <PerformanceDetailed
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/machine_activity"
                      exact
                      render={(props) => (
                        <MachineActvity
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/job_quality_factor"
                      exact
                      render={(props) => (
                        <QualityReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/operator_performance_overview"
                      exact
                      render={(props) => (
                        <OperatorPerformance
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/operator_performance_detailed"
                      exact
                      render={(props) => (
                        <OperatorPerfDetailed
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}

                        />
                      )}
                      storeDataInLocalStorage={this.storeDataInLocalStorage}
                    />
                    <Route
                      path="/reporting/job_performance"
                      exact
                      render={(props) => (
                        <JobPerformance
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/job_operator_performance"
                      exact
                      render={(props) => (
                        <Job_Operator_Performance
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/availability_trend"
                      exact
                      render={(props) => (
                        <AvailabilityTrend
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/availability_hourly"
                      exact
                      render={(props) => (
                        <AvailabilityReportHourly {...props} user={user} />
                      )}
                    />
                    <Route
                      path="/reporting/cycles_runtime"
                      exact
                      render={(props) => (
                        <CycleRunAndRuntime
                          {...props}
                          equipGroups={this.state.equipGroups}
                          user={user}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/job_oee"
                      exact
                      render={(props) => (
                        <JobOEE
                          {...props}
                          user={user}
                          componentList={this.state.componentList}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/downtime_machine_trend"
                      exact
                      render={(props) => (
                        <DowntimeMachineTrend
                          {...props}
                          user={user}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/downtime_pareto"
                      exact
                      render={(props) => (
                        <DowntimePareto
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/downtime_summary"
                      exact
                      render={(props) => (
                        <DowntimeSummary
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={this.handleDownloadTableToExcel}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/quality_pareto"
                      exact
                      render={(props) => (
                        <QualityPareto
                          {...props}
                          user={user}
                          componentList={this.state.componentList}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    -
                    <Route
                      path="/reporting/machine_state_event"
                      exact
                      render={(props) => (
                        <MachineStateEventLog
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          reasons={this.state.downtimeReasonList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/process_parameters"
                      exact
                      render={(props) => (
                        <ProcessParameter
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/discarded_breakdown"
                      exact
                      render={(props) => (
                        <DiscardedBreakdownReport {...props} user={user} />
                      )}
                    />
                    <Route
                      path="/reporting/down_time_detailed_analysis"
                      exact
                      render={(props) => (
                        <DowntimeDetailedAnalysis
                          {...props}
                          user={user}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/quality_analysis"
                      exact
                      render={(props) => (
                        <QualityAnalysis
                          componentList={this.state.componentList}
                          reasons={this.state.downtimeReasonList}
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/reporting/projectdetails"
                      exact
                      render={(props) => (
                        <ProjectDetails
                          {...props}
                          user={user}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/project_budget_vs_plan"
                      exact
                      render={(props) => (
                        <ProjectBudgetVsPlan
                          {...props}
                          user={user}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/project_overview"
                      exact
                      render={(props) => (
                        <ProjectOverview
                          {...props}
                          user={user}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/quality_satgerejection_report"
                      exact
                      render={(props) => (
                        <QualityRejectionStageReport
                          componentList={this.state.componentList}
                          reasons={this.state.downtimeReasonList}
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/utilization_report"
                      exact
                      render={(props) => (
                        <UtilizationReport
                          componentList={this.state.componentList}
                          reasons={this.state.downtimeReasonList}
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/manpower_wise_report"
                      exact
                      render={(props) => (
                        <TalbrosProductionReport
                          componentList={this.state.componentList}
                          reasons={this.state.downtimeReasonList}
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/production_report2"
                      exact
                      render={(props) => (
                        <Dailyproductionreport
                          componentList={this.state.componentList}
                          reasons={this.state.downtimeReasonList}
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/equipment_wise_report"
                      exact
                      render={(props) => (
                        <EquipmentWiseProductionData
                          componentList={this.state.componentList}
                          reasons={this.state.downtimeReasonList}
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/equipment_wise_report1"
                      exact
                      render={(props) => (
                        <EquipmentWiseProductionData1
                          componentList={this.state.componentList}
                          reasons={this.state.downtimeReasonList}
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/machine_wise_report"
                      exact
                      render={(props) => (
                        <McWiseData
                          componentList={this.state.componentList}
                          reasons={this.state.downtimeReasonList}
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/summary_report"
                      exact
                      render={(props) => (
                        <TalbrosProductionSummary
                          componentList={this.state.componentList}
                          reasons={this.state.downtimeReasonList}
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/qualityreport"
                      render={(props) => (
                        <QualityReport
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          user={user}
                          {...props}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                        />
                      )}
                    />
                    {/* <Route path='/reporting/oee' render={props => <OEEReport {...props} />} />
              <Route path='/reporting/jobrun' render={props => <JobRunReport {...props} />} />
              <Route path='/reporting/availability' render={props => <Availability {...props} />} />
              <Route path='/reporting/performance_bycomponent' render={props => <PerformanceAnalysisByComponent {...props} />} />
              <Route path='/reporting/performance_bymachine' render={props => <PerformanceAnalysisByMachine {...props} />} />
              <Route path='/reporting/operatorperformance' render={props => <OperatorPerformance {...props} />} />
              <Route path='/reporting/downtimeanalysis' render={props => <DowntimeAnalysis {...props} />} />
            */}
                    <Route
                      path="/reporting/loss_report"
                      exact
                      render={(props) => (
                        <LossReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/reporting/units_loss_analysis_report"
                      exact
                      render={(props) => (
                        <ProductionLossReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    {/* Talbros Routes Special Report */}
                    <Route
                      path="/reporting/overall_machine_oee"
                      exact
                      render={(props) => (
                        <OverallMachineOEE
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/overall_month_oee"
                      exact
                      render={(props) => (
                        <OverallMonthOEE
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    {/* Talbros Routes Special Report */}
                    {this.state.equipList.length > 0 && <Route
                      path="/reporting/live_summaryreport1"
                      render={(props) => (
                        <LiveDashBoards
                          {...props}
                          equipList={this.state.equipList}
                          equipGroups={this.state.equipGroups}
                          qualityReason={this.state.qualityReasonList}
                          company={this.state.company}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                          reasons={this.state.downtimeReasonList}
                        />
                      )}
                    />}

                    {this.state.equipList.length > 0 && <Route
                      path="/reporting/avg_summary_report"
                      render={(props) => (
                        <SummaryReportWithoutWeighted
                          {...props}
                          equipList={this.state.equipList}
                          equipGroups={this.state.equipGroups}
                          qualityReason={this.state.qualityReasonList}
                          company={this.state.company}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                          reasons={this.state.downtimeReasonList}
                        />
                      )}
                    />}
                    <Route
                      path="/reporting/production_summary1"
                      render={(props) => (
                        <ProductionSummary
                          {...props}
                          equipList={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          pagetitle={this.pagetitle}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/availability_summary1"
                      render={(props) => (
                        <AvilabilitySummary1
                          {...props}
                          equipList={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          pagetitle={this.pagetitle}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/quality_summary1"
                      render={(props) => (
                        <QualitySummary1
                          {...props}
                          equipList={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          pagetitle={this.pagetitle}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/histogram_report"
                      render={(props) => (
                        <HistogramReport
                          {...props}
                          equipList={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          pagetitle={this.pagetitle}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/production_summary2"
                      render={(props) => (
                        <ComponentSummaryReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          reasons={this.state.downtimeReasonList}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/incident_report1"
                      exact
                      render={(props) => (
                        <IncidentsReport1
                          {...props}
                          user={user}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                          pagetitle={this.pagetitle}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/live_summaryreport2"
                      render={(props) => (
                        <LiveDashBoards2
                          {...props}
                          equipList={this.state.equipList}
                          equipGroups={this.state.equipGroups}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/cavity_loss_reason"
                      render={(props) => (
                        <CavityLossReasonReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          reasons={this.state.downtimeReasonList}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/daily_production_summary"
                      exact
                      render={(props) => (
                        <DailyProductionSummary
                          {...props}
                          user={user}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                          pagetitle={this.pagetitle}
                        />
                      )}
                    />
                    {/* <Route path='/setting/faq' exact render={props => <FAQPage {...props} user={user} reasons={this.state.downtimeReasonList} equipGroups={this.state.equipGroups} equips={this.state.equipList}  fromDateLimit={this.state.fromDateLimit  !== null ? this.state.fromDateLimit :''}  storeDataInLocalStorage={this.storeDataInLocalStorage} pagetitle={this.pagetitle} />} /> */}
                    <Route
                      path="/reporting/day_summary_one_report"
                      exact
                      render={(props) => (
                        <DaySummaryOneReport
                          {...props}
                          user={user}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/availability_rejection_oee_report"
                      exact
                      render={(props) => (
                        <AvailabilityRejectionOEEReport
                          {...props}
                          user={user}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/CycleRunReportDynamic"
                      exact
                      render={(props) => (
                        <CycleRunReportDynamic
                          {...props}
                          equipGroups={this.state.equipGroups}
                          user={user}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/JobCycleTime_DowntimeChart"
                      exact
                      render={(props) => (
                        <JobCycleTime_DowntimeChart
                          {...props}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          user={user}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/PressWellReport"
                      exact
                      render={(props) => (
                        <PressWellReport
                          {...props}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          user={user}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/dashboard/plant-trends"
                      exact
                      render={(props) => (
                        <PlantTrendsDashboard
                          {...props}
                          user={user}
                        />
                      )}
                    />
                    <Route
                      path="/dashboard/plant-live"
                      exact
                      render={(props) => (
                        <PlantLiveStatus
                          {...props}
                          user={user}
                          company={this.state.company}
                        />
                      )}
                    />
                    <Route
                      path="/dashboard/process-parameters"
                      exact
                      render={(props) =>
                        // Opens only when Company Setting → Allow Process Parameter is on.
                        !company || !Object.keys(company).length
                          ? null // company details still loading
                          : company.allowProcessParameter
                          ? (
                            <ProcessParameterDashboard
                              {...props}
                              user={user}
                              company={company}
                              equips={this.state.equipList}
                            />
                          )
                          : <div className="text-center mt-5"><h4>Access Restricted</h4><p>Process Parameter is not enabled for this company. Enable it in Company Setting.</p></div>
                      }
                    />
                    <Route
                      path="/dashboard/equipment-groups"
                      exact
                      render={(props) => (
                        <EquipmentGroupLive
                          {...props}
                          user={user}
                          company={this.state.company}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/loss-analytics"
                      exact
                      render={(props) => (
                        <LossAnalytics
                          {...props}
                          user={user}
                          company={this.state.company}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/analytics/:view?"
                      exact
                      render={(props) => (
                        <AnalyticsSuite
                          {...props}
                          user={user}
                          company={this.state.company}
                        />
                      )}
                    />
                    <Route
                      path="/dashboard/welding_fixture_hourly"
                      exact
                      render={(props) => (
                        <WeldingFixtureDashbaord
                          {...props}
                          equipList={this.state.equipList}
                          user={user}
                          filterBy={this.state.filterBy}
                          filterObj={this.state.filterObj}
                        />
                      )}
                    />
                    {this.state.equipList.length > 0 && (
                      <Route
                        path="/dashboard/HourlyCountdashBoard"
                        exact
                        render={(props) => (
                          <HourlyCountdashBoard
                            {...props}
                            equipGroups={this.state.equipGroups}
                            equips={this.state.equipList}
                            handleDownloadTableToExcel={
                              this.handleDownloadTableToExcel
                            }
                          />
                        )}
                      />
                    )}
                    {this.state.equipList.length > 0 && (
                      <Route
                        path="/dashboard/EquipmentGroupHourlyCount"
                        exact
                        render={(props) => (
                          <EquipmentGroupHourlyCount
                            {...props}
                            equipGroups={this.state.equipGroups}
                            equips={this.state.equipList}
                            handleDownloadTableToExcel={
                              this.handleDownloadTableToExcel
                            }
                          />
                        )}
                      />
                    )}

                    {company.IsCustomerPlanScheduleEnable && (
                      <Route
                        path="/dashboard/customer_plan_dashboard"
                        exact
                        render={(props) => (
                          <CustomerPlanDashboard
                            {...props}
                            equipGroups={this.state.equipGroups}
                            equips={this.state.equipList}
                            handleDownloadTableToExcel={
                              this.handleDownloadTableToExcel
                            }
                          />
                        )}
                      />
                    )}
                    {company.IsCustomerPlanScheduleEnable && (
                      <Route
                        path="/reporting/customer_plan_history_report"
                        exact
                        render={(props) => (
                          <CustomerScheduleHistoryReport
                            {...props}
                            equipGroups={this.state.equipGroups}
                            equips={this.state.equipList}
                            handleDownloadTableToExcel={
                              this.handleDownloadTableToExcel
                            }
                          />
                        )}
                      />
                    )}
                    {this.state.equipList.length > 0 && (
                      <Route
                        path="/dashboard/plan_vs_actual"
                        exact
                        render={(props) => (
                          <PlanVsActual
                            {...props}
                            equipGroups={this.state.equipGroups}
                            equips={this.state.equipList}
                            handleDownloadTableToExcel={
                              this.handleDownloadTableToExcel
                            }
                          />
                        )}
                      />
                    )}
                    {user && user.Plants && user.Plants.length > 1 && (
                      <Route
                        path="/dashboard/plant_plan_vs_actual"
                        exact
                        render={(props) => (
                          <PlantPlanVsActual
                            {...props}
                            equipGroups={this.state.equipGroups}
                            equips={this.state.equipList}
                            handleDownloadTableToExcel={
                              this.handleDownloadTableToExcel
                            }
                          />
                        )}
                      />
                    )}
                    {this.state.equipList.length > 0 && (
                      <Route
                        path="/dashboard/livePerformace"
                        exact
                        render={(props) => (
                          <PressShopMonitoring
                            {...props}
                            user={user}
                            equipGroups={this.state.equipGroups}
                            equips={this.state.equipList}
                            handleDownloadTableToExcel={
                              this.handleDownloadTableToExcel
                            }
                          />
                        )}
                      />
                    )}
                    <Route
                      path="/reporting/DayWiseOEEReport"
                      exact
                      render={(props) => (
                        <DayWiseOEEReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/DayWiseQualityReport"
                      exact
                      render={(props) => (
                        <DayWiseQualityReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/reporting/plan_vs_actual"
                      exact
                      render={(props) => (
                        <PlanVsActualReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/plant_plan_vs_actual"
                      exact
                      render={(props) => (
                        <PlantPlanVsActualReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/LiveOperatorWiseProduction"
                      exact
                      render={(props) => (
                        <LiveOperatorWiseProduction
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/operator_perf_board"
                      exact
                      render={(props) => (
                        <OperatorPerformanceBoardHistory
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/setting/MachineGroupMatrix"
                      exact
                      render={(props) => (
                        <MachineGroupMatrix
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          tool={this.state.toolList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/ComponentWise"
                      exact
                      render={(props) => (
                        <ComponentWise
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          tool={this.state.toolList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/ComponentWise1"
                      exact
                      render={(props) => (
                        <ComponentWise1
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          tool={this.state.toolList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/CycleTimeReport"
                      exact
                      render={(props) => (
                        <CycleTimeReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          tool={this.state.toolList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/Machine_Wise_OEE"
                      exact
                      render={(props) => (
                        <Machine_Wise_OEE
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          tool={this.state.toolList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/setting/TragetMultiplier"
                      exact
                      render={(props) => (
                        <TargetMultiplier
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          tool={this.state.toolList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/reporting/ToolChangeTimeLog"
                      exact
                      render={(props) => (
                        <ToolChangeLog
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          tool={this.state.toolList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExcel
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/reporting/ProductionReport_JRG"
                      exact
                      render={(props) => (
                        <ProductionReport_JRG
                          qualityReason={this.state.qualityReasonList}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExceltext
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />


                    <Route
                      path="/reporting/plant_utilization_report"
                      exact
                      render={(props) => (
                        <PlantUtilizationReport
                          qualityReason={this.state.qualityReasonList}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExceltext
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/reporting/jrg_plant_utilization_report"
                      exact
                      render={(props) => (
                        <JRG_PlantUtilizationReport
                          qualityReason={this.state.qualityReasonList}
                          reasons={this.state.downtimeReasonList}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          handleDownloadTableToExcel={
                            this.handleDownloadTableToExceltext
                          }
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/reporting/mttr_mtbf"
                      exact
                      render={(props) => (
                        <MTTR_MTBF
                          {...props}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          user={user}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/setting/ActionTakenMaster"
                      exact
                      render={(props) => (
                        <ActionTakenMaster
                          {...props}
                          equipGroups={this.state.equipGroups}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/QualityRejectionReport"
                      exact
                      render={(props) => (
                        <QualityRejectionReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                          handleDownloadTableToExcel={this.handleDownloadTableToExcel}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/OperatorEfficiencyReport"
                      exact
                      render={(props) => (
                        <OperatorEfficiencyReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                          handleDownloadTableToExcel={this.handleDownloadTableToExcel}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/PremierOperatorEfficiencyReport"
                      exact
                      render={(props) => (
                        <PremierOperatorEfficiencyReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                          handleDownloadTableToExcel={this.handleDownloadTableToExcel}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/EmployeeReport"
                      exact
                      render={(props) => (
                        <EmployeeReport
                          {...props}
                          equipGroups={this.state.equipGroups}
                          userRights={this.state.userRights}
                          getRightsForAccess={handleUserRightsToVisibleOrNot}
                          handleOnAdd={this.handleOnAdd}
                          onUpdate={this.handleOnUpdate}
                          handleDownloadTableToExcel={this.handleDownloadTableToExcel}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/QualityReport_JRG"
                      exact
                      render={(props) => (
                        <QualityReport_JRG
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/WastageReport"
                      exact
                      render={(props) => (
                        <WastageReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/setting/UserRightsManager"
                      exact
                      render={(props) => (
                        <UserRightsManager
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/Cost_To_Poor_Quality"
                      exact
                      render={(props) => (
                        <Cost_To_Poor_Quality
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          generateExcelFile={this.handleDownloadTableToExcel}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/costingReport"
                      exact
                      render={(props) => (
                        <CostingReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          generateExcelFile={this.handleDownloadTableToExcel}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/performanceLoss"
                      exact
                      render={(props) => (
                        <PerformanceLossReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          generateExcelFile={this.handleDownloadTableToExcel}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/material_consumption"
                      exact
                      render={(props) => (
                        <MaterialConsumptionReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          generateExcelFile={this.handleDownloadTableToExcel}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/material_requirement"
                      exact
                      render={(props) => (
                        <MaterialRequirementReport
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          generateExcelFile={this.handleDownloadTableToExcel}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/Component_Machine_Matrix"
                      exact
                      render={(props) => (
                        <Component_Machine_Matrix
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          component={this.state.componentList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          generateExcelFile={this.handleDownloadTableToExcel}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />
                    <Route
                      path="/reporting/ProductionReport420"
                      exact
                      render={(props) => (
                        <ProductionReport420
                          {...props}
                          user={user}

                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          component={this.state.componentList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          handleDownloadTableToExcel={this.handleDownloadTableToExcel}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    {/* Same endpoint, separate sheets: HPR_report is the JRG production report format (HPRReport.jsx). */}
                    <Route
                      path="/reporting/custom_hourly_report"
                      exact
                      render={(props) => (
                        <CustomHourlyReport
                          {...props}
                          user={user}
                          company={this.state.company}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/reporting/HPR_report"
                      exact
                      render={(props) => (
                        <HPRReport
                          {...props}
                          user={user}
                          company={this.state.company}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route
                      path="/setting/CompanySetting"
                      exact
                      render={(props) => (
                        <CompanySetting
                          {...props}
                          user={user}
                          equipGroups={this.state.equipGroups}
                          equips={this.state.equipList}
                          component={this.state.componentList}
                          fromDateLimit={
                            this.state.fromDateLimit !== null
                              ? this.state.fromDateLimit
                              : ""
                          }
                          company={this.state.company}
                          GetCompanyDetail={this.GetCompanyDetail}
                          handleDownloadTableToExcel={this.handleDownloadTableToExcel}
                          storeDataInLocalStorage={this.storeDataInLocalStorage}
                        />
                      )}
                    />

                    <Route path='/support' exact render={props =>
                      this.handleUserRightsToVisibleOrNot("StaticDataRights", "Support", "read")
                        ? <SupportPage {...props} userRights={this.state.userRights} />
                        : <div className="text-center mt-5"><h4>Access Restricted</h4><p>You do not have permission to access this page. Contact your admin.</p></div>
                    } />

                <Route path='/leafnet-bot/reports' render={props =>
                  !REPORTS_ENABLED
                    ? <Redirect to='/leafnet-bot' />
                    : this.handleUserRightsToVisibleOrNot("StaticDataRights", "LeafnetBot", "read")
                    ? <LeafnetReportsPage key={`reports-${this.state.assistantEpoch || 0}`} {...props} />
                    : <div className="text-center mt-5"><h4>Access Restricted</h4><p>COCO AI Assistant is not enabled for your user. Contact your admin.</p></div>
                } />

                <Route path='/leafnet-bot' exact render={props =>
                  this.handleUserRightsToVisibleOrNot("StaticDataRights", "LeafnetBot", "read")
                    ? <PlantAssistantPage key={`assistant-${this.state.assistantEpoch || 0}`} {...props} />
                    : <div className="text-center mt-5"><h4>Access Restricted</h4><p>COCO AI Assistant is not enabled for your user. Contact your admin.</p></div>
                } />

                <Route path='/analytics/:view?' exact render={props =>
                  this.handleUserRightsToVisibleOrNot("StaticDataRights", "PlantAnalytics", "read")
                    ? <AnalyticsSuite {...props} user={user} company={this.state.company} />
                    : <div className="text-center mt-5"><h4>Access Restricted</h4><p>Plant Analytics is not enabled for your user. Contact your admin.</p></div>
                } />

              </Switch>
              </React.Suspense>
              </RouteErrorBoundary>
            </main>
          </div>
        </div >
        {/* </div>
    )} */}
      </>
    );
  }
}

export default NavBarUser;
